function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSpain({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M.004 0h21v16h-21Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#aa151b",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.004 4h21v8h-21Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#f1bf00",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.047 7.113s-.024 0-.035-.008a.2.2 0 0 1-.043-.03l-.032-.016-.027-.028s-.027-.039-.015-.062c.015-.032.039-.04.062-.051.02-.008.063-.02.063-.02l.05-.015.055-.008.023-.008.036-.004.046-.011.07.003h.208q.073.023.148.04c.024.003.078.007.098.02.027.007.043.022.055.03.011.016.011.028.015.035v.036l-.02.027-.023.031-.035.024s-.023.015-.043.015c-.023 0-.21-.027-.336-.027-.125 0-.32.027-.32.027m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.23 6.848.07.004h.212q.072.022.144.039h.008c.012 0 .027.004.043.004.02.003.04.007.05.015.02.008.036.02.048.027q.007.004.008.008a.02.02 0 0 1 .011.02q.005.001.004.008-.001.004.004.007v.04l-.023.027-.024.031-.035.024h-.004q-.006.003-.012.007a.1.1 0 0 1-.03.008h-.016q-.013-.005-.032-.004h-.008q-.033-.006-.074-.011c-.066-.004-.144-.012-.207-.012-.062 0-.14.008-.207.012l-.082.011q-.012-.001-.023.004h-.008v-.004.004H7.03l-.023-.008a.2.2 0 0 1-.043-.03l-.031-.016-.028-.028v-.004h-.004v-.004l-.011-.015c-.004-.012-.008-.032-.004-.043a.1.1 0 0 1 .031-.035.1.1 0 0 1 .031-.016q-.001-.005.004-.004l.04-.012q.012-.005.019-.004.005-.001.004-.003h.004l.046-.016h.004l.051-.008.024-.008q.001-.005.003-.004h.036Zm-.207.058h-.007c-.004 0-.012.004-.02.004l-.039.012s0 .004-.004.004l-.027.011c-.008.008-.02.02-.028.032-.003.011 0 .027.004.039q.007.011.008.015.005.002.004.004l.027.028.032.015a.2.2 0 0 0 .043.032q.006.004.02.003.003.005.007.004h.004q.001-.005.008-.004.005 0 .023-.003.03-.001.082-.008c.063-.008.145-.016.207-.016.063 0 .14.008.207.016a1 1 0 0 0 .074.008h.012q.017.004.027.003a.03.03 0 0 0 .016.004q.011-.001.027-.007c.004-.004.008-.004.008-.008h.004l.031-.024.028-.027.02-.027V6.98q-.006-.001-.005-.003v-.004q0-.001-.003-.008-.001-.005-.008-.016c-.004 0-.004-.004-.008-.004a.2.2 0 0 0-.043-.027l-.047-.012c-.016-.004-.035-.004-.047-.008h-.004a2 2 0 0 1-.148-.039H7.23l-.043.008-.039.004-.023.008-.055.012zm.024.207v.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.313 6.902c0-.047.023-.082.058-.082.031 0 .055.035.055.082 0 .043-.024.078-.055.078-.035 0-.059-.035-.059-.078m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.336 6.848q-.017.017-.016.054-.001.034.016.055.012.019.035.02.018-.001.035-.02c.008-.016.016-.031.016-.055a.1.1 0 0 0-.016-.054q-.017-.022-.035-.02-.023-.002-.035.02m-.012-.004q.018-.026.047-.028.03.002.047.028a.13.13 0 0 1 .016.058.13.13 0 0 1-.016.059.06.06 0 0 1-.047.023.06.06 0 0 1-.047-.023.1.1 0 0 1-.02-.059q.001-.035.02-.058m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.344 6.902c0-.039.011-.074.027-.074s.027.031.027.074-.011.075-.027.075-.027-.032-.027-.075m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.36 6.852a.17.17 0 0 0 0 .101q0 .011.007.016h.004q.002.001.004-.004.007 0 .008-.012.01-.02.008-.05c0-.02 0-.04-.008-.051q-.001-.011-.008-.016c0-.004-.004-.004-.004-.004h-.004v.004q-.007.005-.008.016m0-.028h.011a.03.03 0 0 1 .016.008q.007.005.008.016a.1.1 0 0 1 .011.054q0 .031-.011.055a.03.03 0 0 1-.008.016.03.03 0 0 1-.016.007q-.011 0-.016-.007a.03.03 0 0 1-.007-.016.2.2 0 0 1-.008-.055q.001-.03.008-.054a.03.03 0 0 1 .007-.016c0-.004.004-.004.004-.008m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.332 6.82c0-.015.016-.03.04-.03.019 0 .038.015.038.03 0 .016-.02.028-.039.028a.04.04 0 0 1-.031-.012.02.02 0 0 1-.012-.02",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.398 6.805v.02h-.062v-.02h.02v-.04h-.028v-.019h.027v-.02h.028v.02h.023v.02h-.023v.039Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.352 6.723h.035v.02h.027v.027h-.027v.03h.02v.028h-.075v-.027h.02V6.77h-.028v-.028h.028Zm.011.011v.016h-.027v.012h.027v.05h-.02v.008h.048v-.008h-.016v-.05h.027V6.75h-.027v-.016Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.426 6.805v.02h-.11v-.02h.04v-.04h-.028v-.019h.027v-.02h.028v.02h.023v.02h-.023v.039h.039",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.352 6.723h.035v.02h.027v.027h-.027v.03h.035v.005h.012v.023h-.125v-.027h.043V6.77h-.028v-.028h.028Zm.07.09h-.047v-.051h.027V6.75h-.027v-.016h-.012v.016h-.027v.012h.027v.05h-.039v.008h.098Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.344 6.805q-.01.006-.008.011c0 .016.016.028.035.028.016 0 .031-.012.031-.024q-.001-.01-.007-.015-.005-.007-.016-.008l.004-.012c.012.004.015.008.023.016a.03.03 0 0 1 .008.02c0 .015-.02.03-.043.03s-.047-.015-.047-.035q0-.011.012-.02c.004-.003.016-.007.023-.01l.004.01a.03.03 0 0 0-.02.009m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.371 7.105h-.207V7.07l-.012-.039-.007-.05c-.06-.055-.106-.094-.125-.083 0-.015.007-.02.02-.027.046-.02.147.031.226.121l.023.024h.164l.02-.024c.078-.09.18-.14.23-.12.008.007.016.01.02.026-.02-.011-.07.028-.125.082l-.012.051-.008.04-.004.034Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.043 6.875a.03.03 0 0 0-.016.016q.008-.001.016.004.011.004.027.015.037.025.078.067v.003l.012.051.012.035v.036h.398l.004-.036.008-.035.012-.05v-.004a1 1 0 0 1 .074-.067q.019-.011.031-.015.005-.005.016-.004-.008-.011-.016-.016a.1.1 0 0 0-.043 0 .1.1 0 0 0-.054.02.5.5 0 0 0-.125.101l-.024.024h-.168l-.023-.024a.4.4 0 0 0-.125-.101.1.1 0 0 0-.055-.02q-.026-.006-.039 0m.23.117a.5.5 0 0 0-.128-.105.2.2 0 0 0-.06-.024.1.1 0 0 0-.05.004h-.004q-.013.01-.015.031v.008l.007-.004c.004-.004.004-.004.012 0l.027.016q.031.025.075.066l.008.047.015.04v.038h.422l.004-.039.008-.039.011-.047a1 1 0 0 1 .07-.066l.028-.016c.008-.004.016-.004.016 0l.011.004-.003-.011a.1.1 0 0 0-.02-.028h-.004a.1.1 0 0 0-.047-.004.3.3 0 0 0-.062.024.4.4 0 0 0-.125.105l-.02.02h-.16Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.066 6.898q-.023-.004-.035 0l-.004-.007a.1.1 0 0 1 .043 0 .2.2 0 0 1 .051.023.4.4 0 0 1 .11.098l-.008.004a.7.7 0 0 0-.11-.094.3.3 0 0 0-.047-.024m.606-.007a.1.1 0 0 1 .047 0l-.008.007q-.013-.004-.031 0a.2.2 0 0 0-.051.024.5.5 0 0 0-.11.094l-.011-.004a.5.5 0 0 1 .113-.098.2.2 0 0 1 .05-.023m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.07 7.176-.023-.031c.082-.024.195-.032.324-.032.121 0 .242.008.324.032l-.027.027-.012.023a1.4 1.4 0 0 0-.285-.023c-.121 0-.23.008-.289.023Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.055 7.145.02.027.01.02c.06-.016.169-.024.286-.024.11 0 .207.004.281.023l.012-.023.02-.023a1.5 1.5 0 0 0-.313-.028c-.125 0-.234.008-.316.028m-.012-.004c.082-.024.2-.032.328-.032.121 0 .242.008.324.032h.008l-.027.035-.016.027h-.004a1.2 1.2 0 0 0-.285-.027c-.121 0-.23.011-.285.027h-.008l-.012-.027c-.007-.008-.015-.02-.027-.028l-.004-.007Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.371 7.258q.127 0 .254-.024c.027-.007.043-.015.04-.023q0-.011-.013-.016a1.4 1.4 0 0 0-.285-.027c-.11 0-.219.012-.281.027-.008 0-.012.008-.016.016 0 .008.016.016.04.023.042.008.156.024.261.024m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.367 7.164c.098 0 .192.008.29.027q.005.004.011.008c0 .004.004.004.004.008a.02.02 0 0 1-.012.02l-.035.011a1.4 1.4 0 0 1-.254.024c-.105 0-.219-.012-.262-.024l-.03-.011q-.015-.008-.016-.016v-.004h.003c0-.004.004-.008.004-.008q.005-.007.016-.008a1.3 1.3 0 0 1 .281-.027m.004.098v-.004Zm.281-.059a1.4 1.4 0 0 0-.285-.031c-.11 0-.219.016-.277.031h-.008q-.005.004-.004.008-.002.001.008.008c.004.004.016.008.027.011a1.7 1.7 0 0 0 .508 0 .1.1 0 0 0 .031-.011c.008-.004.008-.008.008-.008q-.002-.004-.004-.008zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.7 7.105-.028-.015s-.024.012-.05.008c-.032-.004-.044-.032-.044-.032s-.031.02-.062.02c-.024 0-.04-.02-.04-.02s-.03.016-.058.016c-.027 0-.05-.027-.05-.027s-.028.027-.052.03c-.027 0-.05-.019-.05-.019s-.012.02-.04.02a.1.1 0 0 1-.066-.016s-.02.02-.039.032c-.027 0-.055-.016-.055-.016l-.007.016-.012.007.008.012c.207-.039.425-.035.636.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.36 7.05.007-.007.004.008.004.004c.004.004.008.004.012.008.008.007.02.015.031.015a.1.1 0 0 0 .035-.008c.008-.004.012-.004.016-.008h.004l.004-.003.003.003.004.004s.004.004.008.004a.1.1 0 0 0 .024.008h.004q.017.005.035-.008.01-.002.015-.004c0-.003.004-.003.004-.003l.008-.004.004.003v.004c.004.004.004.008.008.012a.1.1 0 0 0 .027.016q.018.001.035-.004.006.001.012-.004h.008l.027.02-.008.023h-.008a1.8 1.8 0 0 0-.632-.004l-.004.004-.012-.02.016-.007.008-.02h.007v.004h.004q.006.002.012.004.013.008.031.004c.008-.004.02-.008.028-.016q.003-.007.007-.008s0-.004.004-.004l.004-.003.004.003q.005-.001.004.004c.004 0 .008.004.016.004.011.004.023.012.043.008q.016 0 .027-.012.005-.002.004-.004.005 0 .004-.003l.004-.004.007.003v.004c.004 0 .008.004.012.004q.013.007.031.008.005.001.016-.004l.012-.011q.012-.001.011-.008c.004 0 .004-.004.004-.004m-.2.024a.01.01 0 0 1-.008.008c-.007.008-.02.016-.03.023a.1.1 0 0 1-.04-.007c-.004 0-.012 0-.012-.004l-.008.011-.007.004.004.008a1.7 1.7 0 0 1 .625.004l.007-.012-.02-.011h-.01q-.02.005-.044.004c-.015 0-.027-.012-.035-.02q-.002-.007-.004-.008a.03.03 0 0 0-.016.008.2.2 0 0 1-.046.008c-.012 0-.024-.008-.032-.012q-.007-.004-.007-.008h-.004q-.006.004-.012.008a.1.1 0 0 1-.043.008.06.06 0 0 1-.04-.016q-.01-.007-.01-.008-.007.001-.013.008c-.003.004-.011.008-.015.012a.1.1 0 0 1-.024.008c-.015 0-.03-.008-.039-.012-.004 0-.007-.004-.007-.004-.004 0-.004.004-.008.004q-.012.011-.035.016a.1.1 0 0 1-.051-.012.03.03 0 0 1-.016-.008m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.371 7.023h.012q-.005.01-.004.02.001.006.008.012.005.011.015.011a.04.04 0 0 0 .02.004q.04 0 .05-.023l.005-.012v.016c.003.015.023.027.05.027a.04.04 0 0 0 .032-.012q.01-.005.011-.023v-.004l.016-.012.008.012c0 .008-.004.012-.004.016 0 .02.023.03.043.03.015 0 .031 0 .039-.01l.008-.009v.012c0 .008.011.02.023.024 0 0 .016 0 .04-.016l.034-.024v.016s-.023.024-.043.035l-.039.008q-.021-.007-.03-.02a.1.1 0 0 1-.032.008c-.024 0-.051-.011-.059-.03-.004.003-.011.01-.02.01q-.016.008-.027.009a.1.1 0 0 1-.054-.02.1.1 0 0 1-.047.012.08.08 0 0 1-.055-.02.1.1 0 0 1-.059.02.1.1 0 0 1-.042-.012c-.016.008-.036.02-.055.02q-.017.001-.027-.004l-.024-.012c-.008.016-.031.023-.059.023q-.018 0-.03-.003-.009.011-.028.02a.1.1 0 0 1-.043-.009.4.4 0 0 1-.04-.035v-.016L7 7.087c.02.016.04.016.04.016.015 0 .019-.016.019-.024v-.012l.007.008q.014.017.04.016c.023 0 .042-.016.042-.031q.006-.007 0-.02l.004-.012.016.012c0 .024.02.04.043.04.027 0 .047-.013.047-.032v-.008l.008.008c.007.016.027.023.046.023.028 0 .051-.015.051-.03-.004-.009-.004-.013-.008-.017Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.148 7.02.028.02c0 .019.015.034.035.034a.1.1 0 0 0 .031-.008.02.02 0 0 0 .012-.02v-.023l.02.02v.004q.01.019.038.02c.024 0 .043-.012.043-.028q0-.006-.003-.012l-.004-.007h.043l-.004.007c0 .004-.004.008 0 .012q-.001.011.004.016.005.007.015.008.008.004.016.003.017 0 .027-.003.011-.008.016-.016l.004-.012h.015v.016c0 .011.02.023.043.023.008 0 .02-.004.028-.008.004-.007.011-.015.011-.023v-.004l.024-.02.012.02v.004q-.005.006-.004.012c0 .015.015.027.035.027a.1.1 0 0 0 .035-.008l.02-.023v.027c0 .008.007.016.015.016h.008q.011 0 .027-.012l.043-.031v.031s-.004 0-.004.004q-.004.001-.007.008a.1.1 0 0 1-.032.023l-.043.008h-.004q-.008-.001-.02-.008-.003-.006-.007-.012-.016.007-.031.008a.08.08 0 0 1-.059-.027c-.008.004-.011.008-.02.012-.007 0-.019.004-.027.004h-.004q-.029-.002-.05-.016a.2.2 0 0 1-.047.008.08.08 0 0 1-.055-.02.1.1 0 0 1-.059.02.1.1 0 0 1-.042-.008.1.1 0 0 1-.055.016q-.016.001-.031-.004c-.004-.004-.012-.004-.016-.008-.012.012-.04.02-.063.02H7.09q-.006.001-.012-.005l-.012.012a.03.03 0 0 1-.02.008A.2.2 0 0 1 7 7.117l-.043-.035v-.031l.047.031q.018.012.023.012h.012q.007.001.008-.004.005-.006.004-.012v-.027l.02.023c.007.008.023.012.034.012q.017-.001.028-.008a.03.03 0 0 0 .008-.02.01.01 0 0 0 0-.015v-.004Zm.622.058h-.004q-.001.006-.008.012-.011.012-.028.02l-.035.007q-.006-.001-.011-.008l-.012-.011-.004-.004-.008.004a.1.1 0 0 1-.027.007c-.024 0-.047-.011-.051-.027l-.004-.008-.008.004a.02.02 0 0 1-.02.012.1.1 0 0 1-.023.008q-.032-.004-.05-.02l-.004-.004-.004.004a.1.1 0 0 1-.043.012.07.07 0 0 1-.051-.02l-.004-.003-.008.003a.07.07 0 0 1-.05.02.07.07 0 0 1-.04-.012V7.07l-.007.004c-.016.008-.036.02-.051.02-.008 0-.02-.004-.027-.004l-.02-.012-.004-.004-.004.004c-.008.016-.031.024-.055.024H7.09q-.006-.002-.012-.004L7.07 7.09v.008l-.011.011q-.005.007-.016.008-.017-.001-.035-.008a.2.2 0 0 1-.04-.03v-.005l.028.016q.017.012.027.012.006.004.012.003h.004v-.003.003a.02.02 0 0 0 .02-.011q.004-.006.003-.012a.1.1 0 0 0 .043.012.1.1 0 0 0 .036-.008.1.1 0 0 0 .015-.027v-.02l.008.004c0 .023.024.039.047.039q.022-.001.039-.008c.008-.008.012-.011.016-.02a.06.06 0 0 0 .046.024c.032 0 .055-.02.055-.039v-.008h.008q-.005.006-.004.012c.004.004.004.012.012.016.004.003.008.011.015.011a.1.1 0 0 0 .024.008.1.1 0 0 0 .035-.008q.011-.006.016-.011c.007.011.027.023.054.023a.06.06 0 0 0 .035-.012c.008-.008.016-.015.016-.027l.008-.008.004.004q-.005.011-.004.016c0 .023.023.039.047.039a.1.1 0 0 0 .043-.012c0 .008.011.02.023.023h.004v-.003.003h.004q.001 0 .008-.003.013 0 .031-.012l.024-.016Zm-.707 0v-.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.371 7.113c-.129 0-.242.008-.324.032l-.012-.008q-.002-.006.008-.012a1.5 1.5 0 0 1 .328-.031c.129 0 .246.011.328.031l.008.008c0 .008-.008.012-.012.008-.082-.02-.199-.032-.328-.032",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.043 7.129c-.004 0-.004.004-.004.004v.004h.008c.082-.02.191-.028.312-.028q.001-.005.008-.004c.13 0 .246.012.328.032H7.7l-.004-.008a1.5 1.5 0 0 0-.324-.031 1.5 1.5 0 0 0-.328.03m.332-.016c0 .004-.004.004-.004.004-.129 0-.242.008-.324.031h-.004l-.012-.007q-.005.001-.004-.004v-.008q.006-.007.012-.008c.082-.02.2-.031.332-.031.129 0 .246.012.328.031h.004l.008.012q-.001.012-.008.012-.006.004-.012 0a1.4 1.4 0 0 0-.316-.032m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.246 7.148q.001-.016.02-.015c.007 0 .02.004.02.015 0 .004-.013.012-.024.012s-.016-.008-.016-.012m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.258 7.14q-.005.002-.004.008v.004q.004.002.008.004c.011 0 .015-.008.015-.008 0-.007-.007-.011-.011-.011q-.007-.001-.008.004m-.012-.007q.01-.007.02-.008c.015 0 .023.012.023.023 0 .008-.012.016-.027.016q-.011-.002-.016-.004-.005-.006-.004-.012-.001-.01.004-.015m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.371 7.148H7.32q-.002-.004-.004-.003V7.14q0-.007.012-.008h.082q.004-.005.008-.004.002.005.004.004s.004 0 .004.004v.008q-.002.004-.004.003s-.004 0-.004.004q-.004.001-.008-.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.414 7.137h-.09v.008h.098v-.008h-.008m-.004-.012h.008c.004 0 .004.004.008.004s.004.004.004.004q.005.004.004.008.001.004-.004.007.001.002-.004.004c-.004 0-.004.004-.008.004h-.09q-.001.001-.008-.004h-.004q-.004-.004-.003-.007l-.004-.004q0-.007.007-.008c0-.004.008-.008.012-.008Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.168 7.164h-.027c-.008 0-.016 0-.016-.008v-.004q.004-.005.008-.004l.027-.003.031-.008q.016 0 .02.011 0 .006-.012.012h-.035",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#058e6e",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.191 7.133q.011-.001.016.004.007.001.008.008v.003q.001.007-.004.008-.006.004-.012.008h-.031v.004h-.043q-.007-.006-.008-.012-.001-.004.004-.008.001-.003.008-.007h.031Zm-.027.023h.031q.004-.005.008-.004v-.004c0-.003-.004-.003-.004-.003l-.004-.004-.035.007-.027.004h-.004v.004s0 .004.004.004h.004v-.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.05 7.18.013-.016h.027l-.016.02Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.059 7.156.043.004-.024.031-.039-.011Zm.007.012-.007.008.011.004.012-.012Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.457 7.148c0-.011.008-.015.016-.015q.018 0 .02.015c0 .004-.009.012-.02.012s-.016-.008-.016-.012m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.473 7.137c-.004 0-.012.004-.012.011q-.001.002.004.004.001.002.008.004c.007 0 .015-.008.015-.008q-.002-.006-.004-.007-.006-.005-.011-.004m-.024.011c0-.011.012-.023.024-.023a.03.03 0 0 1 .02.008q.006.005.007.015c0 .008-.012.016-.027.016q-.013-.002-.02-.004-.005-.006-.004-.012m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.57 7.164h.032c.007 0 .015 0 .015-.008 0-.004-.004-.004-.004-.004q-.002-.005-.004-.004l-.035-.003-.027-.008q-.011 0-.016.011 0 .006.012.012h.027",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#058e6e",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.531 7.137q.005-.005.016-.004l.027.008h.035q.007.004.008.007c.004.004.004.004.004.008q-.001.006-.008.012H7.57v-.004h-.03c-.005-.004-.009-.004-.013-.008q-.005-.001-.004-.008v-.003c.004-.004.004-.008.008-.008m.004.011q-.001.002.004.004l.004.004h.062l.004.004v-.008h-.004l-.03-.004-.028-.007c-.004 0-.004.004-.008.004zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.684 7.18-.008-.016h-.028l.012.016h.031",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.637 7.156h.043l.011.02v.011h-.035Zm.043.02-.008-.008H7.66l.004.008Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.371 7.238c-.105 0-.2-.008-.27-.023q.135-.025.27-.02.153.001.266.02a1.3 1.3 0 0 1-.266.023m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.129 7.215a1.4 1.4 0 0 0 .48 0 2 2 0 0 0-.238-.016q-.124-.001-.242.016m.242-.027q-.135 0-.27.023-.004.002-.003.004-.001.005.004.004c.07.015.164.023.27.023q.151 0 .265-.023.005.001.004-.004s0-.004-.004-.004a2 2 0 0 0-.266-.024m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.691 7.07c.004-.008 0-.015 0-.015-.011 0-.02 0-.023.008 0 .007 0 .011.008.015.004 0 .015-.004.015-.008m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.688 7.05h.007v.005h-.004.004v.004q.006.005 0 .011a.01.01 0 0 1-.008.008q-.005.005-.011.004-.012-.001-.012-.008V7.06q.006-.004.012-.008zm-.004.013h-.008v.007s0 .004.004.004V7.07h.004v-.007m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.488 7.04c0-.009 0-.013-.008-.017q-.01.002-.011.016-.002.006.008.012c.003 0 .011-.008.011-.012m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.465 7.027q.005-.006.015-.007h.004q.007.003.008.007l.004.008v.004q-.001.006-.008.012s-.004 0-.004.004h-.011q-.007-.004-.008-.008-.005-.007-.004-.008.002-.006.004-.012m.012.004q-.002.001-.004.008s0 .004.004.004h.003l.004-.004c0-.004-.004-.008-.004-.008zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25 7.04q-.002-.012.008-.017.012.002.012.016c0 .004 0 .008-.008.012Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.258 7.02q.011 0 .015.007.005.006.004.012v.008l-.011.008h-.004l-.016-.016v-.012q0-.004.012-.007m.004.011h-.004v.004l.008.008v-.004q.001-.007-.004-.008m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05 7.07q-.004-.013.005-.015c.004 0 .011 0 .015.008 0 .007 0 .011-.008.015-.003 0-.011-.004-.011-.008m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.055 7.063v.007h.004q0 .005.003.004v-.012zm0-.012c.004 0 .015 0 .02.008l.003.003q.001.006-.004.012a.01.01 0 0 1-.008.008h-.003q-.006.001-.012-.004a.01.01 0 0 1-.008-.008V7.06s0-.004.004-.004c0 0 .004-.004.008-.004m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.371 6.95-.039.015.031.043.008.008.008-.008.027-.043-.039-.016",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.367 6.945.047.02-.031.047-.012.011-.016-.011-.03-.047Zm0 .012-.027.012.027.039h.004l.027-.04Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.293 7.016.016.02.054-.013.008-.007-.008-.008-.054-.012Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.305 6.992.058.012.016.012-.016.011-.058.012-.02-.023Zm.008.012-.012.012.011.011.047-.007v-.008Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.45 7.016-.02.02-.051-.013-.008-.007.004-.008.055-.012Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.434 6.992.02.024-.02.023-.059-.012-.012-.011.008-.012Zm-.055.02v.004l.004.004.047.007.011-.011-.011-.012Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.137 6.969-.032.02.04.034.007.004.008-.004.012-.046-.04-.008",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.133 6.965.047.012-.012.046-.016.012-.011-.008-.043-.039Zm.004.012-.02.011.035.035.004-.003.008-.04Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.074 7.04.02.015.054-.02v-.012h-.062Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.082 7.016h.074v.023l-.062.024-.028-.02Zm.008.011-.008.012.016.012.043-.02v-.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.23 7.02-.011.02-.059-.005-.008-.008.004-.004L7.211 7Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.21 6.992.028.028-.015.023-.067-.004-.011-.012.007-.007Zm-.05.031v.004l.004.004h.05l.009-.011-.016-.012Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.016 7.047v.023h-.07v-.008l.046-.03Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.992 7.023.031.02v.031l-.066.004h-.016v-.02Zm0 .016-.039.027h.004l.055-.003V7.05Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.133 7.031q.001-.018.02-.02c.011 0 .019.009.019.016q.001.006-.004.012-.008.005-.016.004-.007.001-.015-.004-.005-.006-.004-.012",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.137 7.027q.002.007.004.008.006.005.011.004.006.001.012-.004s.004-.004.004-.008-.004-.004-.004-.007q-.006-.002-.012-.004c-.004 0-.007.004-.011.004 0 .003-.004.003-.004.007m-.012.004v-.004q.001-.005.008-.011a.03.03 0 0 1 .02-.008q.012-.001.019.004a.03.03 0 0 1 .008.015q-.001.011-.008.016t-.02.004q-.011.001-.02-.004-.006-.006-.007-.012m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.602 6.969.03.02-.038.034-.008.004-.008-.004-.012-.046.043-.008",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.574 6.98.012.04.004.003V7.02l.035-.032-.023-.011Zm.031-.015-.046.012.015.046.012.012.012-.008.043-.039-.032-.023Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.664 7.04-.023.015-.051-.02-.004-.008.008-.004h.058Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.594 7.016h.062l.016.027-.031.02-.055-.024-.008-.012Zm.004.011h-.004l.004.004.043.02.015-.012-.008-.012Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.508 7.02.012.02.058-.005.008-.008-.004-.004L7.532 7Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.527 6.992.059.028.008.007-.012.012-.062.004-.02-.023Zm.004.016-.015.012.007.011h.051l.004-.004v-.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.715 7.047v.023h.07v-.008l-.047-.03Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.738 7.023.051.036v.02h-.016l-.066-.005v-.031Zm-.02.028v.011l.06.004-.04-.027Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.344 7.016q-.001-.004.004-.008l.004-.004q.006-.005.007-.004h.012c.012 0 .02.008.02.016a.01.01 0 0 1-.008.007q-.006.005-.012.004-.011.001-.016-.004-.003 0-.007-.007",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.367 7.004h-.004c-.004 0-.004 0-.008.004 0 0-.003 0-.003.004h.003v.004l.004.004q.006.004.012.003c.004 0 .004 0 .008-.003q.005-.002.004-.004.001-.007-.004-.008-.001-.002-.008-.004Zm.004-.008H7.36q-.006-.001-.011.004c-.004 0-.004.004-.008.008v.012h.004q.004.006.008.007.008.005.02.004.006.001.015-.004.007-.005.008-.011.001-.008-.004-.016c-.008-.004-.012-.004-.02-.004m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.566 7.031v-.008l.004-.003q.004-.005.008-.004.007-.005.008-.004.011.002.016.004.006.006.007.011-.001.006-.007.012-.005.005-.016.004-.006.001-.012-.004-.007-.006-.008-.012",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.586 7.016s-.004 0-.004.004h-.008v.007q-.001.007.004.008.001.005.008.004.006.001.012-.004.005-.001.004-.008.001-.004-.004-.007-.006-.002-.012-.004m-.024.015H7.56q0-.004.003-.008-.001-.006.004-.007l.008-.008h.012v.004-.004a.03.03 0 0 1 .02.008c.003 0 .007.007.007.011q-.001.011-.008.016-.005.005-.02.004c-.007 0-.01 0-.019-.004zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.938 7.07-.028-.023-.027-.008s.012-.012.023-.012l.02.008v-.008s.011 0 .015.012v.031",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.926 7.023v.004zh.004c.004 0 .004 0 .008.004q.005 0 .011.012v.04h-.011l-.032-.028-.035-.012.008-.004v-.004q.004.001.008-.004c.004 0 .011-.004.02-.004l.015.004v-.004Zm.008.012v.008l-.028-.012c-.004 0-.008.004-.011.004l.02.008.022.02v-.02q-.002-.007-.003-.008m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.938 7.063.027.003q.012.008 0 .016c-.008.004-.012.004-.02 0q-.012-.011-.008-.016",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.934 7.059.03.003h.005q.007.006.008.012 0 .006-.012.012-.006.002-.012.004c-.004 0-.008-.004-.012-.004q-.006-.006-.007-.012-.006-.006 0-.011Zm.011.007v.004q.001.004.008.008h.008l.004-.004s0-.004-.004-.004Zm0 .004",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.793 7.07.027-.023.028-.008s-.012-.012-.024-.012q-.006-.001-.011.004-.004-.001-.008.004v-.008s-.012 0-.016.012v.024Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.824 7.023q.013.002.02.004l.008.004v.004h.003l.004.004-.035.012-.035.031-.008-.02V7.04q.006-.012.012-.012.007-.005.008-.004h.004v.004-.004h.019m-.027.012q.001.001-.004.008v.02l.023-.02.02-.008q-.006-.002-.012-.004-.004-.001-.008.004-.003-.001-.007.004l-.012.008Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.793 7.063-.02.003q-.017.008-.011.016h.027q.011-.011.004-.016",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.797 7.059v.003c.008.008.004.016-.004.024h-.035c-.004-.004-.004-.012 0-.012q.001-.006.008-.011h.004Zm-.012.007-.012.004q-.001.004-.003.008h.015l.004-.008Zm-.015.012",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.902 7.438h.938V7.25h-.938Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.895 7.242h.953v.203h-.953Zm.015.016v.172h.922v-.172Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 7.563.02-.004h.718c-.023-.004-.039-.02-.039-.04 0-.019.02-.039.04-.042h-.72q-.006.004-.019 0 .042.012.043.043c0 .02-.02.035-.043.039",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.746 7.473q.004.006-.004.007c-.008.004-.02.008-.023.016q-.012.012-.012.024 0 .023.035.035.005.002.004.004a.01.01 0 0 1-.008.007h-.715l-.02.004q-.006.001-.007-.004-.005-.002-.004-.003v-.004l.004-.004c.024-.008.04-.02.04-.035q0-.012-.013-.024A.1.1 0 0 0 7 7.484q-.01-.001-.008-.007.001-.005.008-.004h.719q.008-.002.015-.004.012-.001.012.004m-.039.011h-.676c.004 0 .004.004.008.004q.012.016.012.032-.001.017-.02.035h.68c-.016-.012-.02-.024-.02-.035q0-.019.012-.032.005-.002.004-.004m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.016 7.559h.707c.02 0 .039.011.039.027 0 .012-.02.023-.04.023h-.706c-.024 0-.043-.011-.043-.023 0-.016.02-.027.039-.027",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.988 7.57q-.007.005-.008.016.001.006.008.012.014.005.028.004h.707q.01.001.023-.004c.008-.004.008-.008.008-.012q-.001-.011-.008-.016-.012-.005-.023-.004h-.711Q7 7.565 6.988 7.57m-.008-.008q.013-.009.032-.007h.71c.012 0 .024 0 .032.008q.019.005.02.023-.001.013-.02.02a.04.04 0 0 1-.031.011h-.707c-.012 0-.028-.004-.036-.012-.007-.003-.015-.011-.015-.02q0-.016.015-.022m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.016 7.438h.707c.02 0 .039.007.039.019s-.02.02-.04.02h-.706c-.024 0-.04-.008-.04-.02s.016-.023.04-.023",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.992 7.445q-.007.006-.008.012.001.006.008.012c.004 0 .016.004.024.004h.707q.01-.001.023-.008c.008 0 .008-.004.008-.008s0-.008-.008-.008c-.004-.004-.016-.004-.023-.004h-.715v-.004c-.008 0-.012.004-.016.004m.031-.015h-.007c-.012 0-.024 0-.032.008q-.016.006-.015.019 0 .013.015.02.013.006.032.007h.707a.1.1 0 0 0 .03-.007q.02-.007.02-.02 0-.016-.02-.02a.1.1 0 0 0-.03-.007Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.027 10.582a.5.5 0 0 1-.164-.027.5.5 0 0 0-.164-.028.5.5 0 0 0-.164.028.454.454 0 0 1-.328 0 .48.48 0 0 0-.324 0 .5.5 0 0 1-.164.03v.075a.5.5 0 0 0 .164-.031.45.45 0 0 1 .324.004c.05.015.106.027.164.027a.6.6 0 0 0 .164-.027.45.45 0 0 1 .328 0q.077.028.164.027Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#005bbf",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.7 10.523a.4.4 0 0 1 .167.024q.072.028.16.027h.008v.09h-.008a.4.4 0 0 1-.168-.027.5.5 0 0 0-.32 0 .5.5 0 0 1-.168.027.5.5 0 0 1-.168-.027.511.511 0 0 0-.316-.004.5.5 0 0 1-.168.031H6.71v-.086h.008a.4.4 0 0 0 .16-.031.5.5 0 0 1 .164-.024.5.5 0 0 1 .168.024.42.42 0 0 0 .32 0 .5.5 0 0 1 .168-.024m.16.036a.4.4 0 0 0-.16-.024.5.5 0 0 0-.16.024.475.475 0 0 1-.336 0 .4.4 0 0 0-.161-.024.5.5 0 0 0-.156.024.4.4 0 0 1-.16.03v.063c.05 0 .105-.011.152-.03a.5.5 0 0 1 .168-.024c.055 0 .113.007.164.027q.071.028.16.027.084.002.16-.027a.52.52 0 0 1 .336 0q.07.028.153.027v-.066a.4.4 0 0 1-.16-.027m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.027 10.656a.6.6 0 0 1-.164-.023.5.5 0 0 0-.164-.028.5.5 0 0 0-.164.028.6.6 0 0 1-.164.027.5.5 0 0 1-.164-.031.48.48 0 0 0-.324.004.6.6 0 0 1-.164.027v.074a.5.5 0 0 0 .164-.027.5.5 0 0 1 .164-.027q.084 0 .16.027a.45.45 0 0 0 .328 0 .47.47 0 0 1 .328.004q.077.025.164.027Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ccc",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.043 10.598a.5.5 0 0 1 .168.023q.071.03.16.031.084.002.16-.027a.5.5 0 0 1 .168-.023.4.4 0 0 1 .168.023q.072.03.16.023h.008v.094h-.008a.5.5 0 0 1-.168-.027.511.511 0 0 0-.32-.004.5.5 0 0 1-.168.031.4.4 0 0 1-.168-.031.52.52 0 0 0-.316 0 .5.5 0 0 1-.168.031H6.71v-.09h.008c.054 0 .11-.007.16-.027a.4.4 0 0 1 .164-.027m.16.035a.6.6 0 0 0-.16-.024.4.4 0 0 0-.156.028.5.5 0 0 1-.16.027v.063c.05 0 .105-.008.152-.028a.595.595 0 0 1 .332 0 .42.42 0 0 0 .32 0 .5.5 0 0 1 .168-.023q.088 0 .168.027.07.028.153.027v-.066a.4.4 0 0 1-.16-.027.4.4 0 0 0-.16-.024.5.5 0 0 0-.16.024.5.5 0 0 1-.337-.004m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.027 10.738a.5.5 0 0 1-.164-.031.48.48 0 0 0-.328.004.6.6 0 0 1-.164.027.5.5 0 0 1-.164-.031.48.48 0 0 0-.324 0 .5.5 0 0 1-.164.031v.075a.4.4 0 0 0 .164-.028.5.5 0 0 1 .164-.027q.084 0 .16.027.076.028.164.027a.5.5 0 0 0 .164-.027.515.515 0 0 1 .328 0c.04.02.098.031.164.031v-.082",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#005bbf",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.7 10.676a.5.5 0 0 1 .167.023q.072.03.16.031v.004h.008v.086h-.008a.4.4 0 0 1-.168-.03.5.5 0 0 0-.16-.024.5.5 0 0 0-.16.023.475.475 0 0 1-.336 0 .52.52 0 0 0-.316 0 .4.4 0 0 1-.168.031H6.71v-.09h.008a.5.5 0 0 0 .16-.03.6.6 0 0 1 .164-.024.5.5 0 0 1 .168.023q.071.03.16.031.084.002.16-.027c.051-.02.11-.027.168-.027m.32.066a.4.4 0 0 1-.16-.031.6.6 0 0 0-.16-.024.4.4 0 0 0-.16.028.4.4 0 0 1-.169.027.4.4 0 0 1-.168-.031.55.55 0 0 0-.316 0 .5.5 0 0 1-.16.031v.063a.35.35 0 0 0 .152-.028.595.595 0 0 1 .332 0 .42.42 0 0 0 .32 0 .5.5 0 0 1 .168-.023c.063 0 .125.008.168.023.035.02.09.032.153.032Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.027 10.89a.5.5 0 0 1-.164-.03.6.6 0 0 0-.164-.024.5.5 0 0 0-.164.027.47.47 0 0 1-.328-.004.6.6 0 0 0-.164-.023.5.5 0 0 0-.16.027.5.5 0 0 1-.164.028v-.079a.5.5 0 0 0 .164-.027.5.5 0 0 1 .164-.027q.084 0 .16.027c.04.02.098.031.164.031a.5.5 0 0 0 .164-.03.5.5 0 0 1 .164-.028q.083 0 .164.027c.04.02.098.031.164.031Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ccc",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.887 10.79a.6.6 0 0 1-.16.03v.063c.05 0 .105-.008.152-.028a.6.6 0 0 1 .164-.023.4.4 0 0 1 .164.023h.004q.071.029.16.028a.4.4 0 0 0 .16-.028.5.5 0 0 1 .168-.023.4.4 0 0 1 .164.023h.004a.5.5 0 0 0 .153.028v-.063a.4.4 0 0 1-.16-.03.55.55 0 0 0-.32 0 .5.5 0 0 1-.169.03.4.4 0 0 1-.168-.03.54.54 0 0 0-.316 0m.16-.036a.5.5 0 0 0-.168.023.5.5 0 0 1-.16.028H6.71v.093h.008a.5.5 0 0 0 .168-.03.5.5 0 0 1 .156-.024.4.4 0 0 1 .16.02c.05.023.11.034.168.034a.5.5 0 0 0 .168-.03.5.5 0 0 1 .16-.024.4.4 0 0 1 .16.02c.051.023.11.034.168.034h.008v-.09h-.008a.4.4 0 0 1-.16-.03.5.5 0 0 0-.168-.024.5.5 0 0 0-.168.023.5.5 0 0 1-.16.032.4.4 0 0 1-.16-.032.6.6 0 0 0-.164-.023m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.027 10.969a.5.5 0 0 1-.164-.031.4.4 0 0 0-.164-.024.4.4 0 0 0-.164.027.5.5 0 0 1-.164.024.5.5 0 0 1-.164-.027.4.4 0 0 0-.164-.024.4.4 0 0 0-.16.024.4.4 0 0 1-.164.03v-.077a.4.4 0 0 0 .164-.032.56.56 0 0 1 .324.004q.076.029.164.028a.5.5 0 0 0 .164-.028.5.5 0 0 1 .164-.027q.083 0 .164.027.077.029.164.028Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#005bbf",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.887 10.863a.5.5 0 0 1-.16.035v.063a.4.4 0 0 0 .152-.027.504.504 0 0 1 .332 0 .5.5 0 0 0 .16.027q.084 0 .16-.027a.504.504 0 0 1 .336 0 .5.5 0 0 0 .153.027v-.063a.5.5 0 0 1-.16-.03.55.55 0 0 0-.32 0 .475.475 0 0 1-.336 0 .5.5 0 0 0-.157-.024.4.4 0 0 0-.16.02m.16-.031a.4.4 0 0 0-.168.023.5.5 0 0 1-.16.028H6.71v.094h.008a.4.4 0 0 0 .168-.036.548.548 0 0 1 .316 0 .504.504 0 0 0 .336.004.5.5 0 0 1 .32-.004c.051.024.11.036.168.036h.008v-.094h-.008a.4.4 0 0 1-.16-.028.5.5 0 0 0-.168-.023.5.5 0 0 0-.168.023.4.4 0 0 1-.16.028.4.4 0 0 1-.16-.028.6.6 0 0 0-.164-.023m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 10.266.008.02c0 .046-.051.081-.121.081h.968c-.066 0-.12-.035-.12-.082l.003-.02h-.02Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.746 10.262v.004l-.004.02c0 .042.051.077.113.077.004 0 .008.004.008.004a.01.01 0 0 1-.008.008h-.968a.01.01 0 0 1-.008-.008s.004-.004.008-.004c.062 0 .113-.035.113-.078l-.008-.015v-.008c.004 0 .004-.004.008-.004h.719c.008.004.011.004.02 0q0-.001.007.004m-.793.101h.836c-.039-.015-.062-.047-.062-.078l.003-.012h-.718l.004.008v.004c0 .031-.024.063-.063.078m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.016 10.219h.707c.02 0 .039.008.039.023 0 .016-.02.024-.04.024h-.706c-.024 0-.043-.008-.043-.024 0-.015.02-.027.039-.027",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.988 10.227a.03.03 0 0 0-.008.015q.001.006.008.012.014.005.028.004h.707q.01.001.023-.004.007-.006.008-.012c0-.004 0-.008-.008-.012q-.012-.004-.023-.003h-.711l-.004-.004c-.004 0-.012.004-.02.004m-.008-.008a.1.1 0 0 1 .032-.008h.71q.019.001.032.008.019.005.02.023-.001.012-.02.024a.1.1 0 0 1-.031.007h-.707q-.018 0-.036-.007-.016-.012-.015-.024 0-.018.015-.023m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.895 10.555h.953v-.188h-.953Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.887 10.363h.972v.2h-.972Zm.015.012v.176h.938v-.176Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.813 9.555c-.09.043-.157.086-.145.11 0 .015.031.03.078.054.066.035.106.101.074.129q.042-.028.067-.067A.14.14 0 0 0 6.91 9.7a.14.14 0 0 0-.023-.078.3.3 0 0 0-.07-.066",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.809 9.55h.011q.046.028.075.067a.16.16 0 0 1 0 .168.2.2 0 0 1-.07.067l-.013-.008q.024-.019 0-.055a.2.2 0 0 0-.07-.066l-.027-.012-.031-.02c-.012-.007-.024-.015-.024-.027q-.004-.012.004-.023.013-.017.031-.028a.6.6 0 0 1 .114-.062m.003.012a.5.5 0 0 0-.132.083q-.005.01-.004.015v.004q.001.007.02.02.012.008.03.015.012.005.024.016a.2.2 0 0 1 .078.066.1.1 0 0 1 .012.043.1.1 0 0 0 .039-.047.14.14 0 0 0 0-.156.2.2 0 0 0-.066-.059m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.027 10.188h.684V7.637h-.684Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ccc",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.02 7.633h.699v2.562h-.7Zm.02.015v2.532h.464V7.648Zm.48 0v2.532h.066V7.648Zm.082 0v2.532h.101V7.648Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.41 8.594a2.7 2.7 0 0 0-.695-.094c-.11 0-.219.012-.328.023-.407.055-.719.176-.696.282v.004l-.148-.27c-.031-.113.312-.25.77-.309q.197-.023.402-.023c.285 0 .539.027.691.07v.313",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.715 8.21q-.205 0-.402.028a2.4 2.4 0 0 0-.563.13.7.7 0 0 0-.16.085c-.031.031-.047.059-.04.082l.134.242q.006-.03.043-.058a.6.6 0 0 1 .148-.078c.125-.051.305-.094.508-.121a3 3 0 0 1 .332-.028c.234.004.465.035.683.09v-.3a2.8 2.8 0 0 0-.683-.071m.7.38-.005.012a2.6 2.6 0 0 0-.695-.094q-.165 0-.328.023c-.203.028-.38.07-.504.121a.6.6 0 0 0-.145.075q-.046.04-.039.074v.008q.001.007-.004.007-.006.001-.011-.004l-.149-.273h-.004c-.008-.031.012-.062.047-.094a.6.6 0 0 1 .164-.086c.14-.058.34-.105.57-.132q.199-.029.403-.028c.285 0 .543.028.695.074q.005.002.004.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.027 8.91c-.191-.012-.316-.047-.336-.11-.011-.046.055-.1.164-.148.055.004.114.012.172.012v.25",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.855 8.648h.051q.061.007.121.008h.012v.258h-.012a1 1 0 0 1-.234-.035q-.09-.025-.11-.078c-.003-.028.008-.051.04-.078a.5.5 0 0 1 .129-.075Zm.165.254v-.234c-.04 0-.079-.004-.114-.004q-.023-.005-.047-.004a.5.5 0 0 0-.125.07q-.04.037-.035.067.014.047.098.07c.055.02.133.031.223.035m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.715 8.719a.6.6 0 0 1 .246.062l.008.004c.02.031-.082.102-.258.18v-.25",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.719 8.727v.226a1 1 0 0 0 .187-.101.2.2 0 0 0 .047-.04q.013-.017.008-.023l-.004-.004h-.004a.2.2 0 0 0-.09-.035.7.7 0 0 0-.144-.023m-.004-.012V8.71q.088.011.152.027a.3.3 0 0 1 .098.04l.012.003q.01.018-.008.035a.2.2 0 0 1-.051.047q-.072.049-.203.11l-.012.004v-.262Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.602 9.402c-.016-.039.164-.125.425-.195.125-.031.22-.066.344-.105.363-.125.629-.266.598-.313l-.004-.008c.02.012.047.262.047.262.035.047-.211.187-.543.309-.106.039-.332.101-.442.128-.191.051-.379.149-.363.184Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96 8.777q.002-.006.009 0 .005-.001.004.004s.004 0 .004.004q.001.001.003.008c.004.012.004.02.008.035a.5.5 0 0 1 .016.09c.004.031.012.062.012.086a.1.1 0 0 1 .004.027v.008l.003.004c.004.008 0 .016-.003.023-.004.012-.012.02-.024.032a.5.5 0 0 1-.113.078 3 3 0 0 1-.41.18c-.11.039-.336.105-.442.132a1.2 1.2 0 0 0-.258.094 1 1 0 0 0-.082.05q-.01.01-.015.016-.005.007-.004.008v.004q.001.007-.004.008c-.004 0-.012 0-.012-.004V9.66l-.062-.254q-.001-.011.004-.023a.1.1 0 0 1 .023-.024.3.3 0 0 1 .086-.046c.078-.036.188-.075.32-.114.098-.023.176-.05.266-.082l.074-.023c.18-.063.34-.13.446-.184a.7.7 0 0 0 .12-.074c.012-.012.024-.02.028-.027q.006-.013 0-.02l-.004-.004q-.001-.007.004-.008m-1.292.86q.006-.005.012-.016a.4.4 0 0 1 .086-.047c.066-.035.164-.074.261-.097.106-.032.332-.09.438-.133.164-.059.308-.125.406-.18q.077-.04.113-.074c.012-.008.016-.02.02-.027q.005-.011.004-.016-.002.001-.004-.004v-.008q.001-.013-.004-.031l-.012-.086q-.007-.048-.015-.09.001-.007-.004-.008a.1.1 0 0 1-.024.024 1 1 0 0 1-.12.078 4 4 0 0 1-.454.183l-.07.024c-.09.031-.172.059-.27.082a2 2 0 0 0-.316.11c-.035.019-.067.034-.082.05-.012.004-.016.012-.02.016q-.005.01-.004.015Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98 8.469c.082-.024.141-.051.11-.102q-.023-.045-.121-.02l-.117.032.105.191.035-.008.031-.007-.039-.086Zm-.05-.094.03-.008c.024-.008.052 0 .06.028.015.015.007.035-.02.05-.008.004-.02.004-.027.008Zm.316-.082-.031.012h-.043l.062.203.184-.031-.008-.012v-.012l-.11.024Zm.371.176.117-.211h-.043c-.027.05-.054.105-.082.156q-.054-.074-.101-.148l-.04.004h-.046l.152.203.02-.004ZM8 8.313l.023-.028a.2.2 0 0 0-.078-.02c-.074-.007-.117.02-.125.055-.008.07.14.063.137.114-.004.02-.035.027-.066.027-.032 0-.059-.016-.063-.04H7.82a.2.2 0 0 1-.02.04c.02.008.048.016.079.016.074.007.133-.016.14-.055.008-.07-.14-.07-.136-.113 0-.02.02-.032.058-.024q.04.001.051.031H8",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.637 7.055s-.032.023-.055.03c-.023 0-.05-.019-.05-.019s-.024.016-.048.02c-.023.004-.058-.02-.058-.02s-.024.024-.047.032c-.02.004-.047-.008-.047-.008s-.008.012-.027.02h-.02l-.027-.016-.028-.024-.023-.004-.012-.035-.004-.02c-.004-.019.036-.042.098-.054a.2.2 0 0 1 .082 0 .365.365 0 0 1 .266-.004.3.3 0 0 1 .125-.023.3.3 0 0 1 .133.027.16.16 0 0 1 .085 0c.063.012.106.035.098.055v.02l-.015.03-.024.008-.027.028-.028.007s-.011.008-.02.004c-.019-.007-.027-.02-.027-.02s-.027.013-.05.009c-.02-.008-.04-.032-.04-.032s-.038.024-.062.02c-.023-.004-.047-.02-.047-.02s-.027.02-.047.016c-.027 0-.058-.027-.058-.027",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.633 6.957a.3.3 0 0 0-.125-.02h-.004a.25.25 0 0 0-.129.024h-.008a.2.2 0 0 0-.078 0 .4.4 0 0 0-.07.023q-.024.014-.024.028l.004.02.012.03.023.004.032.024.02.015h.019l.015-.011c.004 0 .004-.004.008-.004l.004-.008.004.004q.005-.001.004.004h.012a.1.1 0 0 0 .023.004.1.1 0 0 0 .031-.02q.012-.004.012-.008.005 0 .004-.003l.004-.004.008.003.004.004q.005.001.011.008l.02.008h.015l.028-.012q.006-.005.011-.004v-.003h.004l.004-.004m.004.003s.004 0 .004.004c.004 0 .008.004.012.004q.013.007.031.008c.008 0 .02-.008.031-.016q.006-.003.012-.007l-.008-.008h.035l-.007.008c.003.004.007.004.011.008.004.003.012.007.016.011q.01.002.02.004.005.001.011-.004.011.001.016-.004.006-.002.011-.004c0-.003.004-.003.004-.003l.004-.004.004.003h.004v.004q.006-.001.012.004l.027.012h.016c.008-.004.015-.004.02-.008q.01-.007.015-.008.005-.002.004-.003h.004l.004-.004.004.003q.001.005.003.004.001.007.008.008.011.013.028.02c.007 0 .02 0 .027-.004h.012q-.001-.005.004-.004l.004-.004m.003.008q.004.002.008.004.004.006.02.011h.008q.001 0 .003-.003l.028-.008.027-.028.024-.007.015-.028v-.02c0-.007-.004-.019-.023-.027a.4.4 0 0 0-.07-.023.3.3 0 0 0-.083 0h-.007a.1.1 0 0 0-.051-.02q-.036-.004-.078-.003h-.004a.24.24 0 0 0-.117.019h-.008m.355.152q-.004.005-.008.004c-.003 0-.011.004-.02 0l-.023-.011q-.002-.005-.003-.004-.006-.001-.012.004c-.008 0-.024.003-.035 0a.06.06 0 0 1-.032-.02q-.005-.007-.011-.008-.005.001-.016.008-.012.004-.023.008-.007.005-.02.004h-.004q-.018-.008-.031-.016-.006-.004-.012-.008-.006.007-.011.008l-.02.008h-.016c-.007 0-.015-.004-.023-.004l-.02-.012a.03.03 0 0 0-.015-.008s-.008.004-.012.008q-.018.013-.035.02h-.004c-.012 0-.027-.008-.039-.012-.004 0-.008-.004-.012-.004V7.07q-.006.004-.011.008-.013.008-.032.016h-.004q-.012.001-.02-.004-.012-.004-.019-.008-.01-.007-.015-.008-.006.001-.012.008a.1.1 0 0 1-.04.02c-.01.003-.023 0-.03 0q-.006-.005-.012-.004s-.004 0-.004.004l-.023.011h-.028l-.027-.015-.027-.024-.024-.004-.015-.039-.004-.02q-.005-.017.027-.034c.02-.008.043-.02.074-.024a.2.2 0 0 1 .086 0 .365.365 0 0 1 .266-.004.3.3 0 0 1 .125-.023q.046.001.082.008c.02.003.039.011.054.015a.2.2 0 0 1 .086.004c.032.004.055.016.075.024q.03.017.027.035v.02l-.02.034-.023.008-.027.028Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.578 6.918c0-.035.027-.063.055-.063.031 0 .058.028.058.063s-.027.062-.058.062-.059-.027-.059-.062",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.602 6.879q-.017.013-.016.039v.004h-.004c0 .016.008.027.016.039a.05.05 0 0 0 .035.016.05.05 0 0 0 .035-.016.06.06 0 0 0 .016-.043q.001-.025-.016-.04a.04.04 0 0 0-.035-.019q-.02.001-.031.02m-.028.035h-.004v.004q-.001.03.016.047.018.019.047.02.03-.001.047-.02.016-.017.015-.047c0-.016-.004-.035-.015-.047a.07.07 0 0 0-.047-.02.06.06 0 0 0-.043.02.1.1 0 0 0-.016.043m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.61 6.918c0-.031.011-.059.027-.059.011 0 .023.028.023.059s-.012.059-.027.059c-.012 0-.024-.028-.024-.059m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.621 6.879q-.007.016-.008.039.001.026.008.039.004.006.008.012h.012q.001-.006.007-.012a.1.1 0 0 0 .008-.039q-.001-.022-.008-.04-.003-.005-.007-.01l-.004-.005s-.004 0-.008.004q-.001.006-.008.012m0-.02c.004 0 .008-.004.016-.004q.01.001.015.008c.004 0 .004.008.008.012a.1.1 0 0 1 .008.043.1.1 0 0 1-.008.043l-.012.012q-.004.006-.015.007-.011 0-.016-.007-.001-.006-.008-.012a.1.1 0 0 1-.007-.043.1.1 0 0 1 .007-.043zm.016.004",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.332 7.176a.1.1 0 0 0-.02-.031 1.2 1.2 0 0 1 .32-.032c.13 0 .247.008.329.032l-.024.027-.019.023a1.4 1.4 0 0 0-.285-.023c-.113 0-.23.008-.29.023l-.007-.02",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.32 7.145.02.027-.012.004q-.007-.016-.02-.031l-.003-.004h.008a1.2 1.2 0 0 1 .32-.032c.129 0 .246.008.332.032h.004l-.028.035-.02.027h-.003a1.2 1.2 0 0 0-.285-.027c-.113 0-.23.011-.285.027h-.008l-.008-.027.012-.004.008.02c.058-.016.171-.024.28-.024.118 0 .212.004.286.023l.012-.023.023-.023c-.082-.02-.2-.028-.32-.028q-.188-.001-.313.028m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.633 7.258c.101 0 .219-.016.258-.024q.042-.01.043-.023-.001-.011-.02-.016a2 2 0 0 0-.281-.027c-.094 0-.188.012-.278.027-.011 0-.02.008-.02.016q.002.012.044.023c.039.008.152.024.254.024m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.633 7.164q.145 0 .285.027.006.004.012.008.007 0 .008.012 0 .008-.012.016l-.031.011c-.043.012-.16.024-.262.024s-.215-.012-.258-.024l-.031-.011q-.012-.008-.012-.016.001-.012.008-.012.006-.007.012-.008.14-.029.28-.027m.281.04a1.312 1.312 0 0 0-.559 0h-.007q-.005.003-.004.007-.002.001.008.008c.003.004.015.008.027.011a1.7 1.7 0 0 0 .512 0c.011-.003.023-.007.027-.011q.01-.007.008-.008.001-.005-.004-.004-.001-.005-.008-.004m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.883 6.945c0-.004 0-.004.004-.008q.006-.003.011-.007c.012 0 .02.008.02.015 0 .008-.008.016-.02.016q-.005-.004-.011-.008s-.004-.004-.004-.008m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.723 6.844q-.006-.001-.012.004l-.004.004v.003c0 .004.004.004.004.008.004 0 .008.004.012.004.007 0 .011-.004.011-.004q.005-.001.004-.008.001-.006-.004-.007-.006-.005-.011-.004m0-.008-.016.004q-.007.006-.008.012v.003q.001.006.008.012c.004.004.012.004.016.004v-.004.004m.062-.027q-.017.001-.015.008 0 .005.003.011s.004.004.012.004l.008-.008q.005-.001.004-.007l-.004-.004q-.004-.005-.008-.004m-.023.008q0-.014.023-.016c.004.004.008.004.012.008q.007.001.008.008.001.01-.004.011a.03.03 0 0 1-.016.008q-.012.001-.02-.004-.004-.005-.003-.015m.082 0 .015.003q.007.006.008.012-.001.011-.008.016h-.019q-.006.001-.012-.004-.004-.007-.008-.008v-.008a.01.01 0 0 0 .008-.008q.006 0 .012-.003Zm0 .007q-.007-.001-.008.004-.004-.001-.008.004l.008.008s.004.004.008.004q.006.001.011-.004s.004-.004.004-.008-.004-.004-.004-.004q-.005-.005-.011-.004m.047.028q-.006-.001-.012.004s-.004.004-.004.007c0 .004.004.008.004.008q.006.005.012.004.004-.002.007-.004.005-.007.004-.008.001-.006-.004-.007 0-.005-.007-.004m0-.004c-.004 0-.012 0-.016.004a.01.01 0 0 0-.008.008v.007q.001.007.008.008c.004.004.012.004.016.004q.01.001.015-.004.005-.006.004-.012.001-.005-.004-.011t-.015-.004m.007.047q.013-.001.02.004t.008.011c0 .012-.012.016-.028.016q-.005.001-.011-.004l-.008-.008v-.004q-.001-.006.004-.011c.004-.004.012-.004.015-.004m0 .004q-.003.002-.007.003-.005.007-.004.008c0 .004.004.004.004.008.004 0 .007.004.007.004.012 0 .016-.008.016-.012s0-.004-.004-.008q0-.002-.012-.003m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.957 6.906a.14.14 0 0 1 .09.032q.04.028.039.07m-.129-.09a.1.1 0 0 0-.05.012q-.008.001-.009-.004c-.003 0 0-.004 0-.004a.3.3 0 0 1 .059-.016M13.688 6.89q.024-.016.074-.015c.027 0 .058.008.078.02q.035.021.035.05v.004l-.012.028-.011-.004.011-.028q0-.023-.031-.043a.2.2 0 0 0-.07-.015q-.049 0-.067.011Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.93 6.883c-.004 0-.004.004-.004.004v.011h.023s.004-.003.004-.007a.01.01 0 0 0-.008-.008c0-.004-.008-.004-.008-.004q-.006-.001-.007.004m-.008-.008c.004 0 .008-.004.015-.004a.03.03 0 0 1 .016.008c.004 0 .008.008.008.012q-.001.006-.008.011c-.004.004-.012.004-.015.004-.008 0-.016 0-.016-.004q-.007-.005-.008-.011v-.004q.001-.006.008-.012m.062.008v.004c0 .004.004.008.004.008q.006.004.012.003.007 0 .008-.003a.01.01 0 0 0 .008-.008q-.001-.007-.02-.008s-.004 0-.008.004zm-.007.008h-.004v-.004q.001-.006.007-.012c.008 0 .012-.004.016-.004q.025.002.027.016a.03.03 0 0 1-.007.015q-.007.002-.02.004c-.004 0-.012-.004-.012-.008a.01.01 0 0 1-.007-.007m.078 0q.012-.001.02.004.004.004.003.015.001.006-.004.012c-.008.004-.011.004-.02.004m-.019-.02c0-.004.004-.008.004-.008q.005-.006.016-.007m-.016.023q.005-.001.004.004h.023q.005-.004.004-.008.001-.006-.004-.012h-.011q-.007-.001-.008.004-.005.001-.004.008v.004Zm.063.024q-.019 0-.02.007c0 .004.004.008.004.008q.006.005.012.004c.007 0 .015-.008.015-.012l-.004-.004q-.007-.004-.007-.003m-.028.007c0-.008.012-.015.028-.015q.005.001.011.008.007 0 .008.007c0 .012-.012.016-.023.016h-.016q-.007-.005-.008-.016m.02.055q0 .007.011.008.006.001.012-.004.005-.001.004-.008l-.004-.004c-.004-.004-.012-.004-.012-.004q-.01 0-.011.012m-.012 0v-.004h.004c0-.008.008-.016.02-.016.003 0 .011.004.015.004q.007.006.008.012-.001.006-.008.012-.005.007-.016.008c-.011 0-.02-.008-.02-.016Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.96 7.105-.023-.015s-.027.012-.054.008c-.028-.004-.04-.032-.04-.032s-.03.02-.058.02c-.031 0-.047-.02-.047-.02s-.027.016-.054.016c-.028 0-.051-.027-.051-.027s-.028.027-.055.03c-.023 0-.043-.019-.043-.019s-.012.02-.047.02c-.031.004-.062-.016-.062-.016s-.02.02-.04.032c-.023 0-.054-.016-.054-.016l-.008.016-.015.007.007.012c.211-.039.43-.035.637.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.629 7.05.004-.003.004.004h.004v.004l.011.008q.005.005.016.011.005.002.016.004a.1.1 0 0 0 .035-.008c.004-.004.008-.004.011-.008h.004l.008-.003.004.003v.004c.004 0 .004.004.008.004q.013.007.031.008.018.005.035-.008c.004 0 .012-.004.012-.004l.004-.003.008-.004.004.003v.004h.004l.003.012a.1.1 0 0 0 .028.016q.023.001.035-.004.006.001.012-.004h.008l.03.02-.011.023h-.004c-.21-.04-.426-.04-.633-.004l-.008.004-.011-.024.02-.003.011-.02h.004l.004.004q.006.002.012.004.018.008.03.004a.1.1 0 0 0 .028-.016l.008-.008q.005-.002.004-.004l.004-.003.008.003.004.004c.003 0 .007.004.011.004q.017.013.04.008.021 0 .03-.012.007-.002.008-.004v-.003l.004-.004.008.003s.004 0 .004.004c0 0 .004.004.008.004.008.004.02.008.027.008.004 0 .012 0 .016-.004l.015-.011q.011-.001.016-.008V7.05Zm-.094.024q-.001.002-.008.004-.01.011-.039.016a.1.1 0 0 1-.047-.012q-.006-.001-.011-.008-.006.007-.012.008l-.027.023h-.004a.1.1 0 0 1-.04-.007q-.005.001-.011-.004l-.008.011-.012.008.004.004c.207-.039.422-.035.63.004l.003-.012-.02-.011h-.011q-.017.005-.04.004c-.019 0-.027-.012-.034-.02l-.008-.008q-.006.001-.012.008a.1.1 0 0 1-.043.008c-.015 0-.031-.008-.039-.012a.01.01 0 0 1-.008-.008q-.005.004-.015.008a.1.1 0 0 1-.04.008c-.007 0-.015-.004-.023-.004-.004-.004-.012-.008-.015-.012q-.006-.007-.012-.008-.006.001-.012.008l-.02.012-.019.008h-.004c-.012 0-.027-.008-.035-.012-.004 0-.004-.004-.008-.004m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.344 6.945q.001-.007.008-.008.004-.006.015-.007c.004.004.008.004.012.008q.005.003.004.007a.01.01 0 0 1-.008.008q-.001.004-.008.008c-.012 0-.023-.008-.023-.016m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.473 6.848c-.004 0-.004.004-.004.004 0 .007.008.015.011.015.004 0 .012-.004.012-.004q.005-.006.004-.011.001-.002-.004-.004-.006-.005-.012-.004-.003-.001-.007.004m-.004-.004c0-.004.008-.008.011-.008a.03.03 0 0 1 .016.008q.007.001.008.008.001.01-.004.015-.007.005-.02.004-.018-.001-.02-.02.002-.006.009-.007m.074-.008q.011.001.016.008.009.006.007.011c0 .008-.011.016-.023.016q-.011.001-.016-.004c0-.004-.004-.008-.004-.012v-.003q.002-.007.004-.008.005-.004.016-.008m0 .008q-.007-.001-.008.004c-.004 0-.004.004-.004.004v.003c0 .004 0 .004.004.008q.001-.001.008.004c.012 0 .016-.008.016-.012q.001-.003-.004-.007-.006-.005-.012-.004m-.137.023q.001.007.008.008.001.005.008.004.011.001.015-.004s.004-.004.004-.008-.004-.004-.004-.004q-.004-.005-.015-.004-.006-.001-.012.004h-.004zm0-.012.016-.003q.012.001.02.003.006.006.007.012-.001.011-.008.016h-.02m-.046.004q-.007.002-.008.004-.005.004-.004.007-.001.007.004.008.001.005.008.004.006-.002.012-.004.005-.007.004-.008c0-.003-.004-.007-.004-.007q-.006-.005-.012-.004m0-.004c.004 0 .012 0 .016.004q.007.001.007.008v.003q0 .006-.007.012-.005.005-.016.004-.011.001-.016-.004-.005-.006-.004-.012v-.003c0-.004 0-.004.004-.008q.005-.005.016-.004m-.008.05c-.004 0-.008.005-.012.005q-.004.006-.003.007c0 .004.003.012.015.012q.001-.002.008-.004c0-.004.004-.004.004-.008q.001-.001-.004-.008-.004-.002-.008-.003m-.02 0q.008-.004.02-.003c.004 0 .012 0 .016.004q.005.005.004.011v.004l-.008.008q-.006.005-.012.004c-.015 0-.027-.004-.027-.016q.001-.006.008-.011m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.309 6.918a.14.14 0 0 0-.082.023.09.09 0 0 0-.036.067q0 .013.012.031s0 .004-.004.004q-.001.006-.008 0a.06.06 0 0 1-.011-.035q-.002-.042.039-.07a.14.14 0 0 1 .09-.032c.007 0 .02.004.03.004l.028.012v.004q-.001.005-.008.004a.1.1 0 0 0-.023-.008q-.017-.005-.027-.004M13.406 6.945c0-.03.043-.058.102-.058q.042 0 .062.011l.008-.007c-.015-.012-.043-.016-.07-.016-.063 0-.113.031-.113.07v.004l.011.028.012-.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.266 6.871h.004c.011 0 .023.008.023.016a.03.03 0 0 1-.008.015c-.004 0-.012.004-.015.004-.008 0-.016-.004-.02-.004a.03.03 0 0 1-.008-.015v-.004h.008s0-.004.004-.004q.006-.007.012-.008m-.016.02q.004.005.008.004 0 .004.012.003.005 0 .011-.003s.004-.004.004-.008-.008-.008-.015-.008q-.007-.001-.008.004c-.004 0-.004.004-.008.004v.004Zm.078-.012q-.014.001-.015.008v.004l.007.007h.016q.005-.003.004-.007v-.008q-.006-.005-.012-.004m-.023.008c0-.008.011-.016.023-.016h.004q.006.001.012.008.007.006.008.012-.001.006-.008.011-.005.002-.016.004c-.004 0-.012 0-.015-.004q-.007-.005-.008-.011Zm.047.004h-.008Zm-.157.015h.004v.004s0 .004.004.004q.001.005.008.004h.012c0-.004.004-.008.004-.008q.001-.007-.004-.008-.006-.005-.012-.004-.006-.001-.012.004s-.004 0-.004.004m-.004.008h-.004V6.91q.001-.011.008-.015.005-.002.016-.004c.008 0 .012.004.016.004a.03.03 0 0 1 .007.015q-.001.006-.007.012l-.016.004q-.011-.001-.016-.008zm-.039.031q.001.007.008.008.001.005.008.004.007.001.008-.004.005-.001.004-.008v-.004c-.004-.003-.004-.003-.012-.003s-.016.003-.016.007m-.007 0c0-.008.011-.015.023-.015.008 0 .016.004.016.008q.007 0 .007.007-.001.006-.007.012-.005.005-.016.004c-.004 0-.012 0-.016-.004a.01.01 0 0 1-.007-.008Zm0 .055q.002.001.003.008h.012q.006.001.012-.004.005-.001.004-.008.001-.007-.016-.008-.006-.001-.012.004-.001.001-.003.008m-.008 0v-.004q.001-.007.008-.008.004-.007.015-.008.025.002.027.016a.03.03 0 0 1-.007.016q-.007.002-.02.004-.011.001-.015-.004-.007-.006-.008-.012m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.637 7.023h.008v.016c0 .016.02.031.046.031.02 0 .04-.008.043-.023l.008-.012v.016c0 .015.028.027.047.027h.02q.008-.004.015-.008l.012-.011c0-.004.004-.012 0-.016q.006.001 0-.004l.016-.012.007.012q-.006.011 0 .016c0 .02.016.03.04.03.007.005.015 0 .023 0l.02-.01.003-.009v.012c0 .008.008.02.02.024 0 0 .015 0 .043-.016l.031-.024v.016s-.02.024-.043.035a.1.1 0 0 1-.039.008.04.04 0 0 1-.023-.02.1.1 0 0 1-.036.008q-.042 0-.062-.03c-.004.003-.012.01-.02.01a.1.1 0 0 1-.027.009q-.016-.002-.031-.004a.1.1 0 0 1-.024-.016.1.1 0 0 1-.039.012q-.017.001-.035-.004-.017-.008-.027-.016l-.02.012a.1.1 0 0 1-.027.008c-.008 0-.02 0-.027-.004q-.012-.001-.024-.008-.012.011-.023.016c-.012 0-.02.004-.032.004a.07.07 0 0 1-.046-.016c-.012.016-.036.023-.063.023-.012 0-.02 0-.035-.003q-.005.011-.027.02a.1.1 0 0 1-.04-.009l-.042-.035v-.016l.043.024a.05.05 0 0 0 .03.016c.016 0 .02-.016.02-.024v-.012l.012.008q.013.017.04.016c.023 0 .038-.016.038-.031q.006-.007 0-.02l.008-.012.016.012c0 .024.02.04.043.04s.046-.013.05-.032v-.008l.008.008c.004.016.024.023.04.023.007.004.015 0 .023 0l.02-.011.01-.016c0-.008 0-.012-.003-.02h.008",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.852 7.02.011.02v.015q0 .014.012.02.006.009.023.007h.02c.008-.004.012-.004.016-.008l.004-.011.011.003v.012c0 .008.008.016.016.016h.008c.007 0 .02-.004.03-.012l.044-.031v.027l-.004.004-.004.004-.008.008a.1.1 0 0 1-.031.023.1.1 0 0 1-.043.008h-.004q-.018-.001-.023-.02a.1.1 0 0 1-.032.008q-.042 0-.062-.027l-.016.012c-.011 0-.02.004-.03.004q-.02.001-.032-.004l-.024-.012c-.011.008-.027.008-.039.008-.011.004-.027 0-.039-.004a.1.1 0 0 1-.023-.016c-.004.008-.012.008-.02.012a.1.1 0 0 1-.027.008h-.027q-.012-.007-.024-.008l-.023.012q-.013.005-.032.004-.018.001-.03-.004c-.009-.004-.012-.004-.016-.008 0-.004.004-.004.004-.008h-.012l.008.008c-.012.012-.036.02-.063.02h-.02q-.005.001-.011-.005l.004-.003h-.008v.003h.004q-.007.019-.031.02a.1.1 0 0 1-.043-.008l-.047-.039v-.023l.054.03q.01.008.02.009h.008v.004-.004q.006.001.011-.004c0-.004.004-.008.004-.012v-.023l.024.015v.004q.007.012.031.012c.02 0 .035-.012.035-.027v-.02l.012-.02.02.02c0 .02.019.035.039.035q.036-.001.043-.027v-.024l.02.024c.003.012.023.02.034.02h.024c.004-.005.011-.005.015-.012q.007-.006.008-.012.001-.011-.004-.016V7.02h.035v.02c0 .015.016.022.04.022.019 0 .035-.003.038-.015l.008-.016.012.004v.016q0 .007.012.015c.008.004.02.008.027.008.004 0 .012 0 .016-.004q.007.001.015-.004.007-.005.008-.011.005-.006.004-.012v-.004Zm.18.058-.012.012q-.012.012-.024.02a.1.1 0 0 1-.039.007.05.05 0 0 1-.02-.02l-.003-.003-.004.004q-.016.006-.032.007-.041-.001-.054-.027l-.004-.008-.008.004a.02.02 0 0 1-.02.012.1.1 0 0 1-.023.008.1.1 0 0 1-.027-.008q-.012 0-.024-.012l-.004-.004-.004.004a.06.06 0 0 1-.035.012q-.018.001-.03-.004a.1.1 0 0 1-.028-.016l-.004-.003-.004.003-.02.012q-.01.004-.023.008-.011.001-.027-.004a.03.03 0 0 1-.02-.008l-.004-.004-.004.004q-.012.012-.023.012a.1.1 0 0 1-.028.008c-.007 0-.02-.004-.027-.004q-.011-.006-.015-.012l-.008-.008-.004.008q-.013.024-.055.024h-.016q-.004-.002-.015-.004l-.004-.004-.004.004a.04.04 0 0 1-.023.02.1.1 0 0 1-.036-.009l-.039-.03v-.005l.028.016q.017.012.027.012.004.004.008.003h.004v-.003.003q.018 0 .023-.011l.004-.016q.013.017.043.016c.027 0 .047-.016.047-.035v-.016l.004-.008.004.008c0 .023.023.039.05.039.024 0 .047-.012.055-.027a.06.06 0 0 0 .043.023c.008 0 .02 0 .028-.004l.02-.011a.02.02 0 0 0 .01-.02v-.012h.009v.008c0 .02.023.035.05.035.016 0 .04-.004.047-.02 0 .008.008.016.016.02q.018.007.035.008h.02c.007-.004.011-.004.02-.008q.005-.005.01-.015.006-.005.005-.016l.004-.008.004.008v.016q-.002.01.015.023.013.012.031.012.014.001.028-.004.006-.001.011-.008.005.018.028.023v-.003.003h.004q.004 0 .008-.003c.007 0 .02-.004.03-.012h.005l.02-.016Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.633 7.113a1.3 1.3 0 0 0-.32.032l-.016-.008.008-.012c.082-.02.199-.031.328-.031s.246.011.328.031c.008 0 .012.008.008.008 0 .008-.008.012-.012.008a1.5 1.5 0 0 0-.324-.032",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.309 7.129-.004.008h.008c.082-.02.195-.028.312-.028v-.004h.008c.129 0 .242.012.324.032h.004q.002.001.004-.004c0-.004-.004-.004-.004-.004a1.5 1.5 0 0 0-.328-.031c-.125 0-.242.011-.324.03m.332-.016v.004h-.008c-.121 0-.238.008-.317.031h-.004l-.023-.007.012-.02h.004c.082-.02.199-.031.328-.031s.246.012.328.031q.011-.001.016.004v.012c-.004.004-.004.008-.008.008a.01.01 0 0 1-.016 0 1.4 1.4 0 0 0-.312-.032m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.516 7.148q.002-.016.015-.015c.008 0 .02.004.02.015 0 .004-.012.012-.02.012s-.023-.008-.023-.012",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.531 7.137c-.004 0-.011.004-.011.011v.004q.005.002.011.004s.004-.004.008-.004l.004-.004q.001-.006-.004-.007-.007-.005-.008-.004m-.023.004h-.004v.007q.001.006.008.012c.008 0 .011.004.02.004.003 0 .011-.004.015-.004.004-.004.012-.008.012-.012 0-.007-.008-.011-.012-.015a.03.03 0 0 0-.016-.008.03.03 0 0 0-.023.016m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.637 7.148h-.04q-.018.002-.019-.007.001-.007.02-.008h.09q.002.004.003.008 0 .009-.011.007Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.586 7.14s0 .005.004.005h.094v-.008h-.094zm-.004-.007q.005-.007.016-.008h.082c.004 0 .008.004.011.004q.005.006.004.012.001.006-.004.011-.006.002-.011.004h-.082c-.008 0-.012-.004-.016-.004q-.007-.005-.008-.011v-.004q.004-.005.008-.004m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.434 7.164h-.039l-.004-.004q-.005-.002-.004-.004-.001-.004.004-.008h.007l.028-.003.031-.008c.008 0 .016.004.016.011 0 .004 0 .008-.012.012h-.027",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#058e6e",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.457 7.133c.004 0 .012 0 .016.004q.007 0 .007.011 0 .001-.003.008-.005.007-.016.008h-.027v.004h-.043q-.004-.005-.008-.004c0-.004 0-.004-.004-.008q.001-.006.008-.011.006-.002.011-.004h.028Zm0 .008-.027.007-.032.004h-.003v.004l.003.004.004-.004h.059l.004-.004v-.007q-.004-.002-.008-.004m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.313 7.18.015-.016h.027l-.02.02Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.328 7.156.035.008-.023.027-.04-.011Zm.004.012-.008.008.012.004.008-.012Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.719 7.148q.001-.016.02-.015c.007 0 .015.004.015.015 0 .004-.008.012-.016.012s-.02-.008-.02-.012m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.73 7.14q-.004.002-.003.008l.003.004q.007.002.008.004c.004 0 .004-.004.008-.004s.004-.004.004-.004c0-.007-.008-.011-.012-.011q-.007-.001-.008.004m-.011-.007c.008-.004.011-.008.02-.008.011 0 .023.012.023.023q-.001.006-.008.012c-.004 0-.008.004-.016.004q-.008-.002-.015-.004c-.004-.004-.012-.008-.012-.012q.001-.01.008-.015m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.836 7.164h.031c.008 0 .012 0 .016-.008q.001-.004-.004-.008h-.008l-.027-.003-.031-.008c-.008 0-.016.004-.016.011 0 .004 0 .008.012.012h.027",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#058e6e",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.797 7.137q.011-.005.015-.004l.032.008h.027c.004 0 .008.004.012.004q.007.005.008.011l-.004.004-.008.008h-.039v-.004h-.031q-.011-.001-.016-.008t-.004-.008q.001-.01.008-.011m.008.008v.007l.004.004h.058l.004.004h.004v-.008h-.004l-.031-.004-.027-.007c-.004 0-.004.004-.008.004m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.953 7.18-.012-.016h-.03l.019.016z",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.898 7.156h.047l.012.02-.004.004v.008h-.027Zm.047.02-.008-.008h-.015l.008.008Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.633 7.238a1.5 1.5 0 0 1-.262-.023c.176-.031.356-.031.531 0-.086.015-.18.023-.27.023m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.398 7.215q.118.019.235.02.124-.001.242-.02a1.6 1.6 0 0 0-.477 0m-.03-.004c.179-.031.362-.031.538 0l.004.004c0 .004-.004.004-.004.004a1.6 1.6 0 0 1-.539 0s-.004 0-.004-.004zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.957 7.07-.004-.015c-.008 0-.012 0-.015.008l.003.015q.011-.001.016-.008m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.953 7.05h.004l.008.02h-.004a.01.01 0 0 1-.008.008q-.006.005-.012.004h-.007l-.004-.02V7.06q.006-.001.011-.008zm-.012.013.004.011V7.07q.005.001.004-.004v-.003h-.008m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 7.04q.002-.012-.008-.017c-.004 0-.012.008-.012.016q-.002.006.008.012c.008 0 .012-.008.012-.012m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.738 7.023c0-.003.004-.003.004-.003h.004q.006.003.012.007v.012q.001.007-.004.008-.005.007-.016.008-.012-.004-.011-.008v-.008q0-.012.003-.012.004-.005.008-.004m.004.008q-.005.004-.004.008v.004l.004.004v-.004c.004 0 .004-.004.004-.004v-.008zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.52 7.04q-.002-.012.007-.017c.004 0 .012.008.012.016 0 .004 0 .008-.008.012-.008 0-.011-.008-.011-.012m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.523 7.02h.004s.004 0 .004.003q.004-.001.008.004.005 0 .004.012v.008q0 .004-.012.008-.01-.001-.015-.008-.005-.001-.004-.008v-.012q.006-.004.011-.007m.004.011h-.004v.008s0 .004.004.004v.004l.004-.004v-.004c0-.004 0-.004-.004-.008m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.313 7.07.003-.015c.008 0 .012 0 .016.008l-.004.015q-.011-.001-.015-.008m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.32 7.063v.003q-.001.005.004.004v.004l.004-.011h-.008m.008-.012q.006.007.012.008v.003l-.004.02h-.008q-.006.001-.012-.004a.01.01 0 0 1-.007-.008h-.004l.008-.02h.015m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.633 6.95-.031.015.023.043.008.008.012-.008.023-.043Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.633 6.945.043.02-.028.047-.015.011-.012-.011-.027-.047Zm0 .012-.024.012.02.039h.012l.02-.04Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.555 7.016.015.02.059-.013.004-.007-.004-.008-.059-.012Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.57 6.992.063.012.008.012-.008.011-.063.012-.023-.023Zm.004.012-.011.012.011.011.051-.007v-.008Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.715 7.016-.016.02-.058-.013-.004-.007.004-.008.058-.012Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.7 6.992.023.024-.024.023-.062-.012-.008-.011.008-.012Zm-.055.02v.008l.05.007.012-.011-.012-.012Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.398 6.969-.027.02.04.034.007.004.004-.004.015-.046Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.398 6.965.043.012-.011.046-.008.012-.016-.008-.043-.039Zm0 .008-.02.015.036.032.004.003V7.02l.012-.04Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.34 7.04.023.015.047-.02.004-.008-.004-.004h-.058Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.344 7.016h.07l.008.011-.008.012-.055.024-.023-.02Zm.011.011-.007.012.015.012.043-.02.004-.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.496 7.02-.012.02-.058-.005-.008-.008v-.004L13.473 7Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.473 6.996.03.024-.015.023-.062-.004-.012-.008V7.02Zm-.047.027v.004l.004.004h.05l.008-.011-.015-.016Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.285 7.047-.004.023h-.07v-.008l.047-.03Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.258 7.023.031.024-.004.027-.066.004h-.016v-.02Zm-.043.043h.004l.054-.003.004-.016-.02-.008Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.398 7.031v-.008l.004-.003q.004-.005.008-.004.007-.005.008-.004.011.002.016.004.007.006.007.011-.001.006-.007.012-.005.005-.016.004-.006.001-.012-.004-.007-.006-.008-.012",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.418 7.016s-.004 0-.004.004h-.008v.007q-.001.007.004.008.001.005.008.004.006.001.012-.004.005-.001.004-.008.001-.004-.004-.007-.006-.002-.012-.004m-.023.015q-.006-.004 0-.008 0-.006.003-.007.007-.004.008-.008h.012v.004-.004a.03.03 0 0 1 .02.008c.007 0 .007.007.007.011 0 .008 0 .012-.008.016q-.006.005-.019.004c-.004 0-.012 0-.016-.004q-.007-.006-.007-.012m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.867 6.969.031.02-.039.034-.007.004-.004-.004-.016-.046.04-.008",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.84 6.98.012.04v.003l.003-.003.036-.032-.024-.011Zm.031-.015h-.004l-.039.012.012.046.008.012.015-.008.043-.039Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.93 7.04-.024.015-.05-.02v-.008l.003-.004h.059Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.855 7.016h.07l.009.027-.024.02-.062-.024v-.012Zm.008.011h-.004v.004l.047.02.016-.012-.008-.012Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.773 7.02.012.02.059-.005.008-.008v-.004L13.797 7Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.797 6.996.058.024v.011l-.011.008-.063.004-.015-.023Zm0 .008-.016.016.008.011h.05l.005-.004v-.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.977 7.047.003.023h.07v-.008l-.05-.03Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 7.023.059.036v.02h-.02l-.062-.005-.008-.027Zm0 .016-.016.008.004.016.051.003h.008Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.613 7.016c0-.008.012-.016.02-.016s.02.008.02.016q-.001.01-.02.011-.006.001-.012-.004a.01.01 0 0 1-.008-.007m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.617 7.016c.004 0 .004.004.008.004q.001.004.008.003.016 0 .015-.007 0-.004-.007-.008-.001-.005-.008-.004-.007-.001-.008.004-.007.004-.008.008m0-.016q.005-.005.016-.004.011-.001.015.004.012.005.012.016c0 .007-.012.015-.027.015",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.828 7.031v-.008q.004-.001.008-.003.002-.005.004-.004.006-.005.012-.004c.011 0 .02.008.02.015q-.002.017-.02.016-.011.001-.016-.004-.007-.006-.008-.012",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.852 7.016c-.004 0-.004 0-.008.004h-.004q-.005.003-.004.007-.001.007.004.008.006.005.012.004.006.001.007-.004.005-.001.004-.008.001-.004-.004-.007-.001-.002-.007-.004m-.028.015v-.008c0-.003.004-.007.004-.007q.006-.004.012-.008h.012v.004-.004q.008-.001.02.004.004.007.003.015.001.011-.004.016a.04.04 0 0 1-.02.004q-.012.001-.019-.004-.007-.006-.008-.012m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.598 6.844c0-.012.015-.024.039-.024q.035.002.035.028c0 .015-.016.027-.04.027a.04.04 0 0 1-.027-.012q-.009-.006-.007-.02m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.66 6.836v.02h-.058v-.02h.02v-.043h-.024v-.02h.023v-.015h.027v.015h.024v.02h-.024v.043Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.613 6.754h.043v.016h.024v.027h-.024v.035h.012v.027h-.074v-.027h.02v-.035h-.024V6.77h.023Zm.043.09h-.011v-.055h.023v-.008h-.023v-.015h-.02v.015h-.023v.008h.023v.055h-.02v.008h.051Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.691 6.836v.02h-.113v-.02h.043v-.043h-.031v-.02h.027v-.015h.028v.015h.023v.02h-.023v.043h.043",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.66 6.832q-.005-.007-.015-.008v-.011l.027.011q.007.012.008.024c0 .02-.02.03-.047.03a.04.04 0 0 1-.031-.01q-.012-.013-.012-.024h.008-.008c0-.008.004-.012.008-.02l.027-.011v.011a.03.03 0 0 0-.016.008q-.007.006-.007.012c0 .008.003.011.007.02a.1.1 0 0 0 .024.007c.023 0 .035-.012.035-.023q-.001-.011-.008-.016m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.207 7.07-.031-.023-.028-.008s.012-.012.024-.012l.023.008v-.008s.008 0 .012.012c.008.012 0 .024 0 .024Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.195 7.023v.004zq.004-.001.008.004.007 0 .008.012.005.008.004.016v.008h-.004v.023l-.04-.035-.034-.012.008-.004q0-.002.003-.004.002.001.004-.004c.004 0 .012-.004.02-.004h.004l.011.004v-.004Zm.004.02-.027-.012c-.004 0-.008.004-.012.004l.02.008.02.016h.003v-.004q.001-.006-.004-.012m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.207 7.063.02.003c.007.004.011.012.003.016h-.02q-.01-.011-.003-.016",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.2 7.059.03.003.012.012v.008c-.004 0-.004.004-.008.004h-.027q-.013-.012-.008-.024Zm.01.007v.004s-.003 0 .005.008h.015v-.004q-.003.001-.007-.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.055 7.07.027-.023.031-.008s-.011-.012-.023-.012q-.006-.001-.012.004-.006-.001-.012.004v-.008s-.011 0-.015.012v.024Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.09 7.023q.01.002.02.004.002.005.003.004c.004 0 .004.004.004.004l.008.004-.04.012-.03.031-.008-.02V7.04q0-.012.012-.012c0-.004.004-.004.004-.004h.003v.004-.004h.024m-.027.012q-.005.001-.004.008v.02l.023-.02.02-.008q-.006-.002-.012-.004h-.004s-.004 0-.008.004c0 0-.004 0-.008.004l-.008.008Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.055 7.063-.02.003q-.011.008-.004.016.007.006.02 0 .013-.011.004-.016",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.063 7.059v.003s0 .004.003.004v.008l-.011.012-.016.004h-.008l-.004-.004q-.011-.012.004-.024Zm-.012.007-.012.004c-.008.004-.004.008-.004.008v.004h.004q.001-.005.008-.004.007-.004.008-.008h-.004Zm.004.004",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.168 7.438h.937V7.25h-.94v.188Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.156 7.242h.957v.203h-.957Zm.016.016v.172h.926v-.172Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.008 7.563c-.008 0-.012-.004-.02-.004h-.718c.023-.004.039-.02.039-.04 0-.019-.02-.039-.04-.042h.739q-.045.012-.043.043 0 .031.043.039",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.262 7.473q.001-.005.008-.004l.015.004h.723q.004-.001.008.004a.01.01 0 0 1-.008.007q-.017.006-.028.012a.1.1 0 0 0-.007.024c0 .015.015.027.035.035q.007.002.008.004v.003c0 .004-.004.004-.004.004q-.007.006-.008 0h-.734q-.006 0-.012-.007s.004-.004.008-.004c.02-.008.035-.02.035-.035q0-.012-.012-.024a.1.1 0 0 0-.023-.016c-.004 0-.008-.003-.004-.007m.715.082q-.019-.018-.02-.035 0-.016.012-.032l.004-.004h-.676c.004 0 .004.004.004.004q.016.013.015.032 0 .017-.02.035Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.29 7.559h.694c.028 0 .047.011.047.027 0 .012-.02.023-.043.023h-.699c-.027 0-.043-.011-.043-.023q.001-.026.043-.027m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.262 7.57q-.007.005-.008.016 0 .014.035.016h.7c.007 0 .019 0 .023-.004q.012-.006.011-.012 0-.011-.011-.016c-.004-.004-.016-.004-.028-.004h-.695q-.017-.001-.027.004m-.008-.008q.012-.009.035-.007h.695c.016 0 .028 0 .04.008a.03.03 0 0 1 .015.023q-.002.013-.016.02c-.007.007-.023.011-.035.011h-.699c-.027 0-.05-.015-.05-.031q.002-.018.015-.024m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.29 7.438h.694c.028 0 .047.007.047.019s-.02.02-.043.02h-.699c-.027 0-.047-.008-.047-.02s.02-.023.043-.023",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.262 7.445q-.012.006-.012.012 0 .007.012.008.008.007.027.008h.7q.017-.001.023-.008.012-.001.011-.008 0-.007-.011-.008c-.004-.004-.016-.004-.028-.004h-.699l-.004-.004q-.012-.001-.02.004m-.012-.011q.018-.005.035-.004h.7q.023.001.035.008.018.003.02.019c0 .008-.009.016-.017.02a.1.1 0 0 1-.035.007h-.699a.1.1 0 0 1-.035-.007q-.019-.007-.02-.02c0-.012.008-.016.016-.023m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.98 10.582a.5.5 0 0 0 .165-.027c.05-.02.109-.028.164-.028.062 0 .125.012.164.028a.454.454 0 0 0 .328 0 .49.49 0 0 1 .324 0c.04.015.102.03.164.03v.075a.5.5 0 0 1-.164-.031.47.47 0 0 0-.324.004.6.6 0 0 1-.164.027.6.6 0 0 1-.164-.027.45.45 0 0 0-.328 0 .5.5 0 0 1-.165.027Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#005bbf",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.148 10.559a.4.4 0 0 1-.16.027v.066a.4.4 0 0 0 .153-.027.52.52 0 0 1 .336 0q.076.028.16.027.083.002.16-.027a.5.5 0 0 1 .164-.027.5.5 0 0 1 .168.023q.07.03.152.031v-.062a.4.4 0 0 1-.16-.031.5.5 0 0 0-.156-.024.4.4 0 0 0-.16.024.48.48 0 0 1-.336 0 .5.5 0 0 0-.16-.024.4.4 0 0 0-.16.024m.16-.036a.4.4 0 0 0-.167.024.4.4 0 0 1-.16.027h-.008v.09h.007a.4.4 0 0 0 .168-.027.47.47 0 0 1 .32 0q.081.028.169.027a.4.4 0 0 0 .168-.027.5.5 0 0 1 .156-.028q.084 0 .16.024c.05.02.11.031.168.031h.008v-.086h-.008a.4.4 0 0 1-.16-.031.5.5 0 0 0-.164-.024.5.5 0 0 0-.168.024.5.5 0 0 1-.16.031.4.4 0 0 1-.16-.031.5.5 0 0 0-.168-.024m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.98 10.656a.6.6 0 0 0 .165-.023c.05-.02.109-.028.164-.028.062 0 .125.012.164.028.05.015.109.027.164.027a.4.4 0 0 0 .164-.031.47.47 0 0 1 .324.004c.05.015.105.027.164.027v.074a.5.5 0 0 1-.164-.027.49.49 0 0 0-.324 0 .45.45 0 0 1-.328 0 .47.47 0 0 0-.328.004.5.5 0 0 1-.165.027Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ccc",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.805 10.633a.489.489 0 0 1-.336.004.5.5 0 0 0-.16-.024.4.4 0 0 0-.16.024.5.5 0 0 1-.16.027v.066a.4.4 0 0 0 .152-.027c.05-.02.109-.027.168-.027a.5.5 0 0 1 .168.023.5.5 0 0 0 .16.031.5.5 0 0 0 .16-.03.5.5 0 0 1 .164-.024.5.5 0 0 1 .168.023q.07.029.152.028v-.063a.5.5 0 0 1-.16-.027.4.4 0 0 0-.156-.028.6.6 0 0 0-.16.024m.16-.035a.5.5 0 0 0-.168.023.4.4 0 0 1-.16.031.5.5 0 0 1-.16-.027.5.5 0 0 0-.168-.023.4.4 0 0 0-.168.023.4.4 0 0 1-.16.023h-.008v.094h.007a.4.4 0 0 0 .168-.027.5.5 0 0 1 .16-.027q.084 0 .16.023a.48.48 0 0 0 .337 0 .548.548 0 0 1 .316 0c.05.02.11.031.168.031h.008v-.09h-.008a.5.5 0 0 1-.16-.027.5.5 0 0 0-.164-.027m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.98 10.738a.4.4 0 0 0 .165-.031.47.47 0 0 1 .328.004.5.5 0 0 0 .164.027.4.4 0 0 0 .164-.031.49.49 0 0 1 .324 0c.04.02.102.031.164.031v.075a.5.5 0 0 1-.164-.028.5.5 0 0 0-.164-.027.5.5 0 0 0-.16.027.45.45 0 0 1-.328 0 .496.496 0 0 0-.328 0 .5.5 0 0 1-.165.031v-.082",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#005bbf",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.148 10.71a.4.4 0 0 1-.16.032v.067a.4.4 0 0 0 .153-.032.5.5 0 0 1 .168-.023.5.5 0 0 1 .168.023.5.5 0 0 0 .16.032.5.5 0 0 0 .16-.032.57.57 0 0 1 .332 0q.07.029.152.028v-.063a.4.4 0 0 1-.16-.031.548.548 0 0 0-.316 0 .4.4 0 0 1-.168.031.5.5 0 0 1-.168-.027.5.5 0 0 0-.16-.027.6.6 0 0 0-.16.023m-.168.024v-.004a.4.4 0 0 0 .16-.03.5.5 0 0 1 .169-.024c.058 0 .117.008.168.027.039.016.101.027.16.027a.4.4 0 0 0 .16-.03.5.5 0 0 1 .168-.024.5.5 0 0 1 .164.023.4.4 0 0 0 .16.031h.008v.09h-.008a.5.5 0 0 1-.168-.03.55.55 0 0 0-.316 0 .475.475 0 0 1-.336 0 .55.55 0 0 0-.32 0 .4.4 0 0 1-.169.03h-.007v-.086Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.98 10.89a.5.5 0 0 0 .165-.03.6.6 0 0 1 .164-.024c.054 0 .113.008.164.027a.5.5 0 0 0 .164.028.4.4 0 0 0 .164-.032.6.6 0 0 1 .164-.023.5.5 0 0 1 .16.027c.04.016.102.028.164.028v-.079a.5.5 0 0 1-.164-.027.5.5 0 0 0-.164-.027.5.5 0 0 0-.16.027.45.45 0 0 1-.328 0 .5.5 0 0 0-.164-.027.5.5 0 0 0-.164.027.5.5 0 0 1-.165.031Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ccc",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.96 10.754a.5.5 0 0 1 .169.023c.05.02.105.032.16.028h.008v.093h-.008a.5.5 0 0 1-.168-.03.5.5 0 0 0-.156-.024.4.4 0 0 0-.16.02.4.4 0 0 1-.168.034.5.5 0 0 1-.168-.03.6.6 0 0 0-.16-.024.4.4 0 0 0-.16.02.4.4 0 0 1-.169.034h-.007v-.09h.007a.5.5 0 0 0 .16-.03.5.5 0 0 1 .169-.024.5.5 0 0 1 .168.023.5.5 0 0 0 .16.032.5.5 0 0 0 .16-.032.6.6 0 0 1 .164-.023m.161.035a.55.55 0 0 0-.316 0 .475.475 0 0 1-.336 0 .55.55 0 0 0-.32 0 .5.5 0 0 1-.16.031v.063a.5.5 0 0 0 .152-.028.4.4 0 0 1 .168-.023.5.5 0 0 1 .168.023.47.47 0 0 0 .32 0 .4.4 0 0 1 .168-.023.5.5 0 0 1 .164.023c.039.016.094.028.152.028v-.063a.5.5 0 0 1-.16-.03m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.98 10.969a.4.4 0 0 0 .165-.031.4.4 0 0 1 .164-.024.4.4 0 0 1 .164.027.5.5 0 0 0 .164.024.4.4 0 0 0 .164-.027.4.4 0 0 1 .164-.024q.091 0 .16.024c.04.019.102.03.164.03v-.077a.5.5 0 0 1-.164-.032.6.6 0 0 0-.164-.023.5.5 0 0 0-.16.027.5.5 0 0 1-.164.028.5.5 0 0 1-.164-.028.5.5 0 0 0-.164-.027.5.5 0 0 0-.164.027.5.5 0 0 1-.165.028Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#005bbf",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.96 10.832a.4.4 0 0 1 .169.023q.076.029.16.028h.008v.094h-.008a.4.4 0 0 1-.168-.036.548.548 0 0 0-.316 0 .4.4 0 0 1-.168.032.5.5 0 0 1-.168-.028.6.6 0 0 0-.16-.027.6.6 0 0 0-.16.023.4.4 0 0 1-.169.036h-.007v-.094h.007a.4.4 0 0 0 .16-.028.5.5 0 0 1 .169-.023.5.5 0 0 1 .168.023c.05.02.105.032.16.028a.4.4 0 0 0 .16-.028.5.5 0 0 1 .164-.023m.161.031a.4.4 0 0 0-.16-.02.5.5 0 0 0-.156.024.48.48 0 0 1-.336 0 .55.55 0 0 0-.32 0 .5.5 0 0 1-.16.031v.063a.4.4 0 0 0 .152-.027.5.5 0 0 1 .168-.028c.058 0 .117.008.168.028a.47.47 0 0 0 .32 0 .5.5 0 0 1 .168-.028q.093-.001.164.028c.039.015.094.027.152.027v-.063a.6.6 0 0 1-.16-.035m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.008 10.266-.012.02c0 .046.055.081.125.081h-.969c.067 0 .121-.035.121-.082v-.02Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.266 10.262s.004-.004.007-.004h.735l.004.004q.005.001.004.008l-.008.015c0 .043.047.078.113.078.004 0 .008.004.008.004a.01.01 0 0 1-.008.008h-.969a.01.01 0 0 1-.007-.008s.003-.004.007-.004c.063 0 .11-.035.11-.078h.004v-.02c-.004 0 0-.003 0-.003m-.047.101h.836c-.04-.015-.067-.047-.067-.078v-.004l.008-.008h-.715v.012c0 .031-.027.063-.062.078m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.29 10.219h.694c.028 0 .047.008.047.023 0 .016-.02.024-.043.024h-.699q-.042 0-.043-.024c0-.015.016-.027.043-.027",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.281 10.223c-.015.004-.027.011-.027.02q.001.005.008.01.01.006.027.005h.7q.017.001.023-.004.012-.006.011-.012 0-.006-.011-.012c-.004-.003-.016-.003-.028-.003h-.703Zm.016-.012h-.008c-.027 0-.05.012-.05.031q.002.012.015.024.012.007.035.007h.7q.017 0 .034-.007.014-.012.016-.024a.03.03 0 0 0-.016-.023.1.1 0 0 0-.039-.008Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.156 10.555h.957v-.188h-.96v.188Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.145 10.363h.976v.2h-.976Zm.015.012v.176h.945v-.176Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.195 9.555c.09.043.157.086.149.11-.008.015-.043.03-.082.054-.067.035-.11.101-.075.129a.2.2 0 0 1-.07-.067.14.14 0 0 1-.023-.082.19.19 0 0 1 .097-.144",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.188 9.55h.011c.047.02.086.044.114.063q.018.011.03.028.008.01.009.023a.1.1 0 0 1-.032.027l-.023.012q.001.005-.004.004c-.008.004-.016.012-.027.016a.2.2 0 0 0-.07.066q-.023.036-.005.055l-.011.008a.2.2 0 0 1-.067-.067.14.14 0 0 1-.027-.086.2.2 0 0 1 .027-.082.2.2 0 0 1 .075-.066m.003.012a.2.2 0 0 0-.062.06.15.15 0 0 0-.024.077.1.1 0 0 0 .02.078q.018.03.043.047c-.004-.011.004-.027.012-.043a.2.2 0 0 1 .074-.066q.019-.01.031-.02h.004q.01-.006.02-.011.022-.012.027-.024.002-.005-.008-.015-.008-.012-.027-.024a.6.6 0 0 0-.11-.059m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.293 10.188h.684V7.637h-.68v2.55Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ccc",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.29 7.633h.694v2.562h-.691v-.008h-.004Zm.015 2.547h.664V7.645h-.094v2.535h-.016V7.645h-.058v2.535h-.016V7.645h-.48Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.594 8.594a2.8 2.8 0 0 1 1.027-.07c.406.054.719.175.691.28v.005s.153-.262.153-.27c.027-.113-.317-.25-.77-.309a4 4 0 0 0-.402-.023c-.29 0-.543.027-.695.07v.313",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.293 8.2c.133 0 .27.007.402.027.23.027.43.074.57.132q.107.04.16.086.06.048.048.094v.004q-.004.006-.008.012-.005.013-.016.03c-.015.028-.035.06-.05.095-.02.03-.04.066-.055.09q-.011.018-.016.03l-.008.012-.008-.003.008.004q-.001.004-.008.003a.01.01 0 0 1-.007-.007V8.8q.01-.035-.04-.074a.6.6 0 0 0-.14-.075 2.2 2.2 0 0 0-.504-.12 2.8 2.8 0 0 0-1.023.07l-.004-.012h-.004v-.313s.004-.004.008-.004c.152-.046.406-.074.695-.074m-.688.386a2.8 2.8 0 0 1 1.016-.066c.203.027.383.07.512.12.062.024.113.051.144.079q.037.029.043.062.007-.01.008-.015c.016-.024.035-.059.055-.09.02-.035.035-.07.05-.094q.01-.018.02-.031-.001-.006.004-.012v-.004q.01-.034-.043-.082a.6.6 0 0 0-.156-.086 2.4 2.4 0 0 0-.567-.129 3 3 0 0 0-.398-.027c-.285 0-.535.027-.688.07Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.98 8.91c.192-.012.317-.047.329-.11.015-.046-.047-.1-.164-.148-.047.004-.106.012-.165.012v.25",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.148 8.648a.4.4 0 0 1 .133.075c.031.027.047.05.035.078-.004.035-.043.062-.101.078a.9.9 0 0 1-.235.035h-.007v-.258h.007q.063-.001.122-.008h.043Zm-.16.254a.8.8 0 0 0 .219-.035q.088-.024.094-.066v-.004q.01-.03-.031-.067a.5.5 0 0 0-.125-.07q-.022-.001-.043.004c-.036 0-.075.004-.114.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.293 8.719c-.117.011-.207.031-.246.062l-.008.004c-.023.031.082.102.258.18v-.25",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.14 8.738q.065-.017.153-.027v.004h.012v.262l-.012-.004q-.136-.061-.207-.11a.2.2 0 0 1-.047-.047q-.019-.017-.008-.035l.012-.004a.2.2 0 0 1 .098-.039m.15-.011a.7.7 0 0 0-.145.023.2.2 0 0 0-.094.035l-.008.004q-.002.006.008.024.017.016.047.039.066.047.191.101Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.402 9.402c.02-.039-.164-.125-.425-.195-.122-.031-.215-.066-.34-.105-.36-.125-.633-.266-.598-.313l.004-.008c-.016.012-.05.262-.05.262-.032.047.214.187.546.309.106.039.332.101.438.128.195.051.382.149.367.184Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.047 8.777q.005.001.004.008l-.004.004s-.004.004-.004.008q-.001.006.004.012a.1.1 0 0 0 .027.027c.024.02.067.047.121.074.106.055.266.121.446.184l.074.023c.09.031.168.059.265.082.133.04.243.078.32.114a.4.4 0 0 1 .087.046c.011.008.015.016.023.024a.03.03 0 0 1 0 .023l-.058.254v.004q-.006.005-.012.004c-.004 0-.008-.004-.004-.008v-.004q.001-.001-.004-.008c-.004-.003-.008-.011-.02-.015a.4.4 0 0 0-.078-.051 1.3 1.3 0 0 0-.261-.094 6 6 0 0 1-.438-.133 3 3 0 0 1-.41-.18.5.5 0 0 1-.113-.077.2.2 0 0 1-.028-.032.03.03 0 0 1 0-.023v-.012q.005-.008.004-.027c.004-.024.012-.055.016-.086.004-.035.012-.066.016-.09q.003-.02.007-.031-.001-.006.004-.012v-.004l.004-.004q.006-.006.012 0m-.008.043q-.005.004-.004.008c-.004.027-.012.059-.015.09l-.012.086q-.005.018-.004.031L13 9.043v.004q-.006.005 0 .015.006.014.023.028a.6.6 0 0 0 .11.074c.097.055.242.121.41.18.105.043.332.101.437.133a1.3 1.3 0 0 1 .344.144l.016.016.055-.235q.005-.005 0-.015l-.02-.016a.5.5 0 0 0-.086-.05 2 2 0 0 0-.316-.11 3 3 0 0 1-.266-.082l-.074-.024a4 4 0 0 1-.45-.183 1 1 0 0 1-.12-.078.1.1 0 0 1-.024-.024m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.027 8.477c.024-.075.055-.145.09-.22q-.011.006-.023.005h-.024a1 1 0 0 1-.062.16l-.117-.137-.043.004-.04.004q.09.094.172.187h.047m.258-.218h-.074l-.008.203h.188V8.44c-.036 0-.075.004-.11.004v-.187m.297.035.086.012v-.016l.004-.012-.254-.015v.027h.09l-.024.188h.075Zm.106.203q.016-.002.039.008l.03.004.032-.094h.004l.02.04.043.07c.011 0 .027 0 .039.007l.046.008-.011-.02-.063-.097c.047 0 .082-.012.094-.04q.007-.033-.027-.05a.3.3 0 0 0-.078-.02l-.106-.015Zm.129-.176c.035.008.07.012.07.035v.016c-.012.031-.04.043-.094.031Zm.359.239-.016.066.04.016.034.015.028-.23-.035-.012-.27.125.04.02.073-.043Zm-.078-.051.09-.047-.012.078Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.453 6.414q0 .03.024.047.029.019.062.02c.05 0 .094-.032.094-.067s-.04-.062-.094-.062c-.047 0-.086.027-.086.062m-.008 0c0-.035.043-.066.094-.066.055 0 .098.03.098.066 0 .035-.043.07-.098.07",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.473 5.848c.28 0 .535.03.691.082q.17.053.352.066c.105.012.207.012.289.008.117 0 .28.023.449.082.121.035.23.09.328.156l-.07.047-.016.125-.18.156-.09.063-.218.125-.106.008-.035.07-1.379-.125-1.386.125-.04-.07-.105-.008-.215-.13-.09-.058-.18-.156-.019-.125-.066-.047q.146-.1.328-.156c.164-.059.328-.082.445-.082.082.004.184.004.29-.008q.181-.013.35-.066a2.4 2.4 0 0 1 .673-.082m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.473 5.852a2.3 2.3 0 0 0-.668.082A1.6 1.6 0 0 1 9.449 6a1.5 1.5 0 0 1-.289.008 1.4 1.4 0 0 0-.441.082 1.2 1.2 0 0 0-.324.152l.062.043.023.125.176.156.09.059.215.129.105.008.04.07 1.382-.125 1.375.125.035-.07.11-.012.215-.121.09-.063.18-.156.015-.125.066-.043a1.2 1.2 0 0 0-.32-.152 1.4 1.4 0 0 0-.45-.082A1.5 1.5 0 0 1 11.517 6a1.6 1.6 0 0 1-.356-.066c-.152-.051-.406-.082-.687-.082m-.672.07c.164-.047.394-.078.672-.078.28 0 .535.031.691.078q.17.052.352.07.165.013.289.008c.117 0 .285.023.453.078q.18.06.328.16l.008.004-.074.047-.016.125-.184.156-.09.067-.218.125-.106.008-.031.074-1.387-.125-1.39.125-.04-.074-.105-.004-.215-.133-.09-.063-.18-.156-.023-.125-.066-.047.004-.004a1.2 1.2 0 0 1 .328-.156c.168-.059.332-.082.45-.082h.003c.078.004.18 0 .285-.008q.182-.018.352-.07m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.238a6 6 0 0 1-1.309-.125c-.023 0-.039-.02-.035-.039q0-.011.012-.023c.004-.004.012-.012.023-.012a6.4 6.4 0 0 1 1.309-.125c.512 0 .977.047 1.305.125.023.004.035.02.035.035q.001.03-.04.043a6.6 6.6 0 0 1-1.3.125",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.191 7.043c-.007.004-.011.008-.02.012-.003.008-.007.011-.003.02-.004.01 0 .019.004.023s.008.007.02.007c.331.079.792.125 1.308.125v.012-.008a6.2 6.2 0 0 0 1.297-.125.1.1 0 0 0 .027-.011.1.1 0 0 0 .008-.024q-.001-.018-.031-.031a6.5 6.5 0 0 0-1.301-.125 6.4 6.4 0 0 0-1.309.125m1.309.2a6 6 0 0 1-1.309-.126q-.023 0-.035-.012c-.008-.007-.008-.02-.008-.03q0-.015.012-.028a.1.1 0 0 1 .027-.016c.43-.086.872-.129 1.313-.125.512.004.977.051 1.305.125.03.008.043.028.043.043q0 .016-.012.031-.012.011-.035.016a6.3 6.3 0 0 1-1.301.125Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.496 7.188a6.5 6.5 0 0 1-1.203-.106c.32-.062.738-.102 1.203-.102a6.5 6.5 0 0 1 1.207.102 6.5 6.5 0 0 1-1.207.106m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.457 6.977v.21h-.004v-.21Zm.078 0v.21h-.004v-.21ZM10.32 6.977v.21h-.011v-.21Zm.067 0v.21h-.008v-.21ZM10.2 6.977v.203h-.016v-.203Zm.058 0v.21h-.012v-.21Zm-.117.007v.196h-.012v-.196ZM10.09 6.988v.188h-.016v-.188Zm-.059.004v.176h-.015v-.176ZM9.934 7v.16h-.016V7Zm.046 0v.168h-.015V7Zm-.097.004v.152h-.016v-.152ZM9.832 7.008v.148h-.02v-.148Zm-.043 0v.14h-.023v-.14ZM9.734 7.016v.132h-.023v-.132Zm-.046.007v.118h-.024v-.118Zm-.06.008v.102h-.023V7.03ZM9.578 7.035v.09h-.027v-.09Zm-.05.008v.074H9.5v-.074ZM9.477 7.047v.062h-.032v-.062Zm-.055.012v.043h-.035v-.043ZM9.363 7.07v.024h-.035V7.07ZM10.613 6.977v.207h-.004v-.207Zm.09 0v.207H10.7v-.207Zm.129.007v.196h-.004v-.196Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.496 6.914c-.445-.004-.89.04-1.32.125.027-.008.023-.031-.008-.098-.043-.082-.11-.078-.11-.078a7 7 0 0 1 1.438-.136c.566 0 1.074.054 1.438.136 0 0-.059-.004-.102.078-.035.067-.039.094-.012.102a6 6 0 0 0-1.324-.129m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.094 6.863q.001-.001.008.004c.023.008.05.031.07.07h.004a1 1 0 0 1 .027.075q.001.01-.004.015c.422-.082.86-.125 1.297-.117.508 0 .973.047 1.3.121q-.004-.006-.003-.02a.3.3 0 0 1 .031-.074.14.14 0 0 1 .07-.07q.007-.005.008-.004a7 7 0 0 0-1.406-.129 7 7 0 0 0-1.402.13m2.84.004q-.004-.001-.008.004-.006-.001-.024.004a.15.15 0 0 0-.062.066.3.3 0 0 0-.031.075q-.001.008.004.015 0 .004.011.008l-.008.012c-.324-.078-.8-.13-1.32-.13a6 6 0 0 0-1.32.126l-.004-.012c.004-.004.008-.004.012-.008 0-.004.004-.007 0-.015a.2.2 0 0 0-.024-.07.2.2 0 0 0-.066-.067q-.018-.005-.024-.004-.007-.005-.008-.004H9.06v-.012c.468-.093.953-.14 1.437-.132.566 0 1.074.05 1.441.132Zm-2.875 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.496 6.727a7 7 0 0 0-1.437.136c-.02.004-.047 0-.055-.02Q8.999 6.84 9 6.829q.001-.006.008-.012 0-.005.012-.011c.003 0 .007-.004.015-.004.363-.086.887-.137 1.461-.137.578 0 1.102.05 1.469.137.023.004.035.027.027.043-.008.02-.031.023-.058.02-.364-.083-.871-.134-1.434-.137",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.496 6.668c-.574 0-1.094.055-1.457.137h-.004c-.004.004-.008.004-.012.008q-.005 0-.011.007c0 .004-.004.008-.004.012q-.001.006.004.012c.004.011.027.02.043.011h.004a7 7 0 0 1 1.437-.132v.011a7 7 0 0 0-1.434.133c-.023.008-.058 0-.066-.02v-.003q-.005-.005-.004-.016A.03.03 0 0 1 9 6.812l.012-.011c.008-.004.015-.004.02-.008.366-.082.89-.137 1.464-.137a7 7 0 0 1 1.469.137q.024.006.031.023.011.013.004.032c-.004.007-.016.015-.027.02a.07.07 0 0 1-.04 0 7.5 7.5 0 0 0-1.433-.134v-.011c.563.004 1.07.05 1.438.132q.016.006.027 0 .012-.001.02-.015.005-.007 0-.02c-.008-.008-.012-.011-.024-.015a7 7 0 0 0-1.465-.137M11.668 7.082a6.5 6.5 0 0 0-1.172-.094c-.45 0-.855.035-1.168.094.383.066.774.102 1.168.098.45 0 .86-.04 1.172-.098m-1.172-.105c.406-.004.813.027 1.211.097q.007.001.008.008-.001.005-.008.004c-.32.062-.742.11-1.21.11-.407 0-.813-.036-1.204-.11q-.007.001-.008-.004.001-.007.008-.008a6.5 6.5 0 0 1 1.203-.097m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.094 6.828c0-.02.02-.035.043-.035.031 0 .05.016.05.031 0 .02-.019.035-.05.035a.04.04 0 0 1-.028-.011.02.02 0 0 1-.011-.02",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.098 6.828h-.008q0 .017.015.027l.032.012c.035 0 .058-.02.058-.043 0-.02-.023-.035-.058-.035-.028 0-.051.016-.051.04Zm.039-.027c-.02 0-.035.011-.035.027h.003q0 .011.012.016.007.01.02.008.042-.002.043-.028c0-.011-.016-.023-.043-.023m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.852h-.14c-.024 0-.044-.016-.044-.032 0-.015.02-.03.04-.03h.28c.009-.005.012 0 .02 0a.03.03 0 0 1 .016.007q.007.001.008.008.005.005.004.015c0 .016-.02.032-.047.032Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.652 6.793h-.297c-.015 0-.03.012-.03.027 0 .012.015.028.034.028h.278c.023 0 .039-.012.039-.028q.001-.006-.004-.011a.01.01 0 0 0-.008-.008c-.004-.004-.008-.004-.012-.008m-.015-.012h.02l.019.008.011.016q.005.005.004.015c0 .02-.023.04-.054.04h-.278c-.027 0-.054-.02-.054-.04s.027-.039.05-.039Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.805 6.883-.102.008c-.023 0-.05-.008-.05-.032q.002-.006.003-.011.001-.006.008-.012.005-.007.016-.008.007-.005.015-.004l.098-.008.102-.011c.007 0 .011 0 .02.004l.015.003.011.012c0 .004.004.008.004.012 0 .016-.015.031-.039.035l-.105.012",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#058e6e",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.898 6.813-.105.007-.098.012h-.011c-.008.004-.008.004-.012.008s-.008.004-.008.008-.004.007 0 .011q0 .013.012.02.01.005.027.004l.098-.008.101-.008q.036-.006.036-.031s-.004-.004-.004-.008q-.004-.007-.008-.008c-.004-.004-.008-.004-.016-.008zm-.09.074.098-.008c.028-.004.047-.024.047-.043 0-.004-.004-.008-.004-.016q-.005-.006-.015-.011c-.004-.004-.012-.004-.016-.008h-.023l-.102.008-.098.011h-.02l-.015.012c-.008.004-.008.008-.012.012q-.004.008-.003.015a.03.03 0 0 0 .02.028.1.1 0 0 0 .038.011Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.398 6.887c0-.016.024-.032.047-.032h.02c.004.004.012.004.015.008l.012.012q.002.006.004.012c0 .02-.023.035-.05.035a.04.04 0 0 1-.028-.012q-.011-.007-.016-.02",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46 6.863h-.015c-.02 0-.039.012-.039.024h-.015c0-.02.023-.035.054-.035q.01-.006.02 0a.03.03 0 0 1 .02.007q.01.006.015.012l.004.016c0 .023-.027.043-.059.043l-.035-.012a.1.1 0 0 1-.015-.027h.02q0 .01.007.015.011.01.023.008c.024 0 .04-.012.04-.027v-.012q-.007-.001-.012-.008c-.004 0-.008-.004-.012-.004m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.094 6.95.05-.052.141.016-.11.063Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.14 6.89.165.02-.13.07-.097-.027Zm.008.012-.043.047.067.02.094-.051Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.191 6.883.098.008c.027 0 .05-.008.055-.032v-.011l-.012-.012q-.006-.007-.012-.008-.007-.005-.015-.004l-.106-.008-.097-.011a.06.06 0 0 0-.055.03c0 .017.02.032.043.036Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#058e6e",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.04 6.836q.012-.035.062-.035l.101.008.102.011h.02q.006.006.015.012l.012.012v.015c0 .012-.012.024-.024.028a.07.07 0 0 1-.039.011l-.098-.011-.101-.008c-.031-.004-.05-.024-.05-.043m.019.004q0 .02.03.027l.204.016c.008 0 .02 0 .027-.004.008-.004.016-.012.016-.02v-.011l-.008-.008q-.006-.004-.012-.008h-.015l-.102-.012-.097-.008q-.037.002-.043.028m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.809 6.828c0-.02.023-.035.046-.035.024 0 .047.016.047.031 0 .02-.023.035-.047.035h-.015q-.011-.004-.016-.007c-.008-.004-.008-.008-.011-.012q-.005-.006-.004-.012m.695.063c0-.02.02-.036.043-.036h.015c.008.004.012.004.016.008q.012.006.012.012.005.006.004.012c0 .02-.02.035-.043.035a.1.1 0 0 1-.031-.008c-.008-.008-.016-.016-.016-.023m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.816 6.828q-.001.006.004.012l.008.008c.004 0 .008.004.012.004h.015c.02 0 .04-.012.04-.028 0-.011-.02-.023-.04-.023a.1.1 0 0 0-.027.008.02.02 0 0 0-.012.02m0-.027a.07.07 0 0 1 .04-.012c.027 0 .054.016.054.035 0 .024-.023.043-.055.043q-.009.001-.02-.004c-.007 0-.01-.004-.019-.008l-.011-.011q-.004-.005-.008-.016a.03.03 0 0 1 .02-.027m.746.062h-.015c-.016 0-.035.012-.035.028q0 .009.011.02.011.004.028.003c.02 0 .035-.012.035-.027q.001-.006-.004-.012l-.008-.008c-.004 0-.008-.004-.011-.004m-.019-.011a.03.03 0 0 1 .023 0q.01 0 .02.007l.012.012q.005.008.004.016c0 .023-.024.043-.051.043a.07.07 0 0 1-.04-.012c-.007-.008-.015-.016-.015-.027 0-.024.024-.04.047-.04m.008.078v-.008Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.898 6.95-.05-.052-.137.016.113.063.078-.028",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.852 6.89.054.055-.004.004.004.008-.082.023-.136-.07Zm.035.06-.043-.048-.114.016.094.05ZM10.496 6.973c.492 0 .941.043 1.266.113l-.004.016a6 6 0 0 0-1.262-.118c-.492.004-.93.043-1.258.118l-.004-.016c.329-.07.77-.11 1.262-.113m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.453 6.125.063.035.086-.105a.33.33 0 0 1-.125-.102.2.2 0 0 1-.032-.137c.008-.14.23-.253.512-.253.145 0 .277.03.371.078l.008-.059a.95.95 0 0 0-.379-.074c-.328 0-.578.14-.59.308a.24.24 0 0 0 .028.137.34.34 0 0 0 .109.113l-.05.063",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.957 5.504a1 1 0 0 1 .383.07l.004.004-.012.074-.008-.007a.9.9 0 0 0-.367-.075.85.85 0 0 0-.355.07c-.09.048-.145.11-.149.176a.18.18 0 0 0 .031.133q.043.061.121.098l.008.004-.097.117-.067-.04h.004l-.008-.003.047-.059a.3.3 0 0 1-.105-.109.26.26 0 0 1-.028-.14c.008-.09.075-.169.18-.223a.9.9 0 0 1 .418-.09m-.492.621.047.023.078-.093a.3.3 0 0 1-.121-.102.2.2 0 0 1-.031-.137c.003-.074.062-.14.156-.183a.8.8 0 0 1 .363-.078c.14 0 .27.03.363.074l.008-.043a1 1 0 0 0-.371-.07.9.9 0 0 0-.41.09c-.102.054-.164.128-.172.21a.23.23 0 0 0 .027.133.3.3 0 0 0 .106.114h.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.457 6.125a.4.4 0 0 1-.125-.105.24.24 0 0 1-.05-.137c0-.11.09-.203.234-.266a.28.28 0 0 0-.149.2.24.24 0 0 0 .028.136.34.34 0 0 0 .109.113l-.043.063",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29 5.883q.004.071.05.137a.3.3 0 0 0 .117.097l.035-.05a.3.3 0 0 1-.105-.11.26.26 0 0 1-.028-.14.2.2 0 0 1 .047-.118c.012-.011.02-.023.035-.039-.097.063-.152.14-.152.223m.167.242-.004.004a.35.35 0 0 1-.129-.106.27.27 0 0 1-.05-.14c0-.11.093-.211.238-.274l.008.012a.3.3 0 0 0-.098.086.2.2 0 0 0-.047.11.23.23 0 0 0 .027.132.3.3 0 0 0 .106.114h.004l-.043.07Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.484 6.238a.27.27 0 0 1-.101-.199q.001-.066.039-.125c.09-.14.371-.242.703-.242.09 0 .18.008.258.023q-.025.024-.04.047a1.4 1.4 0 0 0-.218-.015c-.305 0-.559.093-.633.21a.2.2 0 0 0-.031.102q.001.059.031.106c.02.03.051.062.086.082l-.11.14-.062-.039.078-.094",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.688 5.746a.5.5 0 0 0-.258.172.23.23 0 0 0-.04.121c0 .07.036.137.094.188l.008-.016v.043l-.008-.008-.066.082.047.027.105-.125a.3.3 0 0 1-.086-.082.2.2 0 0 1-.03-.109q0-.053.03-.105a.5.5 0 0 1 .235-.153c.113-.039.254-.062.406-.062m.246-.02a1.2 1.2 0 0 0-.246-.02c-.164 0-.316.024-.437.067m-.215.492a.27.27 0 0 1-.098-.199.2.2 0 0 1 .043-.125c.043-.074.137-.137.262-.18s.277-.07.445-.07c.09 0 .184.008.262.024l.011.003-.007.008q-.026.022-.04.043l-.003.004H9.34a1.3 1.3 0 0 0-.215-.016c-.152 0-.29.024-.398.063-.11.039-.192.09-.227.148a.2.2 0 0 0-.031.098q0 .053.031.102c.02.03.05.062.086.082l.004.004-.117.148-.075-.047Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.598 5.773a.45.45 0 0 0-.176.141.25.25 0 0 0-.04.125c0 .078.04.145.102.2l-.07.081a.3.3 0 0 1-.098-.215c0-.132.114-.253.282-.332m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57 5.781c.008-.004.012-.008.024-.011l.008.011-.024.012a.4.4 0 0 0-.148.121.25.25 0 0 0-.04.125c0 .074.04.14.102.195l.004.004-.078.09-.008-.004a.3.3 0 0 1-.101-.219c0-.128.101-.246.261-.324m-.14.114c-.067.062-.106.132-.106.21 0 .075.035.145.09.204l.063-.07a.26.26 0 0 1-.102-.2c0-.043.016-.09.043-.129q.006-.011.012-.015m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.496 5.48c.07 0 .133.04.152.09a1 1 0 0 1 .016.145v.039c0 .113.024.207.05.27l-.222.163-.226-.164a.8.8 0 0 0 .054-.27v-.038c0-.05.008-.102.02-.145.012-.05.082-.09.152-.09",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.492 5.488c-.066 0-.133.035-.144.082a.6.6 0 0 0-.02.145v.039a.7.7 0 0 1-.055.27l.22.156.214-.157a.7.7 0 0 1-.05-.27v-.038a1 1 0 0 0-.016-.145c-.016-.047-.079-.082-.145-.082Zm-.16.078c.012-.05.086-.09.16-.09h.004c.07 0 .14.04.16.09.008.047.016.094.016.149v.039c0 .11.023.207.05.27l.005.003-.235.168-.234-.168v-.004a.8.8 0 0 0 .05-.27v-.038a.6.6 0 0 1 .024-.149m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.496 5.531c.016 0 .035.004.047.012q.024.018.031.035c.008.047.016.094.016.14v.036c0 .105.02.2.047.254l-.145.11-.148-.11a.6.6 0 0 0 .047-.254v-.035a.5.5 0 0 1 .023-.14c.008-.024.04-.044.082-.044",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.488 5.523h.008q.031.002.055.016a.1.1 0 0 1 .031.04 1 1 0 0 1 .016.14v.035c0 .105.02.2.047.254l.003.004-.156.117-.16-.117.004-.004a.6.6 0 0 0 .047-.254v-.035a.5.5 0 0 1 .023-.14c.008-.028.04-.048.082-.052Zm.016.016h-.008c-.039 0-.066.02-.074.04a.5.5 0 0 0-.02.14v.035c0 .105-.02.195-.05.254l.14.101.137-.101a.6.6 0 0 1-.047-.254v-.035a1 1 0 0 0-.016-.14q-.008-.018-.027-.028a.06.06 0 0 0-.035-.012m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.527 6.125-.054.035-.09-.105a.3.3 0 0 0 .125-.102.2.2 0 0 0 .031-.137c-.008-.14-.23-.253-.512-.253a.8.8 0 0 0-.367.078l-.012-.059a.9.9 0 0 1 .38-.074c.324 0 .574.14.59.308a.2.2 0 0 1-.028.137.3.3 0 0 1-.106.113Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.656 5.586c.004.016.008.027.008.043a.9.9 0 0 1 .363-.074c.141 0 .27.03.364.078.093.043.152.11.16.183a.24.24 0 0 1-.035.141.3.3 0 0 1-.125.098l.082.093.047-.023-.047-.062h.004a.3.3 0 0 0 .105-.114.2.2 0 0 0 .027-.133c-.007-.082-.07-.156-.175-.21a.9.9 0 0 0-.407-.09 1 1 0 0 0-.37.07m.371-.082a1 1 0 0 0-.382.07l-.008.004.004.004.011.059v.011l.012-.007a.8.8 0 0 1 .363-.075c.141 0 .262.028.356.07.09.048.144.11.148.176a.18.18 0 0 1-.031.133.27.27 0 0 1-.125.098l-.004.004.098.117.07-.043-.047-.059a.3.3 0 0 0 .106-.109.26.26 0 0 0 .03-.14c-.01-.09-.077-.169-.183-.223a.95.95 0 0 0-.418-.09m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.523 6.125c.114-.062.18-.148.18-.242 0-.11-.094-.203-.23-.266a.3.3 0 0 1 .109.098.23.23 0 0 1 .035.129c0 .086-.05.168-.133.226l.04.059",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.465 5.621.012-.012c.14.063.238.164.238.274 0 .097-.074.183-.184.246h-.004l-.011.004-.043-.067.004-.003c.082-.055.132-.133.132-.22a.24.24 0 0 0-.035-.124.3.3 0 0 0-.11-.098m.062.496c.106-.062.168-.144.168-.234 0-.082-.054-.16-.148-.219q.024.023.043.05a.25.25 0 0 1 .039.13c0 .086-.055.168-.137.226Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.238a.28.28 0 0 0 .098-.156.26.26 0 0 0-.036-.168c-.09-.14-.37-.242-.707-.242q-.128 0-.257.023.03.024.047.047.105-.016.21-.015c.31 0 .563.093.637.21q.03.049.031.102 0 .059-.03.106a.3.3 0 0 1-.09.082l.113.14.058-.039-.074-.094",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.598 5.688a1.44 1.44 0 0 1 .707.046.5.5 0 0 1 .265.18c.032.05.047.113.035.172a.28.28 0 0 1-.093.152l.074.09-.07.047-.125-.148.007-.004a.25.25 0 0 0 .086-.082.2.2 0 0 0 .032-.102.2.2 0 0 0-.032-.098q-.055-.088-.226-.148c-.11-.04-.25-.063-.403-.063q-.105.002-.21.016h-.004l-.004-.004a.2.2 0 0 0-.043-.043l-.012-.008Zm.906.539-.012-.016v.043l.008-.008.063.082-.043.027-.106-.125a.4.4 0 0 0 .086-.082.3.3 0 0 0 .035-.109.2.2 0 0 0-.035-.105.46.46 0 0 0-.234-.153 1.3 1.3 0 0 0-.41-.062m-.208.015q-.014-.017-.035-.035.121-.021.242-.02c.168 0 .32.024.442.067a.5.5 0 0 1 .258.172c.03.05.043.11.035.164a.3.3 0 0 1-.086.145m-.89-.528c-.005-.004-.005-.008-.009-.011l-.007.007.004.004zm.034.035.004.004-.007.004-.004-.008zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.39 5.773a.44.44 0 0 1 .172.141q.041.06.04.125c0 .078-.04.145-.102.2l.066.081a.3.3 0 0 0 .102-.215c0-.132-.11-.253-.281-.332",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.355 5.77h.04q.034.017.062.035c.137.078.219.183.219.3 0 .079-.04.157-.102.22l-.008.003-.074-.09.004-.004a.27.27 0 0 0 .098-.195.2.2 0 0 0-.04-.125.4.4 0 0 0-.105-.101q-.033-.019-.066-.032Zm.204.128.011.012c.028.04.04.086.043.13 0 .077-.043.144-.101.198l.054.07a.3.3 0 0 0 .094-.203.28.28 0 0 0-.101-.207m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.414 6.047c0-.031.035-.059.082-.059.04 0 .078.028.078.059q-.001.012-.008.023c-.004.008-.011.012-.02.02l-.026.012c-.008 0-.02.003-.028 0-.012.003-.023 0-.031 0l-.027-.012c-.008-.008-.012-.012-.016-.02q-.01-.011-.008-.023",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.496 5.992c-.043 0-.074.028-.074.055v.008h-.004c0 .004.004.008.004.011q.007.011.02.016c.003.008.011.008.023.012q.01.005.027.004.011.001.028-.004c.007-.004.015-.004.023-.012.004-.004.012-.008.016-.016q.004-.008.007-.02c0-.026-.035-.054-.07-.054m-.09.047c.004-.031.043-.059.09-.059.043 0 .086.032.086.067q-.001.012-.008.023c-.008.008-.011.016-.02.024l-.03.011q-.016.005-.032.004-.018.001-.035-.004c-.008-.003-.02-.007-.027-.011a.1.1 0 0 1-.02-.024q-.01-.011-.008-.023l-.004-.008Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.414 5.93a.03.03 0 0 1 .008-.02q.005-.012.015-.02l.028-.011q.013-.005.031-.004c.02 0 .04.008.055.016a.05.05 0 0 1 .023.043q-.001.01-.008.023c-.004.008-.011.012-.02.02l-.026.011c-.008 0-.02.004-.028.004-.012 0-.023-.004-.031-.004l-.027-.011a.1.1 0 0 1-.016-.02q-.01-.012-.008-.023m.02-.125c0-.024.027-.043.062-.043s.063.02.063.046c0 .024-.028.043-.063.043s-.062-.02-.062-.043m.015-.113c0-.015.02-.031.047-.031h.016l.02.008q.006.006.007.011.005.006.004.012c0 .02-.02.035-.047.035q-.02 0-.027-.011c-.008-.004-.016-.012-.016-.02m.004-.098c0-.015.016-.027.043-.027.024 0 .031.012.031.027 0 .016-.015.028-.035.028-.023 0-.039-.012-.039-.028m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.496 5.586q-.035.001-.035.02.001.01.008.015c.008 0 .011.004.023.004.008 0 .016-.004.02-.004q.007-.005.008-.016t-.004-.015q-.007-.005-.02-.004m-.05.02c0-.02.019-.036.05-.036q.02 0 .031.012t.008.023q0 .018-.012.024c-.007.008-.02.008-.03.008q-.02.002-.032-.008-.017-.006-.016-.024m.062.07h-.016c-.023 0-.039.011-.039.023h-.015c0-.02.023-.035.05-.035a.03.03 0 0 1 .024 0c.008 0 .011.004.02.008l.011.012c.004.003.004.011.004.015 0 .024-.024.043-.055.043h-.004l-.031-.012c-.008-.007-.016-.015-.016-.027h.016q0 .011.012.016.011.01.023.008c.024 0 .04-.012.04-.028q.001-.006-.005-.011l-.007-.008c-.004 0-.008-.004-.012-.004m-.016.097c-.031 0-.055.016-.055.036h-.015c0-.028.031-.051.07-.051s.074.023.074.054c0 .028-.035.051-.074.051s-.07-.023-.07-.05h.015c0 .019.024.039.055.039s.055-.02.055-.04c0-.023-.024-.039-.055-.039m.004.11h-.027c-.008.004-.02.008-.024.012-.008.003-.011.011-.015.015l-.008.02h-.016q-.002-.012.008-.024a.05.05 0 0 1 .02-.02c.007-.007.02-.011.027-.015.012 0 .023-.004.035-.004q.035.001.059.02c.015.011.027.031.027.047 0 .007-.004.02-.008.027l-.02.02c-.011.003-.019.011-.03.011q-.016.005-.032.004-.018.001-.035-.004c-.008 0-.02-.008-.027-.012q-.013-.008-.02-.02c-.008-.007-.008-.019-.008-.026h.016q-.001.011.004.02c.004.007.012.01.02.019q.005.006.023.007.01.005.027.004.011.001.028-.004.01 0 .023-.007c.004-.008.012-.012.016-.02q.004-.007.007-.02a.04.04 0 0 0-.023-.035c-.012-.011-.031-.015-.047-.015m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.5 6.395.05.003a.2.2 0 0 0-.003.075.17.17 0 0 0 .11.109q.046.019.093.02a.3.3 0 0 0 .121-.028.16.16 0 0 0 .074-.078s.016-.05.028-.05c.007 0 .007.058.011.058.012.074.102.125.204.125a.3.3 0 0 0 .085-.012.2.2 0 0 0 .067-.039.14.14 0 0 0 .043-.055c.012-.02.012-.043.012-.062l.058-.047.04.063a.1.1 0 0 0-.02.062c0 .02.004.035.015.055a.1.1 0 0 0 .043.047q.03.018.063.03.036.014.074.009a.3.3 0 0 0 .094-.016.2.2 0 0 0 .07-.047l.043-.039v.05c0 .048.027.095.09.099 0 0 .074.003.168-.051q.082-.047.152-.106l.008.059s-.082.094-.164.129a.33.33 0 0 1-.184.035.16.16 0 0 1-.125-.082.4.4 0 0 1-.148.031.35.35 0 0 1-.156-.035.25.25 0 0 1-.11-.09.44.44 0 0 1-.23.07 1 1 0 0 1-.121-.023.4.4 0 0 1-.102-.059.409.409 0 0 1-.344.035.3.3 0 0 1-.109-.07.4.4 0 0 1-.11.07.4.4 0 0 1-.14.024.37.37 0 0 1-.207-.059.4.4 0 0 1-.098.06.6.6 0 0 1-.125.022.5.5 0 0 1-.125-.019.3.3 0 0 1-.101-.05.25.25 0 0 1-.11.089.36.36 0 0 1-.304.004.18.18 0 0 1-.13.086.33.33 0 0 1-.175-.04.5.5 0 0 1-.168-.132l.008-.055s.055.047.148.106c.098.054.172.05.172.05.063-.003.09-.05.09-.097v-.05l.043.038c.016.02.043.035.07.047a.2.2 0 0 0 .094.016c.105 0 .195-.063.195-.14a.1.1 0 0 0-.02-.063l.032-.063.066.047v.016q-.001.035.016.058.017.029.047.05a.245.245 0 0 0 .14.043c.106 0 .196-.054.208-.124 0 0 0-.059.007-.059.008 0 .028.055.028.051a.2.2 0 0 0 .078.078.3.3 0 0 0 .121.028q.047-.002.094-.016a.2.2 0 0 0 .07-.047.13.13 0 0 0 .04-.066.12.12 0 0 0-.009-.075Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.5 6.387.063.008-.004.007a.13.13 0 0 0-.004.067.17.17 0 0 0 .105.11.2.2 0 0 0 .09.015c.04 0 .082-.008.113-.028a.15.15 0 0 0 .075-.07v-.004c.003 0 .003-.004.003-.004 0-.008.004-.011.008-.02a.03.03 0 0 1 .008-.019q-.001-.004.004-.008h.004q.001-.004.008-.003.004 0 .007.003v.004s.004.004.004.008q-.001.007.004.02v.023h.004v.008c.012.07.098.117.195.117a.3.3 0 0 0 .083-.012.2.2 0 0 0 .066-.035q.025-.022.039-.05c.012-.024.012-.044.012-.063v-.004l.07-.055.043.075a.1.1 0 0 0-.02.062q-.001.026.016.05.014.03.04.048a.2.2 0 0 0 .062.027.2.2 0 0 0 .07.012.3.3 0 0 0 .09-.016.2.2 0 0 0 .066-.047l.059-.054v.07q-.002.034.02.062.018.025.062.032h.012q.011-.001.035-.008a.3.3 0 0 0 .113-.043q.082-.052.152-.106l.012-.011.012.074-.004.004-.004.004-.008.011a.3.3 0 0 0-.039.036c-.031.027-.07.062-.113.082q-.043.016-.09.027-.048.013-.098.008a.17.17 0 0 1-.129-.082.4.4 0 0 1-.144.027.4.4 0 0 1-.16-.031.3.3 0 0 1-.11-.09.3.3 0 0 1-.097.05.5.5 0 0 1-.13.016.3.3 0 0 1-.124-.023.3.3 0 0 1-.098-.055.36.36 0 0 1-.203.059.4.4 0 0 1-.145-.027.3.3 0 0 1-.105-.067.4.4 0 0 1-.105.067.5.5 0 0 1-.145.023.34.34 0 0 1-.207-.055.3.3 0 0 1-.098.055.3.3 0 0 1-.125.023.4.4 0 0 1-.125-.015.3.3 0 0 1-.101-.051.3.3 0 0 1-.106.09.4.4 0 0 1-.164.031.4.4 0 0 1-.14-.027.2.2 0 0 1-.13.086h-.003a.4.4 0 0 1-.094-.012q-.048-.011-.086-.027a.5.5 0 0 1-.121-.082q-.023-.026-.035-.04l-.012-.011q.001-.002-.004-.004l.008-.004-.008.004v-.004l.008-.07.016.011q.004.001.007.008.011.007.028.02.04.03.11.078.074.039.12.043.024.007.035.008h.012a.1.1 0 0 0 .063-.032q.018-.029.02-.062v-.07l.054.054q.03.03.07.047a.3.3 0 0 0 .09.016c.102 0 .188-.063.188-.137a.1.1 0 0 0-.02-.062h-.004l.04-.075.077.055v.02q.002.03.016.058a.2.2 0 0 0 .043.047q.029.018.062.031.037.007.075.008c.101 0 .187-.05.199-.117v-.032q-.001-.012.004-.019v-.008c0-.004.004-.004.004-.004q.001-.004.007-.003.007 0 .008.003h.004c0 .004.004.004.004.008q.007.01.008.02.007.01.008.015v.004l.004.004h-.012l-.004.004h.016c.015.027.039.055.074.07q.053.029.117.028a.2.2 0 0 0 .09-.016.2.2 0 0 0 .07-.043c.016-.02.031-.039.035-.062a.1.1 0 0 0-.008-.07l-.003-.008Zm-1.465.34v.007H9.02c-.008 0-.02-.004-.036-.004a.5.5 0 0 1-.125-.05 2 2 0 0 1-.113-.075c-.008-.011-.02-.015-.023-.023l-.008.043h.004q.001.006.008.012c.007.011.023.023.035.039a.5.5 0 0 0 .117.078q.034.02.082.027.047.013.09.008a.16.16 0 0 0 .12-.082l.005-.008.008.004c.043.02.093.031.14.031h.004c.05 0 .106-.011.152-.03a.3.3 0 0 0 .106-.09l.004-.009.008.004a.32.32 0 0 0 .222.07.3.3 0 0 0 .121-.023.3.3 0 0 0 .098-.054l.004-.004.008.004a.402.402 0 0 0 .336.031.3.3 0 0 0 .105-.067l.008-.007.008.007q.04.042.105.07.065.024.137.024c.074 0 .145-.02.2-.058l.007-.004.004.004a.3.3 0 0 0 .098.054q.058.024.117.024a.4.4 0 0 0 .12-.016.3.3 0 0 0 .102-.055l.008-.004.008.008a.3.3 0 0 0 .106.09q.07.03.152.031c.05 0 .101-.011.144-.03l.008-.005.004.008c.02.04.063.074.121.082a.2.2 0 0 0 .09-.008.3.3 0 0 0 .086-.027c.04-.02.078-.05.11-.078l.035-.035.011-.012v-.004l-.004-.043a1 1 0 0 1-.14.098l-.004-.004.004.004a.5.5 0 0 1-.121.05c-.016 0-.032.004-.04.004h-.011v-.007.007h-.004a.12.12 0 0 1-.074-.039.1.1 0 0 1-.024-.066v-.031l-.023.023a.2.2 0 0 1-.078.05.27.27 0 0 1-.238-.027.3.3 0 0 1-.044-.046.1.1 0 0 1-.015-.059q-.002-.034.02-.062l-.032-.055-.05.039c0 .023 0 .043-.012.066a.14.14 0 0 1-.043.055.2.2 0 0 1-.075.04c-.027.007-.054.015-.085.01-.106 0-.2-.05-.211-.128q-.005.001-.004-.004v-.02s-.004-.003-.004-.007V6.46c0 .004-.004.008-.004.012q-.007.01-.008.015.001.007-.004.008V6.5a.2.2 0 0 1-.078.078.3.3 0 0 1-.125.027.3.3 0 0 1-.098-.015.2.2 0 0 1-.074-.047.2.2 0 0 1-.039-.07.13.13 0 0 1 .004-.067l-.043-.008-.043.008q.011.03.004.067a.13.13 0 0 1-.04.07.249.249 0 0 1-.172.063.26.26 0 0 1-.124-.028.17.17 0 0 1-.078-.078h-.004v-.004l-.004-.004v-.004q-.001-.005-.008-.015c0-.004-.004-.008-.004-.016q-.005.011-.004.016v.031c-.011.074-.105.129-.214.129a.2.2 0 0 1-.079-.008.2.2 0 0 1-.117-.086.1.1 0 0 1-.015-.062V6.46l-.055-.04-.027.056c.011.015.02.039.02.062 0 .082-.095.149-.204.149a.3.3 0 0 1-.098-.016.2.2 0 0 1-.074-.05l-.027-.024v.03a.106.106 0 0 1-.098.106Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.918 6.586c.012-.024 0-.05-.023-.055a.054.054 0 0 0-.067.04c-.012.023 0 .05.02.054.027.008.058-.008.07-.04m-.902-.129c.007-.027-.008-.05-.036-.055s-.05.016-.054.043c-.004.032.011.055.039.059.027 0 .05-.02.055-.047m-1.043 0c-.004-.027.015-.05.043-.055.023-.004.05.016.054.043.004.032-.015.055-.043.059a.06.06 0 0 1-.054-.047m-.903.133q-.014-.042.031-.063c.024-.004.051.012.067.043.012.024 0 .051-.027.059-.024.004-.051-.012-.067-.04",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.047 6.418q-.011-.013-.027-.008c-.024 0-.036.02-.032.047 0 .023.024.04.043.04q.017 0 .028-.013.007-.017.007-.035a.06.06 0 0 0-.02-.031m.012-.008q.017.012.023.035a.1.1 0 0 1-.012.043q-.011.019-.039.02c-.031 0-.058-.02-.062-.051s.015-.055.05-.059q.023-.005.04.012m.921-.012c.016 0 .032.008.04.02q.01.016.003.039h.004a.06.06 0 0 1-.058.05h-.004a.05.05 0 0 1-.04-.019.05.05 0 0 1-.007-.043q.001-.023.02-.035a.04.04 0 0 1 .042-.012m.032.059-.004-.004a.04.04 0 0 0-.004-.031c-.004-.008-.016-.012-.027-.012q-.011-.005-.028.008a.06.06 0 0 0-.015.031q-.002.018.007.035c.004.008.016.012.028.012.015 0 .039-.016.043-.039m-1.907.078q-.032.012-.023.055l-.016.004c-.007-.032 0-.059.036-.07a.08.08 0 0 1 .078.042.07.07 0 0 1 0 .04q-.007.022-.032.027c-.03.004-.062-.012-.074-.04l.012-.003c.012.023.039.035.059.031.007 0 .015-.008.02-.016a.05.05 0 0 0 0-.035c-.013-.027-.04-.039-.06-.035m2.79-.012a.05.05 0 0 1 .03.028q.014.016 0 .039a.1.1 0 0 1-.03.035.07.07 0 0 1-.047.008c-.016-.004-.024-.016-.032-.028a.05.05 0 0 1 .004-.039.06.06 0 0 1 .032-.035q.018-.01.043-.008m-.036.02c-.011.004-.02.016-.023.027q-.005.019-.004.032.007.016.02.015c.007.004.02.004.03-.004a.05.05 0 0 0 .028-.027q.012-.02 0-.031-.004-.017-.02-.016-.012-.007-.03.004m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.469 6.133a.2.2 0 0 1 .097.094s0-.004.032-.016c.023-.012.043-.012.043-.012l-.008.043c-.004.012-.004.047-.016.074a.14.14 0 0 1-.023.055c-.012-.004-.02-.012-.031-.012q-.018-.005-.036-.004l-.035.012a.1.1 0 0 0-.023.02s-.028-.02-.047-.043l-.05-.07-.028-.036h.043l.043.008a.13.13 0 0 1 .039-.113",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.469 6.14a.12.12 0 0 0-.031.106v.012l-.012-.004-.004-.004h-.008q-.005-.004-.027-.008h-.032l.024.031.047.067.031.031c.004.004.008.004.012.008q.006-.011.02-.016a.07.07 0 0 1 .038-.011c.012-.004.024 0 .04 0l.023.011q.012-.022.02-.05c.007-.012.007-.028.011-.04v-.019q.005-.006.004-.012l.008-.035h-.004q-.011.001-.027.008c-.016.008-.02.012-.024.012 0 .003-.004.003-.004.003h.004v-.003l-.02.003a.2.2 0 0 0-.09-.09m.004-.007-.008-.004a.15.15 0 0 0-.047.11c-.004-.005-.016-.005-.027-.009h-.063l.035.047.051.07.031.032q.011.006.016.012h.004l.008.007.004-.007a.04.04 0 0 1 .023-.02.1.1 0 0 1 .027-.008h.032l.027.012.008.008.008-.008q.018-.03.023-.059c.008-.015.008-.03.012-.043v-.011s.004-.004.004-.008v-.008l.011-.05h-.011v.003-.004h-.012q-.018.001-.035.008a.1.1 0 0 0-.024.012.2.2 0 0 0-.097-.086Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.488 6.46a.1.1 0 0 1-.027-.034c0-.008-.004-.016 0-.024q.001-.006.008-.02l-.078-.019c-.028-.008-.082-.008-.098-.008h-.05l.015.02.02.023a.23.23 0 0 0-.126.067.3.3 0 0 0 .149.031l-.008.027v.02l.043-.012c.016-.008.062-.02.09-.031.035-.02.062-.04.062-.04m.121-.015c.008-.011.012-.027.008-.039a.06.06 0 0 0-.027-.035s.027-.023.058-.039l.098-.031.04-.012v.016l-.009.03a.3.3 0 0 1 .153.032.24.24 0 0 1-.13.063c.012.015.02.03.036.047h-.05c-.016 0-.071 0-.098-.012-.043-.004-.083-.02-.083-.02",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.793 6.277v.032l-.004.02a.26.26 0 0 1 .145.03l.007.004-.004.008a.23.23 0 0 1-.124.063c.007.015.019.027.027.039l.012.007h-.114a.3.3 0 0 1-.054-.007q-.031-.008-.055-.016-.013-.002-.02-.004-.004-.005-.007-.004l.003-.008h-.003q.012-.017.007-.035a.05.05 0 0 0-.027-.031v-.004h.008l-.008-.004c.004 0 .004-.004.004-.004l.016-.011q.018-.011.043-.028l.097-.031Zm-.191.094q.018.012.023.035c.004.012 0 .024-.004.035.004 0 .008.004.012.004q.024.008.055.016h.003c.012.004.032.004.051.008h.078a.2.2 0 0 1-.027-.035l-.004-.008h.012a.24.24 0 0 0 .117-.059.3.3 0 0 0-.14-.027h-.012l.011-.035v-.008l-.03.008-.095.03q-.022.015-.039.028-.006.004-.011.008m-.372-.02h.11c.015 0 .039 0 .055.004l.085.028-.003.004c-.004.008-.008.011-.008.02v.015c.004.016.011.023.027.031l.008.004-.008.008q-.005-.001-.004.004-.005.001-.015.008c-.012.007-.028.02-.047.027a.2.2 0 0 1-.051.02c-.004.003-.012.003-.016.003l-.023.008h-.004l-.05.02V6.52l.003-.016a.4.4 0 0 1-.14-.031l-.004-.004.003-.008a.22.22 0 0 1 .114-.066l-.012-.016Zm.247.11a.1.1 0 0 1-.024-.035.03.03 0 0 1 0-.024c0-.004.004-.007.004-.015l-.066-.02c-.016 0-.036-.004-.055-.004h-.078l.004.008.027.031h-.012a.23.23 0 0 0-.113.063.3.3 0 0 0 .137.027l.011-.004-.011.035v.012l.031-.008c.004-.004.016-.007.023-.011q.01.001.02-.004c.016-.004.035-.012.047-.016q.024-.017.043-.027.012-.007.012-.008m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45 6.414c0-.035.038-.062.09-.062.054 0 .093.027.093.062s-.04.066-.094.066a.1.1 0 0 1-.062-.02c-.016-.01-.028-.026-.028-.046m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.457 6.414c0 .016.012.031.027.043.012.012.036.02.055.02.05 0 .086-.032.086-.063s-.035-.059-.086-.059c-.043 0-.082.028-.082.06m-.016 0c0-.039.043-.07.098-.07.059 0 .102.031.102.07s-.043.074-.102.074",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.496 6.027a.18.18 0 0 1 .082.121s.008-.007.04-.015c.034-.012.05-.004.05-.004l-.02.043c-.011.012-.02.05-.039.082q-.016.03-.039.055-.017-.011-.035-.016c-.012-.004-.027-.008-.039-.004a.13.13 0 0 0-.07.02s-.024-.02-.043-.055c-.02-.031-.028-.07-.035-.082l-.024-.043s.024-.004.051.004c.035.008.043.015.043.015.004-.046.035-.09.082-.125",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.496 6.035a.16.16 0 0 0-.07.117l-.004.016-.012-.016s-.004 0-.004-.004c-.008 0-.015-.003-.031-.007h-.004q-.018-.007-.031-.008h-.004l.02.035a.03.03 0 0 0 .007.016q-.001.005.004.011v.008l.024.047c.007.02.02.031.027.04q.007.005.008.01a.15.15 0 0 1 .07-.019q.018-.001.043.004.017.005.027.016a.2.2 0 0 0 .036-.051.1.1 0 0 0 .023-.047c0-.004.004-.004.004-.008s.004-.008.004-.011q.004-.008.008-.016l.015-.035q-.012-.001-.035.004a.1.1 0 0 0-.031.011l-.004.004h-.004l-.012.016v-.016a.2.2 0 0 0-.074-.117m.004-.012-.008-.003a.2.2 0 0 0-.082.117c-.008 0-.015-.004-.031-.008q-.025-.007-.04-.008h-.019l.004.008-.004-.008-.008.004.028.05.008.013q-.001.005.004.011v.008l.023.047q.017.03.027.043c.008.004.008.008.012.012l.004.003.008.008.004-.008a.12.12 0 0 1 .066-.019q.018-.001.035.004.02.008.031.016l.008.007.004-.008a.2.2 0 0 0 .043-.058.1.1 0 0 0 .024-.047c0-.004.004-.008.004-.008q.002-.006.003-.011.005-.012.004-.012h.004l.02-.051-.004-.004-.004.008.004-.008h-.016q-.015-.001-.043.004l-.031.012a.2.2 0 0 0-.082-.114m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.43 6.395a.05.05 0 0 1-.024-.043q0-.025.024-.043s-.043-.02-.082-.036c-.032-.011-.09-.015-.106-.02l-.055-.01.004.023.016.03a.27.27 0 0 0-.16.056.3.3 0 0 0 .164.058l-.02.031-.007.02.058-.008.106-.023Zm.136 0a.06.06 0 0 0 .02-.043.06.06 0 0 0-.02-.043s.04-.02.082-.036c.032-.011.09-.015.106-.02l.055-.01-.012.023a.1.1 0 0 1-.016.03.3.3 0 0 1 .164.056.3.3 0 0 1-.164.058l.016.031.012.02-.055-.008-.106-.023c-.03-.008-.058-.024-.082-.035m.961-.262a.18.18 0 0 0-.097.094l-.028-.016c-.027-.012-.047-.012-.047-.012l.008.043.012.074.031.055c.008-.004.02-.012.031-.012q.018-.005.036-.004l.03.012a.04.04 0 0 1 .024.02l.051-.043.05-.07.028-.036h-.05c-.028.004-.036.008-.036.008a.13.13 0 0 0-.043-.113m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.531 6.121.004.008q.048.046.043.105.011.001.027-.004h.067l-.04.047-.046.07-.059.051-.007-.007a.05.05 0 0 0-.02-.02.1.1 0 0 0-.031-.008h-.031l-.028.012-.008.008-.035-.067-.012-.07-.007-.05h.007v.003-.004h.016q.012.001.035.008l.02.016q.031-.059.097-.094Zm-.164.086.004.035.016.07.023.051.024-.011c.011 0 .027-.004.039 0 .011 0 .027.003.035.011q.011.005.023.016l.04-.04.05-.066.02-.03h-.036q-.018.003-.023.007h-.008l-.015.016.004-.02a.13.13 0 0 0-.036-.105.17.17 0 0 0-.09.09l-.003.007-.036-.023q-.018-.007-.03-.008m-.547.027-.015.032q0 .016-.012.027a.3.3 0 0 1 .16.055l.004.004-.004.007a.3.3 0 0 1-.16.055l.027.055-.07-.008-.105-.024a1 1 0 0 1-.086-.039l-.008-.003.008-.004a.05.05 0 0 0 .02-.04c0-.011-.009-.027-.02-.038h-.004v-.004h.011l-.007-.004h.004q.002-.005.003-.004c.004-.004.012-.004.02-.008a1 1 0 0 1 .059-.023c.015-.008.039-.012.058-.016q.02-.002.031-.004c.008 0 .012-.004.016-.004Zm-.242.079.016-.012c.015-.004.035-.016.054-.02h.004c.012-.008.036-.011.055-.015.012 0 .02-.004.027-.004h.004q.011.001.016-.004l.043-.004-.008.012c-.004.007-.008.02-.016.027l-.003.008.011.004c.059 0 .114.02.153.047a.3.3 0 0 1-.153.05h-.011l.02.04.003.011-.04-.008-.105-.02-.07-.03a.1.1 0 0 0 .016-.043.06.06 0 0 0-.016-.04m-.402-.079.066.012.016.004h.004c.008 0 .02.004.027.004q.031.005.063.016.03.01.054.023c.008.004.016.004.02.008q.004-.001.008.004l.007.004-.007.003a.1.1 0 0 0-.016.02q-.005.007-.004.02.001.022.02.039l.007.004-.09.043-.109.023-.07.008.012-.032.015-.023a.3.3 0 0 1-.156-.055l-.008-.007.008-.004a.3.3 0 0 1 .152-.059l-.011-.023Zm.242.075-.02-.008c-.015-.004-.035-.016-.054-.02-.016-.008-.04-.011-.059-.015-.008 0-.02-.004-.027-.004q-.013.001-.02-.004l-.043-.008.004.016.02.039h-.012c-.055 0-.11.02-.148.047a.3.3 0 0 0 .152.05h.016l-.028.04-.004.011.043-.008.106-.02.074-.034a.05.05 0 0 1-.02-.036v-.003q-.001-.012.004-.024a.1.1 0 0 1 .016-.02m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.508 6.46a.1.1 0 0 0 .027-.034q.008-.022-.008-.043l.075-.02c.035-.008.082-.008.101-.008h.047l-.008.02-.023.023c.05.008.094.036.125.067a.27.27 0 0 1-.149.031l.008.027v.02l-.039-.012-.094-.031q-.034-.02-.062-.04m-.117-.015a.06.06 0 0 1-.016-.039.1.1 0 0 1 .031-.035s-.031-.023-.062-.039a1 1 0 0 0-.09-.031l-.043-.012v.016c0 .015.012.03.012.03a.3.3 0 0 0-.153.032.2.2 0 0 0 .121.063l-.015.027q-.006.007-.012.02h.047c.02 0 .07 0 .101-.012.04-.004.079-.02.079-.02m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.203 6.277.055.016a.2.2 0 0 0 .043.012l.047.02q.03.015.047.027l.011.011.004.004.008.008-.008.004c-.012.004-.02.016-.023.027q-.005.018.008.035l.007.004-.007.004h-.004s-.004 0-.004.004c-.004 0-.012.004-.02.004q-.018.008-.055.016a.2.2 0 0 1-.054.007h-.106l.004-.007.012-.02.012-.02a.23.23 0 0 1-.117-.062l-.004-.008.007-.004a.3.3 0 0 1 .141-.03c0-.009-.004-.013-.004-.024Zm.024.055.007.008h-.015a.3.3 0 0 0-.137.027.2.2 0 0 0 .113.059h.008l-.02.035q-.003.001-.007.008h.082q.032-.004.05-.008.031-.005.055-.016l.016-.004a.06.06 0 0 1-.012-.035.06.06 0 0 1 .028-.035q-.006-.004-.012-.008c-.012-.008-.028-.02-.043-.027l-.047-.02a.2.2 0 0 1-.043-.011l-.027-.008v.008q-.001.012.004.02v.007m.378.035-.066.02a.05.05 0 0 1 .004.039.1.1 0 0 1-.023.035q.024.018.054.035l.094.031.027.008v-.012l-.008-.035.012.004a.3.3 0 0 0 .133-.027.23.23 0 0 0-.117-.063l-.012-.004.031-.027.004-.008h-.035a1 1 0 0 0-.098.004m.098-.015h.059l-.012.027-.02.016q.078.018.122.066l.003.008-.007.004a.3.3 0 0 1-.141.03l.008.017v.035l-.055-.02-.094-.031a.3.3 0 0 1-.062-.04l-.008-.003.008-.008a.06.06 0 0 0 .023-.031.04.04 0 0 0-.004-.035l-.007-.004.086-.028c.03-.003.082-.003.101-.003m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.363 6.414c0-.035.043-.062.09-.062.055 0 .098.027.098.062s-.043.066-.098.066a.1.1 0 0 1-.062-.02.07.07 0 0 1-.028-.046m1.02.145c-.024-.016-.067-.012-.098.011-.035.02-.043.051-.023.067.023.015.066.015.097-.004.036-.024.043-.055.024-.074m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.371 6.414a.07.07 0 0 0 .027.043q.025.019.055.02c.05 0 .086-.032.086-.063s-.035-.059-.086-.059c-.043 0-.082.028-.082.06m-.016 0c0-.039.047-.07.098-.07.059 0 .106.031.106.07s-.047.074-.106.074m.883.055q.032 0 .05.012c.028.023.016.058-.019.082a.2.2 0 0 1-.058.02c-.02 0-.04-.005-.051-.016a.03.03 0 0 1-.012-.036.1.1 0 0 1 .031-.043.2.2 0 0 1 .059-.019m.004.012a.1.1 0 0 0-.05.02.07.07 0 0 0-.028.03c-.004.012 0 .024.008.028q.01.013.039.008a.08.08 0 0 0 .046-.016c.032-.02.036-.047.02-.062a.1.1 0 0 0-.035-.008m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.254 6.602c0-.012.016-.024.031-.032.031-.023.082-.027.098-.011l.008.011s.046-.066.101-.093c.055-.024.149-.016.149-.016a.06.06 0 0 0-.012-.035.1.1 0 0 0-.027-.031q-.017-.013-.04-.02-.021-.007-.05-.008c-.04 0-.082.016-.102.04l-.012-.036s-.058.012-.082.059c-.023.05 0 .125 0 .125s-.011-.032-.03-.055q-.05-.034-.11-.055l-.055-.023v.047a.5.5 0 0 0-.164.015.18.18 0 0 0 .11.07l-.036.028-.02.016.06.004c.015 0 .074.011.109.007q.04-.001.074-.007m-3.512 0q-.006-.019-.031-.032c-.031-.023-.078-.027-.098-.011q-.007.005-.008.011s-.043-.066-.101-.093c-.055-.024-.145-.016-.145-.016q0-.037.036-.066a.16.16 0 0 1 .085-.028c.043 0 .082.016.106.04l.012-.036s.054.012.082.059c.027.05 0 .125 0 .125s.015-.032.035-.055.074-.043.101-.055l.059-.023a.1.1 0 0 0 0 .047.5.5 0 0 1 .164.015.18.18 0 0 1-.11.07l.036.028.015.016-.05.004c-.02 0-.078.011-.114.007q-.033-.001-.074-.007m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.512 6.363q.029-.002.05.008a.1.1 0 0 1 .047.02.1.1 0 0 1 .028.03.1.1 0 0 1 .011.04v.008M8.48 6.375a.12.12 0 0 0-.082.027.06.06 0 0 0-.03.055h.003q.017-.005.04-.004c.03.004.07.008.1.02a.2.2 0 0 1 .071.058c.012.008.016.016.023.024a.1.1 0 0 1 .051-.012q.011-.001.016.004-.001-.004.004-.008c0-.008.004-.016.004-.027a.14.14 0 0 0-.008-.078.1.1 0 0 0-.047-.047c-.012-.004-.016-.004-.023-.008l-.008.043-.012-.012a.17.17 0 0 0-.102-.035m.118-.004v-.004h.011c.004.004.012.004.024.012q.03.01.055.05a.2.2 0 0 1 .011.079q.001-.006.008-.012a.2.2 0 0 1 .05-.031.3.3 0 0 1 .056-.024l.07-.03v.05a.4.4 0 0 1 .16.02h.008l-.004.007a.2.2 0 0 1-.102.07l.028.02.023.024-.066.007h-.02c-.004 0-.008.004-.008.004H8.88q-.031.005-.063.004-.036-.004-.074-.008h-.004l-.004-.004a.1.1 0 0 0-.027-.03c-.016-.013-.035-.016-.05-.02a.1.1 0 0 0-.04.008c0 .003-.004.007-.004.007l-.004.004h-.004V6.57h-.011q.001-.007-.004-.008l-.02-.027a.2.2 0 0 0-.07-.05.2.2 0 0 0-.09-.016h-.058V6.46c0-.024.011-.05.035-.07a.16.16 0 0 1 .093-.028q.06.001.102.032l.008-.032.008.004Zm.09.18q.003-.006.007-.012.011-.018.028-.035c.007-.012.027-.02.043-.031l.054-.02.047-.02a.05.05 0 0 0 0 .036v.008h.008c.05-.008.105 0 .152.011a.2.2 0 0 1-.101.063l-.012.004.047.03.004.009-.04.004h-.027a.04.04 0 0 1-.02.004c-.023 0-.046.003-.058 0h-.004q-.03.001-.066-.004a.2.2 0 0 0-.035-.035zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.617 6.563c.02-.02.063-.016.094.007.035.02.039.051.023.067-.023.02-.066.015-.097-.004-.035-.024-.043-.055-.024-.074m1.793-.207c0-.036.04-.063.094-.063.05 0 .09.027.09.063 0 .03-.043.066-.094.066a.1.1 0 0 1-.062-.02.05.05 0 0 1-.028-.046m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.414 6.352q0 .023.024.043.023.018.058.02c.047 0 .086-.032.086-.063 0-.032-.035-.059-.082-.059-.05 0-.086.027-.086.059m-.016 0c0-.04.043-.07.102-.07.055 0 .098.03.098.07 0 .035-.043.074-.102.074m-1.836.129a.07.07 0 0 0-.039.011l-.004-.003c-.015.015-.012.042.024.062.03.023.07.023.09.008.011-.012.007-.04-.024-.059-.016-.011-.035-.015-.047-.02m-.05.004q.018-.017.05-.016.031.004.055.02c.039.023.047.058.027.078-.031.023-.074.02-.11-.004-.038-.024-.05-.059-.027-.082Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.305 5.352c0-.075.082-.133.191-.133.102 0 .184.062.184.133a.1.1 0 0 1-.016.054.14.14 0 0 1-.039.043.2.2 0 0 1-.062.028.2.2 0 0 1-.067.011.4.4 0 0 1-.07-.008.2.2 0 0 1-.063-.03.2.2 0 0 1-.043-.044.2.2 0 0 1-.015-.054m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#005bbf",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.313 5.352c0 .02.003.035.015.054a.214.214 0 0 0 .098.07.4.4 0 0 0 .07.008.2.2 0 0 0 .066-.011c.02-.004.04-.016.06-.028a.2.2 0 0 0 .038-.043.1.1 0 0 0 .012-.05c0-.067-.078-.13-.176-.13-.105 0-.184.06-.184.13m-.012 0c0-.079.086-.137.195-.137.106 0 .191.062.191.137a.2.2 0 0 1-.015.054.2.2 0 0 1-.043.047.3.3 0 0 1-.063.031q-.034.007-.07.008-.04-.001-.074-.008a.2.2 0 0 1-.063-.03.12.12 0 0 1-.043-.048.1.1 0 0 1-.015-.054m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.445 4.977v.074h-.105v.07h.101v.215h-.132l-.008.016q.001.03.02.054h.34a.1.1 0 0 0 .015-.054l-.008-.016h-.125v-.211h.102v-.07h-.102V4.98h-.102Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.441 4.984h-.015l.027-.015v.008h.098v.07h.097v.082h-.097v.2h.12l.013.023a.2.2 0 0 1-.02.058h-.348l-.004-.004a.1.1 0 0 1-.015-.054l.008-.024h.133v-.203h-.106v-.078h.11Zm.012 0h.086v.075h.098v.062h-.098v.219h.125l.004.015a.1.1 0 0 1-.012.047h-.332a.1.1 0 0 1-.015-.047l.007-.015h.133v-.223h-.105v-.062h.11Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.512 11.02a4.6 4.6 0 0 1-1.551-.278.9.9 0 0 1-.406-.273.64.64 0 0 1-.157-.399V9h4.22v1.063c0 .296-.223.554-.563.68-.48.179-1.008.273-1.543.273",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ccc",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39 8.992h4.235v1.07c0 .301-.223.56-.566.688-.48.18-1.004.27-1.536.273v.004h-.011a4.6 4.6 0 0 1-1.555-.277m1.543.262v-.004h.012c.531 0 1.058-.094 1.539-.27.336-.129.554-.383.554-.675V9.008H8.41v1.062c0 .137.055.274.152.395a1 1 0 0 0 .403.273c.48.176 1.004.27 1.535.274m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.504 9h2.113V7.219h-2.113Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ccc",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.492 7.21h2.133v1.798h-2.133Zm.02.017v1.765h2.093V7.227Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.504 10.066a.64.64 0 0 1-.09.297.8.8 0 0 1-.226.25 1.2 1.2 0 0 1-.735.215c-.582 0-1.058-.344-1.058-.762V9h2.109v1.063",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.855 10.695c.07.028.16.07.254.09l-.004-1.824H8.86v1.734Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.848 8.953h.265l.004 1.84h-.012a1.4 1.4 0 0 1-.19-.066l-.063-.024-.016-.004.012-.008Zm.02 1.742c.019.004.034.012.054.02s.035.015.055.02c.039.015.082.03.12.038L9.095 8.97h-.227Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39 10.055c.008.18.094.36.247.5V8.973h-.242v1.082Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.387 8.973q.001-.007.008-.008h.242q.011.001.011.008v1.582q0 .002-.007.004-.006.006-.012 0a.73.73 0 0 1-.25-.504c0-.004.004-.004.004-.008h.004Zm.015 1.086a.72.72 0 0 0 .223.472v-1.55h-.219v1.074zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.324 10.824c.102.008.172.008.246 0V8.961h-.246Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c7b500",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.316 8.953h.266v1.879h-.008a1.3 1.3 0 0 1-.25 0h-.008Zm.02.016v1.847c.09.008.156.008.226 0V8.97Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79 10.781a1 1 0 0 0 .253-.082V8.961h-.246l-.008 1.824Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79 8.953h.265v1.75l-.004.004a1 1 0 0 1-.258.082l-.004-.004h-.008v-.012Zm.01 1.817.009-1.801h.226v1.726a1 1 0 0 1-.234.075m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.395 9h2.109V7.219h-2.11Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.387 7.21h2.125v1.798H8.387Zm.02.017v1.765h2.085V7.227Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.273 10.535c.102-.07.2-.23.235-.406l.008-1.168h-.246v1.57Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.258 8.953h.27l-.008 1.176h-.004a.7.7 0 0 1-.09.246.6.6 0 0 1-.145.164l-.008.008-.015-.012Zm.023.016v1.55a.5.5 0 0 0 .125-.152.7.7 0 0 0 .09-.238l.008-1.16Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.387 8.992h2.125v1.07h-.02V9.009H8.406v1.058c0 .414.469.754 1.047.754a1.17 1.17 0 0 0 .727-.215.8.8 0 0 0 .226-.246.6.6 0 0 0 .086-.293h.02a.6.6 0 0 1-.086.301.8.8 0 0 1-.235.25 1 1 0 0 1-.34.164q-.192.06-.398.055c-.586 0-1.066-.348-1.066-.77Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.621 9v1.063a.64.64 0 0 1-.09.296.8.8 0 0 1-.234.25c-.098.07-.211.13-.34.164a1.3 1.3 0 0 1-.395.051c-.582 0-1.058-.344-1.058-.761V9Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.492 8.992h2.137v1.07a.64.64 0 0 1-.09.301.76.76 0 0 1-.234.254q-.149.105-.344.164a1.4 1.4 0 0 1-.399.051c-.59 0-1.07-.348-1.07-.77Zm.02.016v1.055c0 .414.472.753 1.05.753.133.004.266-.011.391-.05a1 1 0 0 0 .336-.16.9.9 0 0 0 .23-.247.64.64 0 0 0 .09-.296V9.008Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.89 9.805.005.015c0 .02-.024.035-.051.035-.024 0-.051-.015-.051-.035q-.002-.007.008-.015h-.067q-.007.035.016.058.02.03.063.035v.13h.066v-.13q.03-.002.047-.02a.1.1 0 0 0 .027-.03h.195v-.043Zm.946 0v.043h-.172q-.006.006-.012.02l.203.171-.054.031-.203-.172h-.008v.293h-.074v-.293h-.008l-.203.172-.059-.03.207-.177a.03.03 0 0 0-.008-.015h-.18v-.043h.575Zm.113 0v.043h.2c.007.023.035.043.07.05v.13h.074v-.13c.02-.003.043-.011.055-.027a.1.1 0 0 0 .027-.05l-.008-.016h-.066q.005.007.004.015-.001.011-.008.016a.03.03 0 0 1-.016.016q-.012.004-.023.003c-.031 0-.051-.015-.051-.035l.004-.015zm-.285.734a.7.7 0 0 0 .156-.031l.035.047a1 1 0 0 1-.187.039.1.1 0 0 1-.043.047.14.14 0 0 1-.07.015.2.2 0 0 1-.07-.015.1.1 0 0 1-.044-.047 1 1 0 0 1-.195-.04l.031-.046a1 1 0 0 0 .172.035.1.1 0 0 1 .028-.027.1.1 0 0 1 .039-.02v-.223h.074v.223a.13.13 0 0 1 .07.043Zm-.484-.074-.035.047a.7.7 0 0 1-.16-.102.2.2 0 0 1-.06 0 .1.1 0 0 1-.05-.015q-.017-.012-.027-.024a.1.1 0 0 1-.012-.031q-.004-.018.004-.035a.1.1 0 0 1 .02-.028l.007-.004a.5.5 0 0 1-.055-.16h.07a.4.4 0 0 0 .048.137.2.2 0 0 1 .062.004l.18-.152.055.03-.184.157a.06.06 0 0 1 .023.047q0 .024-.023.047c.039.031.086.058.133.082Zm-.266-.156q.005-.007.016-.008.007-.005.015-.004.013-.006.02 0 .01.001.02.008.005.001.011.008a.03.03 0 0 1 .004.015q.001.005-.004.016-.006.007-.012.008a.04.04 0 0 1-.03.011c-.013.004-.024 0-.036-.004l-.012-.011q-.005-.006-.004-.012v-.016zm-.09-.149-.074-.012-.012-.144.075-.02v.082q-.002.048.007.094Zm.055-.18.074.012v.074c0-.027.012.07.012.07l-.07.02-.016-.09Zm.246.457q.1.059.21.086l.017-.054a.7.7 0 0 1-.176-.067l-.051.032m-.04.05a1 1 0 0 0 .216.086l-.055.04a1 1 0 0 1-.172-.07l.016-.056m.094-.312.07.023.133-.11-.043-.046-.16.129m-.055-.031-.04-.047.13-.11.066.024Zm.793.328.039.047a.7.7 0 0 0 .152-.102.16.16 0 0 0 .114-.015.1.1 0 0 0 .027-.028.04.04 0 0 0 .012-.027q.001-.018-.004-.035c-.008-.008-.012-.02-.024-.028l-.004-.004a.4.4 0 0 0 .055-.16h-.07a.4.4 0 0 1-.051.137.2.2 0 0 0-.063.004l-.175-.152-.051.03.176.157q-.022.017-.02.047 0 .024.024.047a.7.7 0 0 1-.137.082m.265-.156q-.005-.007-.011-.008-.01-.005-.02-.004c-.008-.004-.011-.004-.02 0q-.01.001-.015.008-.012.001-.012.008a.03.03 0 0 0-.007.015q0 .006.003.012c.004.004.004.012.008.012.02.015.051.02.07.003q.012-.005.012-.011.007-.006.008-.012a.03.03 0 0 0-.008-.016q0-.006-.011-.011Zm.09-.149.075-.015.007-.141-.066-.02v.082Zm-.058-.18-.074.012v.074c0-.027-.012.07-.012.07l.078.02.008-.09Zm-.246.457a1 1 0 0 1-.207.086l-.02-.054a.7.7 0 0 0 .176-.067l.055.032m.035.05a1 1 0 0 1-.211.086l.05.04a.7.7 0 0 0 .176-.07Zm-.098-.312-.07.023-.125-.11.039-.046.156.129m.059-.031.039-.047-.13-.11-.07.024.157.133m-.88-.29.02.051h.2l.023-.05Zm.923 0-.02.051h-.195l-.024-.05h.243m-.508.726c0-.02.02-.035.05-.035.024 0 .044.016.044.035 0 .024-.02.04-.047.04-.032 0-.051-.02-.051-.04Zm.082-.254.074-.015v-.149l-.074-.015v.175m-.074 0-.075-.015v-.145l.075-.015Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.734 9.805c.008-.032.04-.051.079-.063v-.18h.066v.18c.039.008.066.028.074.051h.195v.012h-.257q-.01-.011-.02-.016-.012-.005-.023-.004c-.008 0-.02 0-.028.004a.1.1 0 0 0-.02.016zm.532 0v-.012h.18l.007-.012-.219-.187.051-.031.219.18h.012v-.25h.07v.25h.012l.214-.184.051.03-.21.184.011.02h.172v.012Zm.945 0c.004-.008.008-.012.02-.016q.01-.005.023-.004c.02 0 .039.004.043.02h.07c-.008-.016-.015-.032-.027-.04a.1.1 0 0 0-.047-.023v-.18h-.074v.18c-.02.004-.035.008-.047.02a.1.1 0 0 0-.027.031h-.188v.012h.258m-1.32-.5.265.226.05-.031-.265-.227.012-.02h.195v-.05h-.195a.1.1 0 0 0-.043-.043.13.13 0 0 0-.066-.015q-.025 0-.043.003a.1.1 0 0 0-.04.02c-.007.008-.019.016-.023.027q-.01.016-.008.032c0 .035.032.066.079.078v.175h.066v-.175Zm1.394 0v.175h-.07v-.175c-.008 0-.012-.004-.016-.004l-.265.23-.051-.031.265-.234c0-.004-.004-.008-.004-.008h-.199v-.051h.2a.1.1 0 0 1 .039-.043.13.13 0 0 1 .066-.016c.066 0 .117.036.117.082 0 .04-.035.07-.082.079Zm-.7 0v.11h-.073v-.102a.1.1 0 0 1-.043-.02c-.016-.008-.024-.02-.032-.035h-.175V9.21h.175a.08.08 0 0 1 .043-.043.13.13 0 0 1 .067-.02c.05 0 .094.028.11.063h.175v.047h-.176c-.004.015-.015.023-.027.035a.1.1 0 0 1-.043.02Zm-.777.129-.074.015v.145l.075.015v-.171m.07 0 .074.015v.145l-.074.015Zm1.336 0-.074.015v.145l.074.015Zm.074 0 .074.015v.145l-.074.015Zm-1.121.03.07-.023.13.11-.04.047Zm-.055.032-.039.047.121.11.074-.024Zm.809-.04-.074-.019-.122.11.04.047Zm.054.032.04.051-.122.11-.074-.02.156-.137m-.89.3.02-.054h.199l.023.055Zm-.29-.566c0-.02.024-.035.048-.035.027 0 .05.016.05.035 0 .024-.023.036-.05.036-.024 0-.051-.016-.051-.036Zm.528.028-.02.05h-.199l-.02-.05Zm0-.055-.02-.055h-.199l-.02.055Zm.684.594-.02-.055h-.195l-.024.055h.243m.191-.567c0-.02.023-.035.047-.035.031 0 .05.016.05.035q-.002.036-.05.036c-.024 0-.047-.016-.047-.036m-.707 0c0-.02.023-.035.05-.035.024 0 .048.016.048.035 0 .024-.02.036-.047.036-.028 0-.051-.016-.051-.036m.273.028.028.05h.195l.02-.05Zm0-.051.024-.059h.2l.019.055h-.243m-.257.168-.075.016v.144l.075.016Zm.07 0 .074.016v.144l-.074.016Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.848 9.14c.023 0 .05.008.07.016q.03.02.043.043h.195v.063h-.195l-.008.011.27.23-.063.036-.265-.223h-.008v.168h-.082v-.171c-.047-.016-.078-.047-.078-.083q0-.017.007-.035a.1.1 0 0 1 .028-.027.2.2 0 0 1 .039-.02.2.2 0 0 1 .047-.007m.039.169h-.012v.168h-.059v-.172h-.004c-.042-.012-.074-.043-.074-.075q.001-.016.008-.03l.024-.028c.011-.004.023-.012.035-.016q.02-.005.043-.004c.023 0 .047.004.062.012q.03.017.043.04v.003h.192v.043h-.192l-.015.027.265.227-.043.023-.273-.23Zm.625.187h.082v.242h.004l.214-.183.063.035-.215.187.008.016h.176v.059h-.176l-.008.011.207.18-.07.035-.2-.176v.293h-.085v-.293h-.004l-.203.176-.067-.035.211-.18q-.004-.006-.008-.011h-.18v-.059h.18v-.004c0-.004.004-.004.004-.004l-.222-.187.066-.04.215.184q.004.001.008-.004Zm.011.008v.242l-.003.004h-.012l-.004.004-.219-.184-.043.028.223.187-.008.004q-.005-.001-.004.004v.008h-.18v.043h.18q.001.01.008.015v.004l-.207.176.047.027.207-.175.015.007v.29h.063v-.29l.016-.007.199.175.047-.027-.203-.172.015-.023h.172V9.8h-.172l-.015-.024.21-.187-.043-.024-.21.184-.024-.008v-.238Zm-.718.059h.082v.175a.1.1 0 0 1 .07.055h.195v.059h-.195a.1.1 0 0 1-.027.03.1.1 0 0 1-.043.02v.075l.074.011v.004q0 .076.012.145v.004l-.075.02c.008.027.02.058.036.085a.1.1 0 0 1 .054 0l.184-.148.062.035-.18.156c.012.012.02.031.02.047q0 .024-.023.047l.074.047.05-.035h.005c.05.03.113.054.175.07h.004l-.015.055a.4.4 0 0 0 .101.015c.008-.008.016-.02.028-.023a.1.1 0 0 1 .039-.02v-.226h.086v.226l.039.016.027.027a.7.7 0 0 0 .156-.031h.008l.04.05-.009.005a1 1 0 0 1-.187.039.1.1 0 0 1-.043.047.2.2 0 0 1-.074.015.15.15 0 0 1-.075-.015.1.1 0 0 1-.043-.047 1 1 0 0 1-.132-.024l-.059.04-.004-.005a1 1 0 0 1-.172-.066h-.004l.016-.055a1 1 0 0 1-.102-.074.15.15 0 0 1-.109-.016.1.1 0 0 1-.027-.027q-.012-.016-.012-.031c-.004-.012 0-.024.004-.035a.05.05 0 0 1 .023-.028v-.004a.3.3 0 0 1-.046-.113l-.07-.012L10.73 10l.075-.02v-.074a.1.1 0 0 1-.059-.031.08.08 0 0 1-.023-.055c0-.039.035-.07.082-.082Zm.011.46h.059v-.128h.004c.016-.004.031-.008.043-.02q.017-.013.027-.031h.192V9.8h-.192v-.004a.09.09 0 0 0-.07-.047l-.004-.004V9.57h-.059v.172l-.004.004c-.042.012-.078.04-.078.074q0 .028.024.051a.1.1 0 0 0 .055.027h.003Zm.059.008h-.059v.078h.063l-.004-.043Zm.023.117.063-.015a1 1 0 0 1-.012-.137l-.062-.008v.078Zm-.02-.03h-.058q.001.016.008.034v.008h-.004c.012.04.024.074.047.11v.011h-.004a.1.1 0 0 0-.02.028c-.003.007-.007.02-.003.027q0 .019.011.031c.004.008.016.016.024.024a.15.15 0 0 0 .101.015l.004-.004.004.004c.043.04.098.07.153.102l.03-.04c-.01-.007-.023-.011-.03-.019a.5.5 0 0 1-.102-.066h-.004l.004-.004c.016-.012.02-.027.024-.043a.1.1 0 0 0-.02-.047h-.004l.176-.152-.043-.028-.18.149h-.004q-.03-.008-.058-.004h-.004v-.004a.3.3 0 0 1-.04-.086v-.004q-.003-.018-.007-.043m.306.355-.032.039.09.035.028-.04q-.048-.016-.086-.034m.148.043.012-.043a.8.8 0 0 1-.168-.067l-.04.031c.005 0 .009.004.009.004q.022.013.039.02l.004.004q.068.032.144.05m-.05-.004-.028.039.05.011.012.004q.06.018.125.024h.008v.004q.011.024.04.043.03.014.066.015a.13.13 0 0 0 .066-.015.1.1 0 0 0 .043-.043v-.004h.004a1 1 0 0 0 .18-.04l-.028-.034q-.076.021-.16.03h-.004v-.003c-.008-.012-.02-.02-.027-.027-.012-.004-.027-.012-.04-.016h-.003v-.223h-.063v.223h-.003c-.016.004-.028.012-.04.016-.007.007-.02.015-.023.027l-.004.004h-.004a.6.6 0 0 1-.168-.035m-.044.043a1 1 0 0 1-.144-.059l-.012.043q.075.037.164.063l.043-.032-.047-.011Zm-.425-.407a.1.1 0 0 1-.008-.035v-.121l-.063.016.012.133Zm.152.153h-.016c-.008 0-.011 0-.02.004q-.005.001-.011.008l-.008.007q-.005.006-.004.012c0 .004.004.008.004.012q.006.007.012.008c.008.003.02.007.027.007a.1.1 0 0 0 .031-.007c.016-.016.016-.036 0-.043a.03.03 0 0 0-.015-.008m-.047-.004h.008q.006-.004.02-.008a.1.1 0 0 1 .023.004c.008 0 .011.004.02.008.023.011.023.039 0 .054a.06.06 0 0 1-.036.012q-.022.002-.039-.008-.012-.006-.012-.011a.03.03 0 0 1-.007-.016c0-.004 0-.012.003-.016.004-.004.004-.007.012-.011l.008-.012Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.55 9.14c.052 0 .095.028.114.06h.18v.062h-.18a.1.1 0 0 1-.027.031.1.1 0 0 1-.043.02v.109h-.082v-.11c-.02-.003-.032-.011-.047-.019a.1.1 0 0 1-.027-.031h-.176v-.063h.175a.1.1 0 0 1 .043-.039.14.14 0 0 1 .07-.02m.04.165a.1.1 0 0 0 .039-.02.06.06 0 0 0 .023-.031l.004-.004h.176v-.043h-.176l-.004-.004c-.011-.027-.05-.05-.101-.05a.1.1 0 0 0-.063.015.07.07 0 0 0-.039.035l-.004.004h-.172v.043h.172l.004.004a.1.1 0 0 0 .028.031q.018.016.043.02h.003v.105h.055v-.105Zm.664-.164c.07 0 .121.043.121.09 0 .039-.031.07-.078.082v.171h-.074v.079h.074v.175a.1.1 0 0 1 .058.032.07.07 0 0 1 .024.05q0 .031-.024.055a.14.14 0 0 1-.058.027v.078l.07.02-.008.152-.074.012a.5.5 0 0 1-.047.106l.004.003c.012.012.02.02.024.032q.007.017.007.035a.12.12 0 0 1-.043.058.16.16 0 0 1-.109.016.6.6 0 0 1-.101.07l.015.059h-.004a.7.7 0 0 1-.176.07h-.003l-.063-.047.008-.004a.7.7 0 0 0 .152-.05l-.031-.04q-.07.031-.152.055h-.008l-.02-.062h.008a.6.6 0 0 0 .172-.067h.004l.058.032.07-.047c-.015-.016-.019-.031-.023-.047 0-.016.008-.035.02-.047l-.184-.156.067-.035.18.148a.1.1 0 0 1 .054 0c.016-.027.027-.059.04-.086l-.079-.02v-.007q-.001-.006.004-.012-.001-.013.004-.031c0-.008 0-.02.004-.024V9.99l.074-.012v-.075q-.022-.006-.04-.02a.1.1 0 0 1-.026-.03h-.2v-.059h.196a.11.11 0 0 1 .07-.055v-.12l-.074-.016v-.153l.074-.015v-.118c-.004 0-.004-.004-.008-.004l-.265.227-.063-.043.27-.23v-.004h-.2v-.063h.2a.1.1 0 0 1 .043-.039.13.13 0 0 1 .066-.02m-.031.336h.062v-.172c.047-.008.078-.04.078-.075 0-.043-.047-.078-.11-.078a.1.1 0 0 0-.058.016.08.08 0 0 0-.043.035v.004h-.195v.043h.195v.004q.005.006.004.012h.004l-.265.23.043.027.261-.222h.004q.011.004.016.008h.004Zm-.012-.032-.063.012v.137l.063.011Zm.012.301-.004.004a.1.1 0 0 0-.07.047V9.8h-.192v.043h.195a.1.1 0 0 0 .028.031.1.1 0 0 0 .039.02l.004.003v.125h.062v-.128h.004q.036-.005.055-.028a.06.06 0 0 0 .023-.047q0-.022-.023-.047-.019-.022-.055-.027h-.004V9.57h-.062Zm.062.285h-.062v.035l-.004.043h.062l.004-.043Zm0 .121a.1.1 0 0 0 .008-.039v-.004l.004-.043v-.074l.058.016-.007.137Zm-.008-.035h-.054q-.001.018-.008.035v.012-.004a1 1 0 0 1-.04.09l-.003.004h-.004a.2.2 0 0 0-.059.004h-.004l-.175-.149-.047.028.18.148-.004.004c-.012.016-.02.031-.016.047q.001.024.02.043l.003.004h-.004a.5.5 0 0 1-.132.086l.027.039a.8.8 0 0 0 .156-.102l.004-.004.004.004c.031.008.07 0 .102-.015l.027-.024a.1.1 0 0 0 .008-.031c.004-.008 0-.02-.004-.027a.1.1 0 0 0-.02-.028l-.011-.008v-.003a.3.3 0 0 0 .05-.118Zm-.074.031.008-.082v-.078l-.063.008v.07q-.001.011-.003.028-.005.013-.004.031c0 .004-.004.008-.004.008Zm-.058-.082h-.004zm-.18.368-.043-.024a.8.8 0 0 1-.168.063l.012.043a.8.8 0 0 0 .199-.082m.043.058a.8.8 0 0 1-.195.078l.042.035c.06-.02.114-.039.168-.066ZM10.816 9.43v.187l-.086-.015v-.153Zm.063 0 .086.02v.152l-.086.015Zm-.137.027v.137l.063.011v-.16Zm.149-.012v.16l.062-.011v-.137Zm-.047.344c-.024 0-.043.016-.043.031q0 .012.011.024.013.007.032.008c.027 0 .043-.016.043-.032 0-.02-.02-.03-.043-.03m-.055.031c0-.023.027-.039.055-.039.031 0 .054.016.054.04 0 .023-.023.038-.054.038a.07.07 0 0 1-.04-.011.03.03 0 0 1-.015-.028m.426.157.082.023-.168.145-.047-.055Zm.004.011-.121.102.035.039.144-.125Zm.125.043.05.055-.14.113-.078-.027Zm-.149.137.059.02.125-.106-.035-.035Zm.942.125q.006-.005.02-.004.012.004.019.008.01.001.015.008l.012.011q.005.005.004.016c0 .004 0 .012-.004.016l-.015.011a.1.1 0 0 1-.043.012q-.018-.002-.036-.016-.007-.005-.007-.011-.005-.011-.004-.016-.001-.011.004-.015.004-.006.015-.012a.03.03 0 0 1 .02-.008m.043.016.004.004q.007.003.007.007.005.006.004.012.001.006-.004.012-.006.007-.011.008a.1.1 0 0 1-.032.011l-.027-.011q-.007-.006-.008-.012-.005-.006-.004-.012-.001-.006.004-.012c.004-.004.004-.007.012-.007q.006-.007.012-.008h.02c.003 0 .011 0 .015.004q.007.002.008.004m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.797 9.14H12l.023.063h-.257Zm.008.012-.02.043h.223l-.016-.043Zm-.7-.007h.207l.024.062h-.254Zm.008.011-.015.043h.222l-.02-.043Zm.438.04c-.024 0-.043.015-.043.03q0 .012.012.024c.007.004.02.008.03.008a.1.1 0 0 0 .032-.008c.004-.004.012-.012.012-.023 0-.02-.02-.032-.043-.032m-.059.03c0-.023.031-.039.059-.039.031 0 .054.016.054.04q-.002.021-.015.03c-.012.009-.024.009-.04.009a.07.07 0 0 1-.038-.012.03.03 0 0 1-.02-.027m.762-.03c-.02 0-.043.015-.043.03q-.001.012.016.024a.1.1 0 0 0 .027.008.1.1 0 0 0 .031-.008q.012-.006.012-.023-.001-.031-.043-.032m-.055.03c0-.023.028-.039.055-.039.031 0 .055.016.055.04q.001.021-.016.03c-.008.009-.023.009-.04.009a.1.1 0 0 1-.038-.012.03.03 0 0 1-.016-.027M10.848 9.2c-.02 0-.04.012-.04.031v.004h-.003q.006.01.011.02.016.007.032.008a.1.1 0 0 0 .03-.008q.013-.006.013-.024-.001-.03-.043-.03m-.051.028h-.004v.003c0 .012.008.024.016.028a.07.07 0 0 0 .039.012.1.1 0 0 0 .039-.008.04.04 0 0 0 .015-.032c0-.023-.023-.043-.054-.043-.028 0-.047.016-.051.04m.969.023h.257L12 9.313h-.203Zm.02.008.019.043h.187l.016-.043Zm-.704-.008h.254l-.024.063h-.207Zm.016.012.015.043h.188l.02-.043Zm.418.101.004.012-.07.012v.133l.062.015v-.16h.011v.172l-.085-.02V9.38Zm.062.004.09.02v.148l-.09.02Zm.016.016v.156l.058-.012v-.132Zm.691.047.086.02v.152l-.086.015Zm.012.015v.16l.062-.011v-.137Zm-.445-.011.085.027-.167.144-.047-.054Zm.003.011-.117.106.032.039.144-.125Zm-.613-.008.133.114-.047.058-.168-.144Zm-.058.032.144.125.031-.04-.12-.105Zm.793.027v-.004l-.165.137.086.027.13-.117-.044-.047Zm.003.008-.144.121.059.02.117-.106Zm-.863-.012.168.14-.086.028-.129-.113Zm.004.016-.035.039.117.105.063-.023Zm-.016.23h.207l.028.063h-.258Zm.008.012-.015.043h.226l-.02-.043Zm.676-.012h.207l.024.059h-.004V9.8h-.25Zm.215.055-.016-.043h-.187l-.02.043Zm.25-.004c-.024 0-.043.016-.043.031 0 .016.02.032.043.032.027 0 .043-.016.043-.032q-.001-.03-.043-.03m-.055.031c0-.02.024-.039.055-.039s.055.016.055.04c0 .023-.024.038-.055.038s-.055-.015-.055-.039m-1.117.024h.258l-.027.062h-.208Zm.016.008.015.043h.192l.02-.043Zm.668-.008h.261l-.03.062h-.208Zm.015.008.02.043h.187l.02-.043Zm.106.125.129.113-.047.055L11.8 10Zm-.067.027.149.125.031-.04-.117-.1Zm-.062.027.168.14-.082.028-.133-.113Zm0 .016-.031.039.12.101.055-.019Zm-.235.086v.187l-.085-.015v-.153Zm.063 0 .086.02v.156l-.078.015-.004-.008h-.004Zm.012.18.058-.012v-.14l-.058-.013Zm-.149-.153v.137l.063.012v-.16Zm.11.387c-.028 0-.043.012-.043.027v.004h-.004c0 .02.02.031.043.031s.043-.015.043-.035c0-.015-.02-.027-.04-.027m-.055.023h-.008v.004c0 .024.024.043.059.043.03 0 .054-.02.054-.043 0-.02-.023-.039-.05-.039-.032 0-.055.016-.055.035m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.438 9.82q0-.013.011-.03a.2.2 0 0 1 .024-.028.1.1 0 0 1 .039-.016.1.1 0 0 1 .043-.004c.062 0 .113.031.113.078q-.001.018-.008.035a.1.1 0 0 1-.027.028.1.1 0 0 1-.035.02q-.025.004-.043.003-.024.001-.047-.004-.018-.006-.035-.02a.1.1 0 0 1-.028-.027q-.007-.017-.008-.035m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#058e6e",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.582 7.656v-.02l.004-.011s-.066.008-.102 0a.3.3 0 0 1-.101-.043c-.035-.023-.047-.031-.07-.039-.06-.004-.102.012-.102.012s.043.015.074.047q.035.03.082.046c.028.004.113 0 .137 0Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#db4446",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.238 7.543c.02-.004.043-.008.075-.004.023.004.039.016.066.031l.008.008a.3.3 0 0 0 .097.04q.031.004.063.003h.027q.007.001.008-.004h.016l-.008.02v.027l-.086-.008h-.106q-.021.001-.03-.004a.3.3 0 0 1-.087-.047m.293.028h-.093a.4.4 0 0 1-.106-.047l-.008-.008c-.027-.016-.039-.023-.058-.027a.2.2 0 0 0-.067.004h-.012c.004.004.008.004.012.008.016.007.035.015.051.035a.2.2 0 0 0 .078.043c.004 0 .016.004.027.004h.106l.07.003Zm-.36-.078-.007-.004h.004l.004-.004c.008 0 .015-.004.023-.004m-.023.012-.008-.004-.012.008.016.003h.004q.007.004.02.008c.011.008.03.02.046.035m-.062-.043",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.898 7.586v.043c.004.02-.007.039 0 .05l.008.032c.008.008.012.031.012.031l-.031-.02-.028-.011v.031c.004.008.016.031.028.04a.14.14 0 0 1 .039.042c.011.012.008.043.008.043s-.016-.02-.036-.027l-.054-.02s.039.028.039.051c0 .024-.02.05-.02.05s-.011-.023-.031-.034l-.05-.032s.023.04.023.063V8s-.024-.023-.043-.031l-.04-.024c0-.008.02.02.024.035 0 .016.012.075.082.153.04.043.098.117.23.094.13-.028.083-.157.051-.22a.7.7 0 0 1-.039-.155c.004-.028.028-.094.024-.11a.3.3 0 0 1 .004-.11c.015-.038.035-.058.043-.073l.02-.043v-.043l.03.047.004.046s.008-.035.043-.054c.04-.02.082-.035.09-.047l.016-.016s-.004.063-.028.086l-.074.067s.031-.008.055-.008h.035s-.027.015-.062.05c-.032.036-.02.04-.04.07-.027.032-.046.032-.078.052-.043.03-.02.14-.011.156.004.016.082.152.082.187.004.032.011.102-.067.153-.05.031-.129.031-.148.039-.016.008-.051.035-.051.094 0 .054.027.066.047.082.02.011.05.003.055.015l.02.024c.007.007.015.015.01.023 0 .016-.038.043-.046.063A.3.3 0 0 0 12 8.68c0 .008 0 .03.012.047 0 0 .039.03.008.039-.016.004-.032-.008-.04-.008l-.043.015c-.011 0-.011-.007-.015-.027l-.004-.02q-.017-.001-.016.016c0 .004 0 .028-.011.028-.012 0-.028-.016-.04-.02-.007 0-.03-.008-.035-.016 0-.007.016-.027.032-.03.015 0 .035-.009.02-.017a.02.02 0 0 0-.028 0c-.008.008-.031 0-.031-.007 0-.012.004-.024 0-.028 0-.004-.016-.02.007-.027.024-.008.032.008.059.008q.037-.006.043-.024c.008-.007.008-.03-.008-.046-.015-.016-.031-.016-.043-.024l-.012-.031v.074l-.03-.027a.2.2 0 0 1-.024-.047v.047c0 .011.015.02.008.027-.004.004-.036-.027-.043-.027a.1.1 0 0 1-.04-.032l-.027-.046c0-.008-.008-.047 0-.051l.02-.04h-.059c-.031 0-.055-.003-.066.012q-.017.024.008.094c.015.04.027.063.02.067a.1.1 0 0 1-.032.03l-.04-.003c-.01 0-.023-.008-.05-.008h-.059c-.011 0-.039-.012-.046-.008-.012 0-.036.008-.032.02.008.02-.008.027-.02.023l-.038-.008c-.016-.003-.04 0-.035-.011 0-.016.007-.016.015-.024.008-.011.016-.015 0-.015h-.027c-.008.004-.02.015-.028.015-.011-.008-.023-.015-.023-.035 0-.023-.027-.043 0-.043s.059.016.063.008c.007-.012 0-.016-.012-.023-.012-.012-.028-.016-.012-.028l.031-.02c.008 0 .016-.023.032-.015.027.008 0 .02.027.043.023.02.039.031.086.027.043-.004.058-.007.058-.02l-.007-.03.007-.032s-.023.012-.027.02l-.02.023v-.062l-.007-.031-.012.03-.004.032s-.027-.016-.02-.047v-.062c.012-.016.036-.055.09-.059h.114l.086-.008s-.121-.047-.153-.062a.4.4 0 0 1-.086-.07c-.015-.02-.027-.051-.027-.051s-.02 0-.043.011q-.029.013-.05.032l-.032.03v-.062s-.016.04-.039.055l-.062.04v-.032l.007-.031s-.02.023-.047.03c-.03.005-.078 0-.082.017 0 .015.008.035 0 .043-.004.011-.023.019-.023.019s-.016-.012-.031-.012c-.016 0-.028.004-.028.004s-.02-.011-.007-.02c0-.011.027-.023.02-.03l-.04.007c-.012.008-.035.008-.031-.008 0-.011.008-.02 0-.03q-.005-.015.008-.016c.007-.004.05 0 .054-.008q.002-.012-.039-.024c-.023 0-.035-.015-.023-.023l.023-.02c.004-.007.008-.023.031-.02.024.013.02.032.04.032.023.012.082 0 .093 0l.063-.031.07-.04-.047-.023-.039-.035a.3.3 0 0 0-.082-.023c-.02 0-.074-.016-.074-.016l.031-.008a.1.1 0 0 1 .04-.02h.01-.062a.14.14 0 0 0-.05-.019h-.04s.032-.011.06-.015l.046-.004s-.039-.008-.05-.016l-.028-.031c-.008-.008-.012-.02-.024-.02-.011 0-.035.012-.046.008q-.023.002-.028-.02v-.015c-.008-.012-.027-.027-.008-.031h.06c.003-.008-.02-.024-.036-.032-.016-.003-.04-.015-.027-.023l.03-.02c.013-.007.02-.03.036-.02.012.005.035.04.043.036.016-.004.02-.027.016-.035 0-.012 0-.031.011-.031.012 0 .02.015.04.015.015 0 .046 0 .042.008q-.002.018-.027.035c-.004.008-.012.016-.012.024s0 .02.004.027q.02.023.05.047c.017.008.056.016.075.023.024.012.078.043.094.047l.035.008s.024-.004.047-.004c.027 0 .09.004.113-.004.028-.008.055-.023.047-.039-.008-.015-.062-.031-.059-.043s.028-.011.06-.015c.03 0 .073.007.081-.032.008-.03.012-.05-.031-.058-.047-.008-.082-.008-.09-.032-.008-.023-.016-.03-.008-.039q.011-.01.063-.011c.035-.004.07-.004.082-.008.008-.008.011-.024.023-.031l.063-.012s.062.023.125.055c.047.03.093.07.093.07",
    style: {
      fillRule: "nonzero",
      fill: "#ed72aa",
      fillOpacity: 1,
      strokeWidth: 0.03,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "#000",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.457 7.563-.008-.024-.004-.008s.04 0 .04.008-.012.008-.016.012c0 .004-.012.008-.012.008",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.445 7.527h.02c.004 0 .012 0 .015.004h.004q.005.001.004.008v.008c-.004 0-.008.004-.008.004h-.007c0 .004-.004.008-.004.008l-.004.003h-.012l-.008-.019-.008-.016Zm.016.024v-.004c.004 0 .008-.004.008-.004h.004c.004 0 .004-.004.004-.004q-.006-.002-.012-.004h-.008v.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.629 7.516V7.5s.027 0 .043.008l.043.031c-.012.008-.027-.004-.043-.008h-.016q-.01.002-.015-.008v-.007Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.629 7.5h.016c.007 0 .02.004.027.008q.02.012.031.02l.008.007.004.004v.004h-.008q-.006.001-.012-.004h-.008l-.003-.004q-.006.001-.012-.004h-.027c-.004 0-.004-.004-.008-.004v-.011h-.012V7.5Zm.082.04h-.004c0-.005-.004-.005-.008-.009q-.01-.012-.027-.02a.1.1 0 0 0-.027-.007q-.012-.002-.012-.004h-.004v.016h.012v.007q.004.005.007.004.001.005.008.004h.016q.006-.001.012.004h.007l.004.004h.016M11.848 7.684q-.007-.006-.008-.012h-.012q.001.011.008.016v.003l.016.02.011-.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.992 7.555s.02.011.031.011l.04.004s.007-.015.003-.03c-.007-.04-.054-.048-.054-.048s.011.024.004.031c-.008.02-.024.032-.024.032m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#db4446",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.012 7.488v.004zh.011q.005.004.016.008c.016.008.031.02.035.04v.023q-.005.006-.004.007v.004h-.008.008l-.004.004-.043-.004q-.01.001-.023-.004-.007-.002-.008-.003h-.004l-.011-.004.007-.008h.004c0-.004.004-.004.004-.008q.011-.007.016-.02.005-.003.004-.007.001-.004-.004-.008V7.5c-.004 0-.004-.004-.004-.004L11 7.484Zm-.008.067h.004c.004.004.012.004.015.004l.032.003s0-.003.004-.003v-.02a.05.05 0 0 0-.028-.031q-.004-.005-.008-.004.005.006.004.012.001.006-.004.011a.1.1 0 0 1-.015.024zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.895 7.586s-.02-.024-.055-.02a.1.1 0 0 0-.067.028h.055c.016.008.02.031.02.031l.027-.02Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#db4446",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.898 7.586h-.003zl.004.004-.02.02-.038.027-.004-.012v-.004s-.004-.004-.004-.008l-.012-.011h-.066l.008-.012.007.004-.007-.004h.004s0-.004.003-.004l.012-.012q.019-.007.055-.015.03 0 .047.011.006.007.011.008v.008m-.105 0h.035l.004.004c.012.004.016.015.02.02v.003l.02-.011.01-.016s-.003-.004-.007-.004q-.012-.012-.035-.012a.1.1 0 0 0-.043.016zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.848 7.688s-.032.003-.051.019c-.02.016-.016.047-.016.047s.02-.02.043-.02l.047.008-.012-.031c0-.008-.011-.024-.011-.024m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#db4446",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.855 7.684-.007.003V7.68h.004Zm.012.027-.004-.016q-.004-.007-.008-.008v-.003l-.007.003V7.68h-.004q.001.002-.004.004h-.012c-.012.003-.027.007-.035.02-.012.007-.016.023-.02.03v.02h.008-.008l.004.016.012-.012s0-.004.004-.004q.001-.002.008-.004.012-.007.023-.008l.059.008Zm-.078.027c.008-.004.02-.011.035-.011l.035.007-.007-.02v-.003s-.004-.008-.004-.012c-.004 0-.004-.004-.004-.004h-.012c-.008.004-.02.008-.027.016q-.011.012-.016.023zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.457 7.684.02-.016.011.016Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.477 7.66.023.027h-.055Zm-.004.02h.004l-.004-.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.496 7.684.016-.02.015.016h-.03",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.512 7.656.031.032h-.047v-.004h-.004Zm0 .02h.004l-.004-.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.48 7.578.032.008-.028.016Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.473 7.57.054.016-.047.023Zm.015.016v.008l.008-.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.52 7.586.035.008-.028.011Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.512 7.582.054.008-.039.023Zm.02.012v.004h.007ZM11.29 7.781l.003.012q-.005-.001-.004.004-.005-.001-.016.004c-.007.004-.02.008-.023.011-.008.008-.008.016-.012.02q.004.001.008-.004a.1.1 0 0 1 .05 0l.052.008h.011c.008 0 .012-.004.02-.004.004 0 .012-.004.012-.004q.004.001.007-.004l.008.012q.001.002-.004.004-.001.006-.007.012-.004.005-.008.011c0 .008-.004.012 0 .016v.02a.04.04 0 0 1 .004.019c0 .012-.008.023-.012.031 0 .004-.004.004-.004.008l.023-.008a.14.14 0 0 0 .07-.027l.063-.043-.008.02v.015q-.004.017 0 .027l.008.043c.004-.007.016-.011.024-.015h.008q.005-.004.011-.008l.016-.012.012-.027h.015v.004q.005.004.004.008c0 .007.004.02.012.023l.012.016.007.02q.005.003.004.007a.1.1 0 0 1 .02-.027q.008-.005.015-.016c.004-.004.008-.004.008-.008v-.034h.016l.02.03-.016.004s-.004.004-.004.008a.01.01 0 0 0-.008.008q-.013.011-.02.015a.1.1 0 0 0-.015.024q-.004.006-.008.012v.004m-.016 0q-.001-.004-.003-.008-.001-.005-.008-.016a.03.03 0 0 0-.008-.016q-.007-.01-.008-.015-.012-.008-.012-.016l-.004.008-.023.016q-.006.004-.012.007h-.011q-.007.006-.02.012c0 .004-.004.004-.004.008h-.004l-.011.012q-.017.011-.04.023l-.058.027-.008-.011.059-.024q.023-.017.043-.035l-.008-.047c-.004-.008-.004-.023-.004-.03l-.024.019c-.023.011-.046.023-.078.027l-.058.016.008-.016h.003v-.004q.004 0 .008-.012a.1.1 0 0 0 .008-.03h.004q.001-.007-.004-.013v-.004l-.031.012-.05.024q-.014.006-.024.02-.007.005-.008.01c-.004 0-.004.005-.004.005l-.016-.008s.004 0 .004-.004c.004-.004.004-.008.008-.012q.013-.011.031-.023l.051-.024.04-.011q-.006-.004-.005-.008-.001-.01.004-.02a.03.03 0 0 0 .008-.015c-.004 0-.008.004-.012.004-.008 0-.015.004-.02.004l-.054-.012c-.016-.004-.031 0-.043 0-.004.004-.008.004-.012.008h-.004l-.011.007v-.011h.007-.007v-.012q0-.011.011-.027c.008-.008.024-.012.032-.016q.01-.005.015-.004l.004-.004h.004",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.953 8.012s-.015-.016-.047-.008c-.031 0-.05.031-.05.031l.042-.008a.1.1 0 0 1 .024.016l.02-.012Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#db4446",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.96 8.008-.007.004zl.004.004-.016.023-.031.02-.004-.008-.004-.004q-.005-.004-.015-.008l-.055.008.008-.012.007.004-.007-.004h.004v-.004l.011-.011c.008-.008.024-.02.04-.02a.07.07 0 0 1 .042.004c.004 0 .008.004.012.004q-.001.005.004.004m-.085.015h.027q.013.006.02.012l.015-.008.008-.011c-.004-.004-.004-.004-.008-.004q-.006-.005-.03-.004c-.012 0-.024.008-.032.015m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.922 8.105s-.027 0-.05.012c-.024.016-.024.04-.024.04s.02-.012.043-.009l.03.004.005-.02c.004-.01-.004-.027-.004-.027m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#db4446",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.93 8.105h-.008v-.003h.004Zm.004.032c.004-.008 0-.016 0-.024 0 0-.004-.004-.004-.008h-.008v-.003h-.02a.1.1 0 0 0-.035.011q-.02.014-.023.028-.005.006-.004.011v.004h.008-.008v.012l.012-.008m.007-.015q.013-.005.032-.004l.023.004.004-.012v-.016s0-.004-.004-.004h-.008c-.008.004-.02.004-.027.012q-.016.007-.02.02m-.007.015h.003c.004 0 .004-.004.008-.004q.012-.005.024-.004l.043.008.004-.023",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.98 8.195s0 .024.016.04c.016.019.047.019.047.019l-.012-.027c-.004-.012.012-.02.012-.02s-.016-.012-.027-.012h-.032",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#db4446",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.973 8.188h.043q.006 0 .011.003.006-.001.012.004c.004 0 .008.004.008.004s.004 0 .004.004l-.008.004.008-.004.008.004-.008.004h-.004q.001.005-.004.004-.005.006-.004.012l.016.03h-.012v-.003.004h-.02a.1.1 0 0 1-.035-.02c-.008-.008-.011-.02-.015-.027v-.016h.007-.007Zm.015.011v.008L11 8.23h.004c.004.008.016.012.023.016h.004l-.008-.016q.001-.01.008-.023v-.004h-.008q-.006-.005-.007-.004Zm.688.043.004-.004.004-.008.004.004c.003 0 .007.004.011.004.008.004.02.012.028.02l.03.023c.009.012.016.02.013.031 0 .02-.012.04-.024.051-.004.008-.012.016-.016.02q-.002.004-.003.008h-.004l-.012-.008.008-.008.015-.016c.008-.015.02-.03.02-.046q-.001-.012-.008-.024l-.027-.023q-.02-.011-.031-.016-.004-.005-.008-.004c0-.004-.004-.004-.004-.004m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.29 8.418s-.02-.02-.052-.02c-.031 0-.062.024-.062.024s.043 0 .05.008l.016.02.024-.009Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#db4446",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.191 8.406a.1.1 0 0 1 .047-.011q.028 0 .043.007.006.007.012.008c0 .004.004.004.004.004l-.008.004.008-.004.004.004-.031.027-.032.012-.02-.023q-.003-.005-.007-.004h-.059l.02-.012c0-.004.004-.004.004-.004q.005-.004.015-.008m.008.012h.016q.007-.001.008.004h.007v.004l.016.015.016-.004.02-.019q-.008.001-.009-.004-.017-.007-.035-.008a.1.1 0 0 0-.039.012m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2 8.508s-.04 0-.06.015c-.023.016-.019.043-.019.043s.027-.023.043-.02a.2.2 0 0 1 .05.009l-.01-.024a.1.1 0 0 0-.009-.023",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#db4446",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.203 8.504-.004.004zl-.004.004h.004q.007.011.008.023l.016.035-.016-.004h-.004V8.56h-.012q-.013-.005-.03-.004h-.005c0-.004-.004 0-.008 0q-.006.002-.011.004-.004.007-.008.007s-.004 0-.004.004l-.012.012-.004-.016h.008-.008v-.019q.004-.013.02-.031a.1.1 0 0 1 .043-.012h.023Zm-.07.047q.005-.007.015-.008c.004 0 .008-.004.016-.004q.023.001.035.008l-.004-.016q-.002-.008-.004-.015h-.011c-.012 0-.028.004-.035.011-.008.004-.012.016-.012.024m-.004.015",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.281 8.605s-.02.02-.004.036c.012.02.043.023.043.023s-.008-.012-.004-.023c.004-.012.028-.024.028-.024Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#db4446",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.281 8.598.082.015-.015.008h-.004q-.001.004-.008.008c-.004.004-.012.008-.012.012-.004.007 0 .011 0 .015v.004c.004 0 .004.004.004.004l.008.012-.02-.004.004-.008-.004.008h-.004q-.005-.004-.011-.008c-.012-.004-.024-.008-.028-.02q-.015-.016-.007-.027.004-.006.007-.012v-.003h.004l.004.003-.004-.003Zm.004.015q.001.001-.004.008c0 .004-.004.012.004.016.004.008.016.015.02.015q-.001-.006.004-.011c0-.008.011-.016.015-.024Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.805 8.645s-.035-.008-.055 0c-.02.007-.031.046-.031.046s.027-.02.05-.02l.043.009v-.024q-.006-.006-.007-.011m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#db4446",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.805 8.637h.004v.004l.011.011v.04l-.05-.012a.1.1 0 0 0-.032.008q-.006.002-.011.003-.002.005-.004.004l-.02.012.008-.02v-.003c.004-.004.004-.008.008-.016.004-.004.008-.012.011-.016q.005-.008.016-.015a.07.07 0 0 1 .04 0h.019m-.07.039c.007-.004.023-.012.035-.012h.003l.032.008v-.016q-.004-.001-.008-.008h-.043c-.004.004-.008.004-.012.012q-.007.006-.008.012zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.82 8.742s-.023.016-.015.035q.011.019.023.032s0-.02.012-.032c.012-.007.043-.007.043-.007l-.031-.02Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#db4446",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.816 8.734.04.012.046.027h-.023q-.006.002-.012.004c-.008 0-.015.004-.02.004-.003.004-.007.012-.011.016v.012l-.008.007h-.004l-.004-.004q-.011-.012-.023-.03c-.008-.012 0-.024.004-.032q.007-.006.008-.012h.004v-.004l.007.008-.008-.008Zm.008.012-.008.008q-.007.012-.004.023l.012.016q0-.013.012-.02a.1.1 0 0 1 .027-.007l-.015-.012Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.95 8.77s-.012.023.015.039c.023.02.043.02.043.02s-.02-.024-.012-.04c.004-.016.02-.023.02-.023l-.032-.008Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#db4446",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.984 8.754.051.008-.012.008h-.003v.003s-.004 0-.004.004c-.004.004-.012.008-.012.012v.012q-.001.006.004.011c0 .004.004.008.004.008l.004.004.007.012h-.015v-.008.008h-.004q-.006-.005-.012-.004c-.008-.004-.02-.008-.035-.02a.04.04 0 0 1-.016-.03v-.016h.004l.004.004-.004-.004Zm-.027.02v.007c0 .008 0 .016.012.024q.012.011.023.011-.005-.008-.004-.015a.01.01 0 0 1 0-.016q.006-.011.012-.015l-.016-.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.613 10.547c.086.02.133.07.133.125 0 .078-.094.133-.223.133-.12 0-.23-.055-.23-.13 0-.058.043-.124.133-.124 0 0 0-.012-.012-.02l-.027-.023h.054l.028.015.027-.02a.1.1 0 0 1 .027-.019l.04.04s.015-.012.03-.016l.036-.008-.012.023Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffd691",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.527 10.477.032.023.004.012h.003c.004-.004.016-.008.024-.012l.058-.012-.02.035-.003.02c.086.02.129.07.129.129 0 .086-.102.14-.23.14a.33.33 0 0 1-.169-.039c-.043-.023-.07-.058-.07-.097 0-.031.008-.067.031-.09a.15.15 0 0 1 .094-.043q.001-.004-.004-.008l-.039-.035h.078l.024.016.02-.016c.003-.008.011-.016.019-.016q.007-.005.008-.004c0-.003.004-.003.004-.003l.003.007-.003-.007Zm-.004.02h-.003l-.016.01-.031.028-.036-.02h-.027l.012.012c.008.004.008.012.012.016v.004l.004.004h-.012.011v.008h-.011a.12.12 0 0 0-.09.035.11.11 0 0 0-.031.082q.002.051.062.086a.33.33 0 0 0 .156.035c.125 0 .211-.055.211-.125 0-.05-.043-.102-.125-.117l-.007-.004.007-.031.004-.008-.015.004q-.013.004-.02.007-.007.005-.008.004v.004h-.004l-.007.008-.02-.027Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.504 10.89s-.164-.085-.238-.097c-.094-.016-.196-.004-.243-.004l.079.047q.064.04.144.062c.133.024.258-.007.258-.007m.047.008s.11-.085.219-.093a.7.7 0 0 1 .27.015s-.04.016-.063.032c-.024.007-.082.046-.176.046-.09 0-.192-.007-.207-.003Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#058e6e",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.988 10.777.035.004h.063q.017-.005.039-.004c.043 0 .094 0 .14.008q.034.007.075.02l.078.035.062.031q.016.007.02.008l.008.004-.004.008.004.007H10.5q-.005.002-.016.004a.74.74 0 0 1-.242.004.6.6 0 0 1-.148-.066Zm.516.114.004.007.02-.003-.02-.012Zm-.024-.004q-.006.001-.007-.004-.028-.013-.067-.031a.5.5 0 0 0-.078-.032c-.023-.011-.047-.015-.062-.02h-.004c-.043-.007-.094-.007-.137-.007h-.04a.04.04 0 0 1-.019.004h-.011l.054.031q.06.04.137.063a.7.7 0 0 0 .234-.004m.532-.067c-.051-.008-.13-.023-.242-.008a.35.35 0 0 0-.145.047q-.025.017-.043.028h.09c.039.004.086.004.129.004a.3.3 0 0 0 .156-.043c.004 0 .008-.004.012-.004.011-.008.031-.016.043-.024m.035.004h-.004v.004h-.004a.03.03 0 0 0-.016.008.1.1 0 0 0-.043.02q-.005.003-.011.007c-.024.012-.086.043-.164.043H10.8c-.043 0-.094 0-.133-.004h-.074l-.067.004.02-.015.004.007-.004-.007.004-.004q.006-.001.011-.008l.051-.031a.4.4 0 0 1 .157-.051.7.7 0 0 1 .273.015l.027.004",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.52 10.793c-.02-.016-.04-.031-.051-.055a.1.1 0 0 1-.016-.062q-.001-.037.016-.067a.2.2 0 0 1 .05-.054q.035.024.051.054.019.03.02.067a.1.1 0 0 1-.02.062.14.14 0 0 1-.05.055m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.52 10.547.007.004q.034.024.055.054.016.036.02.07a.2.2 0 0 1-.02.067.2.2 0 0 1-.055.059l-.007.004-.008-.004a.2.2 0 0 1-.051-.059.13.13 0 0 1-.02-.066.2.2 0 0 1 .02-.07.2.2 0 0 1 .05-.055Zm0 .02q-.026.022-.04.046a.1.1 0 0 0-.02.063q.002.032.02.062a.14.14 0 0 0 .04.043.2.2 0 0 0 .043-.043.12.12 0 0 0 .015-.062.1.1 0 0 0-.015-.063.2.2 0 0 0-.043-.047m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.48 10.969s.024-.051.028-.094l-.008-.07h.031s.016.039.016.07l-.008.078-.027.004-.032.008",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#058e6e",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.488 10.797h.051l.004.008v.004q.004.009.008.02a.2.2 0 0 1 .008.046l-.008.086-.035.004-.028.008h-.008v-.004l-.011-.004c0-.004.004-.004.004-.008q.004-.007.007-.02a.2.2 0 0 0 .016-.062Zm.008.156.012-.004.023-.004.008-.07a.1.1 0 0 0-.008-.043q-.004-.011-.008-.016v-.004h-.011l.008.063a.3.3 0 0 1-.02.066q.001.006-.004.012m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.594 6.355c0-.02.02-.03.043-.03.027 0 .047.01.047.03s-.02.036-.047.036a.1.1 0 0 1-.032-.008q-.01-.012-.011-.024",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.613 6.34q-.012.005-.011.015v.004c0 .008.003.012.011.02.004.004.016.004.024.004.023 0 .039-.012.039-.028q-.001-.01-.008-.015a.1.1 0 0 0-.031-.008q-.018-.002-.024.008m-.011-.012a.1.1 0 0 1 .035-.008c.015 0 .031 0 .039.008q.018.011.02.027c0 .024-.028.043-.06.043q-.023 0-.034-.011-.014-.011-.016-.028v-.004q-.001-.016.016-.027m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.652 6.273c0-.02.024-.03.051-.03.008 0 .02 0 .027.007q.012.006.012.023c0 .016-.015.032-.039.032q-.01.001-.02-.004c-.003 0-.011-.004-.015-.004l-.012-.012c0-.004-.004-.008-.004-.012m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.66 6.273s.004.004.004.008l.008.008c.004.004.012.004.015.008h.016a.1.1 0 0 0 .024-.008q.006-.005.007-.016a.03.03 0 0 0-.007-.02q-.012-.006-.024-.007a.1.1 0 0 0-.031.008.02.02 0 0 0-.012.02m.004-.027q.014-.012.04-.012.016 0 .034.012a.04.04 0 0 1 .012.027c0 .008-.004.02-.012.028a.1.1 0 0 1-.035.008h-.02q-.012-.004-.019-.008l-.016-.012q-.001-.011-.003-.016a.03.03 0 0 1 .02-.027m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7 6.176c0-.02.019-.031.038-.031h.02l.015.003.012.012.004.016c0 .02-.023.031-.047.031a.1.1 0 0 1-.031-.008q-.012-.011-.012-.023m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.754 6.148h-.016c-.015 0-.031.012-.031.028q0 .007.012.015c.004.008.015.008.023.008.024 0 .04-.008.04-.023 0-.004-.005-.008-.005-.012q-.004-.007-.007-.008c-.004-.004-.012-.004-.016-.008m-.016-.011h.02c.008.004.015.004.02.008a.03.03 0 0 1 .015.015c0 .004.004.008.004.016 0 .023-.027.035-.055.035v-.004.004a.1.1 0 0 1-.035-.008.05.05 0 0 1-.02-.027c0-.024.028-.04.051-.04m0 0v.008Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.703 6.07c0-.02.02-.03.043-.03.008-.005.012 0 .02 0q.006 0 .011.007.006.001.012.008c0 .004.004.008.004.015 0 .016-.023.032-.043.032-.027 0-.047-.016-.047-.032m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.762 6.043h-.016c-.02 0-.035.012-.035.027q0 .011.012.016.008.007.027.008c.016 0 .035-.012.035-.024 0-.004-.004-.008-.004-.011q-.004-.007-.008-.008c-.003-.004-.007-.004-.011-.008m-.016-.012h.02q.009.007.02.008.005.005.01.016c0 .004.005.008.005.015 0 .02-.024.035-.051.035q-.022 0-.04-.007a.03.03 0 0 1-.015-.028c0-.023.024-.039.051-.039m.055.04h-.008Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.668 5.965c0-.02.02-.031.043-.031h.016l.02.007q.006.006.007.012.005.006.004.012c0 .02-.02.031-.043.031a.1.1 0 0 1-.031-.008c-.008-.008-.016-.015-.016-.023m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.727 5.941h-.016c-.016 0-.035.008-.035.024l.011.02q.011.006.028.007c.02 0 .035-.012.035-.027q.001-.006-.004-.012l-.008-.008q-.006-.002-.011-.004m-.016-.011q.007-.006.02 0 .009.001.019.008c.004.003.012.007.012.011q.005.008.004.016c0 .023-.024.039-.051.039v-.008.008q-.023 0-.035-.012-.019-.01-.02-.027c0-.024.024-.035.05-.035m0 0h-.004l.004.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.594 5.867c0-.015.023-.031.05-.031q.017 0 .028.012a.02.02 0 0 1 .012.02c0 .019-.016.034-.04.034h-.019q-.005-.001-.016-.007c-.004-.004-.007-.004-.007-.008q-.007-.011-.008-.016",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.645 5.844c-.028 0-.043.011-.043.023v.004q.004.006.003.012.006.004.012.008.006.005.012.004.005.004.016.003.03 0 .03-.03a.03.03 0 0 0-.007-.016q-.012-.007-.023-.008m-.06.023c0-.02.028-.035.06-.035q.017 0 .035.012c.008.004.015.015.015.023 0 .024-.02.043-.05.043q-.01.001-.02-.004a.03.03 0 0 1-.02-.008c-.003 0-.007-.007-.011-.011q-.007-.005-.008-.016Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.793c0-.02.02-.031.05-.031q.017 0 .028.011a.02.02 0 0 1 .012.02c0 .016-.016.031-.04.031h-.019a.03.03 0 0 1-.015-.008q-.006-.003-.012-.007c0-.008-.004-.012-.004-.016m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.508 5.793c0 .004.004.008.004.012.004.004.008.004.011.008q.006.004.012.003.005.005.016.004c.02 0 .031-.015.031-.027a.03.03 0 0 0-.008-.016q-.012-.009-.023-.007-.022 0-.031.007-.012.005-.012.016m0-.027q.018-.01.043-.008.017.001.035.008c.008.007.012.02.012.027 0 .02-.02.039-.047.039q-.013.001-.02-.004a.03.03 0 0 1-.02-.008c-.003 0-.011-.008-.011-.011q-.007-.005-.008-.016.002-.017.016-.027m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.39 5.727c0-.016.024-.032.047-.032.028 0 .047.016.047.032 0 .02-.02.03-.046.03-.004.005-.012 0-.016 0a.03.03 0 0 1-.016-.007.01.01 0 0 1-.008-.008q-.004-.005-.003-.015",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.398 5.723h.004v.004q-.001.005.004.011.001.007.008.008c.004.004.008.004.012.008h.011c.024 0 .04-.012.04-.027 0-.012-.016-.024-.04-.024a.1.1 0 0 0-.027.008zm-.011.011h-.004v-.007c0-.012.008-.02.015-.028a.1.1 0 0 1 .04-.008c.03 0 .054.016.054.036 0 .023-.023.039-.05.039h-.024a.03.03 0 0 0-.016-.008q-.006-.005-.011-.016-.005-.001-.004-.008m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.262 5.676c0-.02.023-.031.043-.031.027 0 .047.011.047.03 0 .02-.02.032-.043.032a.1.1 0 0 1-.032-.008.1.1 0 0 1-.015-.023m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.27 5.676.011.015q.011.01.028.008c.02 0 .035-.008.035-.023a.03.03 0 0 0-.008-.02.1.1 0 0 0-.031-.008c-.016 0-.035.012-.035.028m-.016 0c0-.024.027-.04.05-.04.016 0 .032.005.04.012.011.004.015.016.015.028 0 .023-.023.035-.05.035v-.004.004a.1.1 0 0 1-.036-.008.05.05 0 0 1-.02-.027m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.125 5.637c0-.02.02-.032.047-.032q.019 0 .031.012a.02.02 0 0 1 .012.02c0 .02-.02.031-.043.031h-.016q-.01-.001-.015-.008c-.004-.004-.008-.004-.012-.008q-.005-.01-.004-.015m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.133 5.637q-.001.006.004.011c0 .004.004.004.008.008q.005.005.011.004c.004.004.012.004.016.004q.018-.001.023-.008a.02.02 0 0 0 .012-.02c0-.003-.004-.011-.012-.015-.004-.008-.015-.008-.023-.008a.1.1 0 0 0-.031.008q-.007.005-.008.016m0-.028q.013-.009.039-.007.023 0 .035.007c.008.008.016.02.016.028q.001.016-.016.027-.012.012-.035.012-.007.001-.02-.004-.009-.001-.02-.008c-.003 0-.007-.008-.01-.012-.005-.004-.005-.007-.009-.015q.001-.017.02-.028m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.973 5.617c0-.015.02-.031.043-.031.03 0 .05.016.05.031 0 .02-.02.031-.05.031a.1.1 0 0 1-.028-.007q-.012-.012-.011-.024",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.98 5.613h.004v.004q0 .013.012.02a.03.03 0 0 0 .02.008q.021-.001.03-.008a.02.02 0 0 0 .013-.02c0-.012-.016-.027-.043-.027-.016 0-.032.012-.036.023m-.011.012h-.004v-.008c0-.02.023-.039.05-.039.036 0 .06.02.06.04 0 .01-.009.019-.016.027a.1.1 0 0 1-.043.011.04.04 0 0 1-.032-.011q-.01-.007-.015-.02m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.828 5.613c0-.02.02-.031.047-.031h.016c.007 0 .011.004.015.004q.012.006.012.012.005.007.004.015c0 .02-.02.032-.047.032a.04.04 0 0 1-.031-.012.02.02 0 0 1-.012-.02",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.89 5.586h-.015q-.031.001-.04.02h.005v.007q0 .008.012.016.005.007.023.008.017-.001.027-.008.012-.005.012-.016.001-.006-.004-.011a.01.01 0 0 0-.008-.008zm-.066.031h-.004v-.004c0-.023.024-.039.051-.039h.024c.007.004.011.004.02.008l.01.016q.006.004.005.015.001.017-.016.028-.017.009-.039.007h-.004a.04.04 0 0 1-.031-.011q-.011-.007-.016-.02m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.688 5.617c0-.02.023-.031.042-.031.028 0 .047.012.047.031 0 .016-.02.031-.043.031a.04.04 0 0 1-.03-.011q-.012-.007-.017-.02m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.695 5.617.012.016a.1.1 0 0 0 .027.008c.02 0 .036-.012.036-.024a.03.03 0 0 0-.008-.02.1.1 0 0 0-.032-.007c-.015 0-.035.012-.035.027m-.015 0c0-.023.027-.039.05-.039.016 0 .032.004.04.012q.016.007.015.027c0 .02-.023.035-.05.035v-.004.004q-.024 0-.036-.011c-.011-.004-.015-.016-.02-.024m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.547 5.617c0-.02.02-.031.043-.031s.047.012.047.031c0 .016-.024.031-.043.031-.004 0-.012 0-.016-.003q-.011-.002-.015-.004c-.008-.004-.008-.008-.012-.012q-.005-.006-.004-.012m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.555 5.617q-.001.001.004.008.001.007.007.008.006.004.012.008h.016c.015 0 .035-.012.035-.024 0-.015-.02-.027-.04-.027-.019 0-.034.012-.034.027m-.02 0c0-.023.027-.039.055-.039.027 0 .055.016.055.04 0 .019-.028.034-.051.034h-.02c-.008-.004-.011-.004-.02-.007l-.011-.012q-.004-.011-.008-.016m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.613 5.71c0-.019.024-.034.047-.034.027 0 .05.015.05.031 0 .02-.023.035-.046.035q-.01.001-.02-.004-.005-.002-.011-.004-.012-.006-.012-.011-.004-.006-.008-.012m.032.099c0-.02.02-.032.046-.032q.043.001.043.032 0 .03-.043.03h-.015q-.011-.003-.016-.007c-.004-.004-.008-.004-.012-.008q-.004-.01-.003-.015m.007.105c0-.02.02-.031.04-.031q.009-.006.019 0c.008 0 .012.004.016.004l.011.011q.005.005.004.016c0 .016-.02.031-.047.031a.04.04 0 0 1-.027-.011q-.017-.007-.016-.02m-.043.094c0-.02.02-.035.043-.035h.016c.008 0 .012.004.02.004q.006.005.007.011.005.008.004.016c0 .02-.02.035-.043.035-.008 0-.011 0-.02-.004q-.004-.002-.015-.004-.007-.006-.008-.011-.007-.006-.008-.012m-.078.082c0-.02.024-.031.051-.031.024 0 .04.011.04.03 0 .02-.016.032-.04.032h-.02q-.004-.004-.015-.008c-.004-.004-.008-.004-.008-.008q-.007-.01-.008-.015m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.621 5.71q.004.002.008.009.001.007.008.008.006.003.011.007h.016c.02 0 .035-.011.035-.027 0-.012-.015-.027-.039-.027a.04.04 0 0 0-.039.03m-.016 0c0-.022.024-.042.055-.042s.059.02.059.039c0 .02-.024.04-.055.04h-.02c-.007-.005-.011-.005-.019-.009l-.012-.011q-.007-.011-.008-.016m.047.099q-.001.005.004.011.001.004.008.008.006.005.012.004a.03.03 0 0 0 .015.004q.018-.001.024-.008a.02.02 0 0 0 .012-.02q0-.01-.012-.015-.006-.01-.024-.008c-.011 0-.023.004-.027.008q-.012.005-.012.016m0-.028q.017-.01.04-.008.023.001.035.008.016.011.015.028 0 .016-.015.027-.012.012-.036.012-.006.001-.02-.004-.009-.001-.015-.008c-.008 0-.011-.008-.015-.012q-.005-.005-.004-.015 0-.017.015-.028m.055.106h-.016c-.015 0-.03.011-.03.027q0 .008.01.016.014.007.024.008c.024 0 .04-.012.04-.024q.001-.006-.005-.012a.01.01 0 0 0-.007-.007q-.005-.007-.016-.008m-.016-.012h.024a.03.03 0 0 1 .015.008l.016.012a.04.04 0 0 1 .004.02c0 .019-.023.034-.055.034v-.004.004a.06.06 0 0 1-.035-.011c-.008-.004-.015-.016-.015-.024 0-.023.023-.039.046-.039m0 0v.008Zm-.023.102h-.016c-.02 0-.035.011-.035.03h-.004c.004.005.004.005.004.009q.006.007.012.007c.004.004.008.004.012.008h.015q.017-.001.028-.008a.03.03 0 0 0 .007-.02v-.01q-.006-.008-.011-.009-.006-.004-.012-.007m-.063.03h-.003c0-.023.02-.042.05-.042h.02c.008.004.015.004.02.008.003.004.011.007.011.015q.007.005.008.016a.03.03 0 0 1-.02.027q-.012.012-.035.012h-.02q-.012-.004-.019-.008l-.012-.012q-.006-.01-.007-.015Zm-.07.083q.005.006.004.012.006.003.012.007.006.005.011.004.005.005.016.004.018-.001.024-.008a.03.03 0 0 0 .007-.02q-.001-.009-.007-.015-.006-.01-.024-.008a.1.1 0 0 0-.031.008q-.012.005-.012.016m.004-.027q.014-.01.04-.008.022.001.034.008c.008.007.016.015.016.027s-.008.02-.016.027q-.012.012-.035.012-.012.001-.02-.004a.03.03 0 0 1-.019-.008c-.004 0-.008-.008-.012-.012q-.007-.004-.007-.015 0-.017.02-.027m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.438 5.55c0-.015.019-.03.046-.03.024 0 .043.011.043.03 0 .02-.02.036-.039.036-.008 0-.011 0-.02-.004q-.004-.002-.015-.004-.007-.006-.008-.012-.007-.005-.008-.011",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.484 5.523c-.02 0-.039.016-.039.028v.004s.004.004.004.008q.006.006.012.007.006.004.012.008h.015c.016 0 .032-.012.032-.027 0-.016-.016-.028-.036-.028m-.054.028c0-.02.023-.04.054-.04.028 0 .051.016.051.04 0 .02-.023.039-.047.039h-.02q-.012-.004-.019-.008c-.004-.004-.011-.008-.011-.012q-.007-.01-.008-.015Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.313 5.5c0-.023.019-.035.042-.035q.05.001.051.031c0 .02-.02.035-.047.035h-.015q-.011-.004-.016-.008l-.012-.011q-.005-.006-.004-.012m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.32 5.5q-.001.006.004.012l.008.008.012.003h.015c.02 0 .04-.011.04-.027q0-.011-.012-.016a.1.1 0 0 0-.032-.007c-.007 0-.02 0-.023.007a.02.02 0 0 0-.012.02m0-.031a.1.1 0 0 1 .035-.008c.016 0 .032 0 .043.008q.014.01.016.027c0 .024-.023.043-.055.043q-.006.001-.02-.004c-.007 0-.01-.004-.019-.008l-.011-.011q-.005-.005-.004-.016 0-.018.015-.031m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.172 5.469c0-.024.02-.035.05-.035.024 0 .04.011.04.03 0 .02-.016.032-.04.032h-.019a.03.03 0 0 1-.015-.008c-.004-.004-.008-.004-.012-.008 0-.007-.004-.011-.004-.015",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.164 5.465v.004c0 .004.004.008.004.011.004.004.008.012.016.012a.03.03 0 0 0 .015.008.1.1 0 0 0 .024.004.06.06 0 0 0 .035-.012.04.04 0 0 0 .012-.027.04.04 0 0 0-.012-.027.1.1 0 0 0-.035-.008c-.016 0-.032 0-.043.008-.008.007-.016.015-.016.027m.016 0q.002.006.004.012l.007.007c.004.004.012.004.016.004q.006.005.012.004h.004q.01-.001.023-.008a.03.03 0 0 0 .008-.02q-.001-.009-.008-.015-.012-.01-.023-.008a.1.1 0 0 0-.032.008q-.01.005-.011.016m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.027 5.445c0-.015.02-.03.047-.03.028 0 .047.015.047.03 0 .02-.02.032-.047.032q-.017-.001-.027-.008-.011-.012-.016-.024",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.04 5.441v.004l.01.02q.013.007.024.008.02-.001.028-.008a.02.02 0 0 0 .011-.02q0-.01-.011-.015-.008-.007-.028-.008-.03.001-.035.02m-.013.012h-.007v-.008c0-.02.027-.035.054-.035q.023.001.04.008c.011.008.015.02.015.027 0 .012-.004.024-.016.028a.07.07 0 0 1-.039.011q-.023 0-.035-.011a.02.02 0 0 1-.012-.02m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.89 5.45c0-.02.02-.032.044-.032s.046.012.046.031c0 .02-.023.031-.046.031a.1.1 0 0 1-.032-.007q-.01-.012-.011-.024m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.898 5.45q0 .012.012.019a.04.04 0 0 0 .024.008c.023 0 .039-.012.039-.028 0-.015-.016-.023-.04-.023-.019 0-.035.008-.035.023m-.02 0c0-.024.028-.036.056-.036.027 0 .054.012.054.035s-.027.04-.054.04V5.48v.008c-.012 0-.028-.004-.036-.011a.05.05 0 0 1-.02-.028m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.742 5.469c0-.02.02-.032.043-.032h.02q.006.004.011.008l.012.012q.005.006.004.012c0 .02-.02.031-.043.031h-.016q-.01-.004-.015-.008l-.012-.012q-.005-.005-.004-.011m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8 5.445h-.015c-.02 0-.035.008-.035.024q-.001.006.004.011l.008.008c.004 0 .008.004.011.004h.016c.02 0 .035-.008.035-.023q.001-.006-.004-.012l-.008-.008c-.003 0-.007-.004-.011-.004m-.015-.015q.013-.001.02.004a.03.03 0 0 1 .02.007l.01.012q.006.008.005.016c0 .023-.024.039-.05.039q-.008.001-.02-.004-.011-.001-.016-.008-.011-.006-.016-.012-.005-.005-.004-.015c0-.024.024-.04.051-.04m.055.039h-.008Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.605 5.504c0-.02.02-.031.047-.031.024 0 .043.011.043.03 0 .02-.02.032-.043.032a.1.1 0 0 1-.03-.008q-.015-.01-.017-.023m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.613 5.504c0 .004.008.012.012.016q.011.009.027.007c.02 0 .036-.007.036-.023s-.016-.027-.036-.027c-.023 0-.039.011-.039.027m-.015 0c0-.024.023-.04.054-.04.028 0 .051.016.051.04 0 .023-.023.035-.05.035v-.004.004q-.023-.001-.04-.008-.014-.01-.015-.027m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3 6.355c0-.02.02-.03.048-.03l.015.003c.004 0 .012 0 .016.004q.007.006.008.012.005.006.004.011c0 .02-.02.036-.04.036h-.019q-.011-.001-.016-.008-.006 0-.011-.012Q8.3 6.365 8.3 6.36",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36 6.332h-.012c-.024 0-.04.008-.04.023v.004q-.001.006.005.012c0 .004.003.004.007.008q.006.005.012.004.011.006.016 0h.004c.015 0 .03-.012.03-.028q0-.006-.003-.007-.001-.006-.008-.012c-.004 0-.008-.004-.012-.004m-.016-.012c.008-.004.015 0 .023 0a.03.03 0 0 1 .016.008l.012.012.003.015c0 .024-.023.04-.046.043q-.012 0-.024-.003-.007-.002-.02-.004-.005-.008-.011-.016t-.004-.016v-.004c0-.023.023-.035.05-.035m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.238 6.273c0-.02.02-.03.043-.03.028 0 .047.01.047.03 0 .016-.02.032-.043.032q-.01.001-.02-.004-.005-.002-.011-.004l-.012-.012c0-.004-.004-.008-.004-.012m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.281 6.246c-.015 0-.035.012-.035.027 0 .004.004.004.004.008q.004.007.008.008.006.004.012.008h.015c.02 0 .035-.012.035-.024a.02.02 0 0 0-.011-.02c-.004-.003-.016-.007-.028-.007m-.05.027c0-.023.023-.039.05-.039q.023 0 .04.012c.011.004.015.016.015.027 0 .02-.024.036-.05.036h-.02l-.02-.008-.012-.012q-.005-.011-.004-.016m0 0h.007Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.195 6.176c0-.02.02-.031.047-.031q.02 0 .031.007.012.012.012.024 0 .03-.043.031c-.004 0-.012 0-.015-.004q-.011.001-.016-.004l-.012-.011q-.005-.006-.004-.012m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.203 6.176q-.001.007.004.008.001.005.008.011c.004 0 .008.004.012.004h.015q.018.002.024-.008.01-.004.011-.015a.02.02 0 0 0-.011-.02q-.006-.007-.024-.008-.02.001-.027.008a.02.02 0 0 0-.012.02m0-.028a.07.07 0 0 1 .04-.011q.023 0 .034.011.017.011.016.028.001.016-.016.027a.1.1 0 0 1-.035.008c-.004.004-.012 0-.02 0q-.009-.001-.019-.008l-.012-.012c-.004-.003-.004-.011-.004-.015 0-.012.004-.024.016-.028m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.191 6.07c0-.02.02-.03.043-.03q.05 0 .051.03c0 .016-.02.032-.05.032-.024 0-.04-.016-.04-.032",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.188 6.074q0 .012.011.024a.1.1 0 0 0 .035.007.1.1 0 0 0 .043-.007c.008-.008.016-.02.016-.028a.03.03 0 0 0-.016-.027.1.1 0 0 0-.043-.012c-.027 0-.05.016-.05.04v.003Zm.046-.031c-.015 0-.03.008-.035.02h.004v.007q.001.011.008.016a.04.04 0 0 0 .023.008.1.1 0 0 0 .032-.008q.01-.005.011-.016a.02.02 0 0 0-.011-.02.1.1 0 0 0-.032-.007m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.223 5.965c0-.02.02-.031.05-.031.024 0 .04.011.04.03 0 .02-.016.032-.04.032h-.02a.03.03 0 0 1-.015-.008c-.004-.004-.008-.004-.011-.008q-.002-.01-.004-.015m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.23 5.965c0 .004.004.008.004.012q.007.003.008.007c.004.004.012.004.016.004q.006.005.012.004h.003q.012-.001.024-.008a.03.03 0 0 0 .008-.02q-.001-.009-.008-.015-.012-.01-.024-.008a.1.1 0 0 0-.03.008q-.013.005-.013.016m0-.027q.02-.01.043-.008.018.001.036.008a.04.04 0 0 1 .011.027q0 .017-.011.027a.06.06 0 0 1-.036.012q-.011.001-.02-.004a.03.03 0 0 1-.019-.008c-.007 0-.011-.008-.015-.012 0-.003-.004-.007-.004-.015 0-.012.008-.02.015-.027m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.297 5.867c0-.015.02-.031.039-.031h.02c.007.004.011.004.015.008l.012.011q.005.006.004.012c0 .02-.02.035-.047.035a.1.1 0 0 1-.027-.007c-.008-.008-.016-.016-.016-.024",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.355 5.844h-.019a.03.03 0 0 0-.02.008c-.007.003-.011.011-.011.015v.004q0 .013.011.02.012.007.024.007c.023 0 .039-.015.039-.03q.001-.008-.004-.009-.001-.006-.008-.011-.006-.002-.012-.004m-.02-.012h.024q.007.001.02.008l.012.012a.03.03 0 0 1 .004.015c0 .024-.024.043-.055.043a.06.06 0 0 1-.035-.012c-.008-.007-.016-.015-.016-.027v-.004c0-.008.004-.02.016-.023a.04.04 0 0 1 .03-.012m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39 5.793c0-.02.02-.031.047-.031.024 0 .043.011.043.031 0 .016-.02.031-.043.031-.027 0-.046-.011-.046-.031m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.438 5.77c-.024 0-.04.007-.04.023q.002.026.04.027c.019 0 .035-.015.035-.027 0-.016-.016-.023-.036-.023m-.055.023c0-.023.023-.035.055-.035.027 0 .05.012.05.035 0 .02-.023.039-.05.039-.032 0-.055-.016-.055-.039m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.727c0-.016.023-.032.043-.032.027 0 .05.016.05.032 0 .02-.023.03-.046.03q-.01.007-.02 0l-.015-.003-.012-.012c0-.004-.004-.008-.004-.015",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.543 5.703c-.016 0-.031.012-.031.024v.007h-.004v.004q.006.007.012.008c0 .004.007.008.011.008h.016c.02 0 .035-.012.035-.027q-.001-.011-.008-.016a.1.1 0 0 0-.031-.008m-.047.02c.004-.02.024-.032.047-.032q.026.001.039.008c.012.008.02.02.02.028 0 .023-.028.039-.055.039h-.02a.03.03 0 0 1-.02-.008l-.015-.012c0-.008-.004-.012-.004-.02v-.003Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.629 5.676c0-.02.02-.031.05-.031q.014 0 .028.007.012.012.012.024c0 .02-.016.031-.04.031q-.009.001-.019-.004c-.004 0-.012 0-.015-.004l-.012-.011q-.002-.006-.004-.012m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.637 5.676c0 .004.004.008.004.008q.004.005.007.011l.016.004h.016q.011.002.023-.008.007-.004.008-.015a.03.03 0 0 0-.008-.02q-.011-.007-.023-.008c-.016 0-.024.004-.032.008a.02.02 0 0 0-.011.02m0-.028a.1.1 0 0 1 .043-.011q.018 0 .03.011.018.011.017.028 0 .016-.012.027-.018.007-.035.008c-.008.004-.016 0-.024 0a.03.03 0 0 1-.015-.008q-.011-.006-.016-.012c0-.003-.004-.011-.004-.015 0-.012.004-.024.016-.028m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.77 5.637c0-.02.02-.032.039-.032.03 0 .05.012.05.032s-.02.031-.046.031c-.012 0-.02-.004-.032-.008q-.011-.011-.011-.023m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.777 5.637q0 .012.012.02.012.006.024.007c.023 0 .039-.012.039-.027q0-.011-.012-.016a.1.1 0 0 0-.031-.008c-.016 0-.032.008-.032.024m-.015 0c0-.024.023-.035.047-.035q.023-.002.043.007c.007.008.015.016.015.028 0 .023-.027.039-.055.039v-.008.008a.06.06 0 0 1-.035-.012q-.016-.011-.015-.027m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.922 5.617c0-.015.02-.031.043-.031.008-.004.012 0 .015 0q.011.001.016.008.006.001.012.008c0 .003.004.007.004.015 0 .02-.024.031-.047.031q-.02.002-.031-.007-.012-.006-.012-.024m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98 5.59h-.015c-.02 0-.035.012-.035.027q0 .013.011.02a.04.04 0 0 0 .024.008q.017-.001.027-.008c.004-.004.012-.012.012-.02 0-.004-.004-.008-.004-.012q-.004-.006-.008-.007c-.004-.004-.008-.004-.012-.008m-.015-.012h.02q.009.007.019.008.006.005.012.016c0 .003.004.007.004.015q-.002.017-.016.028a.07.07 0 0 1-.04.011v-.008.008c-.01 0-.027-.004-.034-.011-.012-.004-.016-.016-.02-.024v-.004c0-.02.027-.039.055-.039m0 0v.008Zm.055.04h-.008Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.063 5.613c0-.02.023-.031.046-.031.024 0 .043.012.043.031 0 .02-.02.032-.039.032-.008 0-.011 0-.02-.004q-.004.001-.015-.004-.007-.006-.008-.012-.007-.006-.008-.012m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07 5.613q.005.007.004.008l.012.012c.004 0 .008.004.012.004h.015c.016 0 .032-.008.032-.024 0-.015-.016-.027-.036-.027-.023 0-.039.012-.039.027m-.015 0c0-.023.027-.039.054-.039.028 0 .051.016.051.04 0 .023-.023.034-.047.034-.008.004-.015 0-.02 0a.03.03 0 0 1-.019-.007l-.011-.012a.03.03 0 0 1-.008-.016m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.203 5.617c0-.02.02-.031.05-.031.009 0 .02 0 .028.008q.012.006.012.023c0 .016-.016.031-.04.031-.007 0-.01 0-.019-.003q-.008-.002-.015-.004l-.012-.012c0-.004-.004-.008-.004-.012m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21 5.617s.005.004.005.008q.004.007.008.008.008.004.015.008h.016a.1.1 0 0 0 .023-.008q.007-.005.008-.016a.03.03 0 0 0-.008-.02q-.01-.006-.023-.007-.022.001-.031.008a.02.02 0 0 0-.012.02m0-.027a.1.1 0 0 1 .044-.012q.018 0 .031.012.017.01.016.027c0 .008-.004.02-.012.028a.1.1 0 0 1-.035.007H9.23c-.003-.004-.011-.004-.015-.007l-.016-.012c0-.008-.004-.012-.004-.016q-.001-.02.016-.027m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.348 5.617c0-.02.02-.031.043-.031.027 0 .05.012.05.031 0 .016-.02.031-.05.031-.012 0-.02-.003-.032-.011a.02.02 0 0 1-.011-.02m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.355 5.617q0 .008.012.016a.1.1 0 0 0 .024.008.1.1 0 0 0 .03-.008q.013-.005.013-.016a.02.02 0 0 0-.012-.02.1.1 0 0 0-.031-.007c-.02 0-.036.012-.036.027m-.015 0c0-.023.023-.039.05-.039q.023 0 .04.012a.03.03 0 0 1 .02.027c0 .008-.009.02-.016.028a.1.1 0 0 1-.043.007v-.004.004a.06.06 0 0 1-.036-.011c-.007-.004-.015-.016-.015-.024m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.273 5.71c0-.019.024-.034.047-.034.028 0 .047.015.047.031 0 .02-.02.035-.047.035a.04.04 0 0 1-.027-.012q-.017-.005-.016-.02m-.027.099c0-.02.02-.032.04-.032.026 0 .05.012.05.032s-.024.03-.047.03-.043-.01-.043-.03m-.012.105c0-.02.024-.031.051-.031.024 0 .043.012.043.031 0 .016-.02.031-.043.031-.004 0-.012 0-.016-.004q-.01-.002-.015-.003-.012-.006-.012-.012-.004-.006-.008-.012m.043.094c0-.02.024-.035.051-.035h.016q.008.004.015.007.007.006.008.012.005.006.004.012c0 .02-.02.035-.043.035a.04.04 0 0 1-.031-.012c-.008-.004-.016-.011-.016-.02m.078.083c0-.02.02-.031.04-.031.03 0 .05.011.05.03 0 .02-.02.032-.047.032a.1.1 0 0 1-.027-.008c-.008-.008-.016-.015-.016-.023m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.281 5.71.004-.003q0 .013.012.02a.1.1 0 0 0 .023.007q.038-.002.04-.027c0-.012-.016-.027-.04-.027a.04.04 0 0 0-.027.011.02.02 0 0 0-.012.02m-.004 0h-.011q.002-.016.015-.03a.1.1 0 0 1 .04-.012c.03 0 .054.02.054.039 0 .02-.023.04-.055.04a.06.06 0 0 1-.035-.013c-.008-.004-.015-.015-.015-.023Zm.043.036v-.004Zm-.03.04c-.017 0-.032.007-.032.023 0 .015.015.027.035.027s.039-.012.039-.027q0-.011-.012-.016a.1.1 0 0 0-.03-.008m-.052.023c0-.024.028-.036.051-.036.016 0 .031 0 .04.008s.019.016.019.028c0 .023-.028.039-.055.039s-.055-.016-.055-.04m.012.105q-.001.001.004.008.001.007.008.008c.004.004.008.004.011.008h.016q.018-.001.024-.008.009-.005.007-.016c0-.008 0-.016-.008-.02q-.005-.006-.023-.007a.1.1 0 0 0-.031.008.03.03 0 0 0-.008.02m0-.027q.013-.012.04-.012.022 0 .034.012a.03.03 0 0 1 .016.027c0 .008-.008.02-.016.027a.1.1 0 0 1-.035.008h-.02l-.019-.008-.012-.011q-.007-.011-.008-.016a.03.03 0 0 1 .02-.027m.094.093q-.006-.004-.012-.003a.04.04 0 0 0-.031.011.02.02 0 0 0-.012.02l.004-.004q0 .013.012.02a.1.1 0 0 0 .027.007c.008 0 .02-.004.023-.008a.02.02 0 0 0 .012-.02q.001-.005-.004-.01c0-.005-.004-.005-.008-.009q-.005-.005-.011-.004m-.059.028h-.012q.002-.02.016-.031a.1.1 0 0 1 .04-.012.1.1 0 0 1 .023.004.03.03 0 0 1 .015.008l.012.011q.005.005.004.016.001.02-.016.027c-.008.008-.023.012-.035.012v-.004.004a.07.07 0 0 1-.039-.012c-.008-.004-.016-.015-.016-.023Zm.098-.004h-.008Zm-.012.086q0 .012.012.02.011.006.023.007c.024 0 .04-.012.04-.027q0-.011-.012-.016a.1.1 0 0 0-.032-.008c-.015 0-.03.008-.03.024m-.016 0c0-.024.024-.035.047-.035.016 0 .032 0 .043.008q.017.01.016.027c0 .023-.024.039-.055.039V6.12v.008a.06.06 0 0 1-.035-.012c-.008-.008-.016-.015-.016-.027m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.453 5.55c0-.015.02-.03.047-.03s.047.011.047.03c0 .02-.02.036-.047.036-.012-.004-.023-.004-.031-.012-.004-.004-.012-.011-.012-.02",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.46 5.547.005.004q0 .012.012.02a.04.04 0 0 0 .023.007c.023 0 .04-.012.04-.027a.02.02 0 0 0-.013-.02q-.008-.007-.027-.008c-.02 0-.035.012-.04.024m-.015.004c0-.02.024-.04.055-.04q.022 0 .04.012c.01.004.015.016.015.028 0 .023-.024.039-.055.039h-.004a.04.04 0 0 1-.031-.012q-.011-.006-.016-.023Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.582 5.5c0-.023.02-.035.043-.035s.047.012.047.031c0 .02-.024.035-.043.035h-.016q-.01-.004-.015-.008l-.012-.011q-.005-.006-.004-.012m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59 5.5q-.001.006.004.012l.008.008q.005.001.011.003h.016c.016 0 .035-.011.035-.027s-.016-.023-.039-.023q-.017-.002-.027.007a.03.03 0 0 0-.008.02m0-.031a.1.1 0 0 1 .035-.008c.027 0 .055.012.055.035s-.024.043-.051.043q-.007.001-.02-.004c-.007 0-.011-.004-.02-.008l-.01-.011c-.005-.004-.005-.008-.009-.016q.001-.018.02-.031m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.719 5.469c0-.024.023-.035.043-.035s.047.011.047.03c0 .02-.02.032-.043.032a.1.1 0 0 1-.032-.008q-.01-.011-.015-.023",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71 5.465v.004c.005.008.009.015.02.023q.012.012.036.012m-.04-.04q.006.014.012.02.011.007.028.008c.02 0 .035-.012.035-.027q0-.011-.012-.016c-.008-.008-.02-.008-.027-.008-.016 0-.032.008-.035.024m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.863 5.445c0-.015.02-.03.047-.03.004 0 .012 0 .016.003q.008.002.015.004.007.006.008.012.005.005.004.011c0 .02-.02.032-.039.032-.008.003-.012 0-.02 0a.03.03 0 0 1-.015-.008q-.006-.001-.012-.008c0-.004-.004-.008-.004-.016m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.922 5.422H9.91c-.023 0-.039.012-.039.023 0 .004.004.008.004.012l.008.008c.004.004.012.004.015.008h.016c.016 0 .031-.012.031-.028 0-.004 0-.004-.004-.008a.01.01 0 0 0-.007-.007q-.006-.004-.012-.008m-.016-.012h.024q.007.004.015.008l.012.012a.03.03 0 0 1 .004.015c0 .024-.024.04-.047.04h-.02q-.012-.006-.019-.008a.03.03 0 0 1-.016-.016c0-.004-.004-.008-.004-.012v-.004c0-.02.024-.035.051-.035m.055.035h-.008Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.004 5.45c0-.02.02-.032.047-.032q.018 0 .031.012a.02.02 0 0 1 .012.02q-.001.03-.043.03h-.016q-.011-.001-.015-.003-.012-.006-.012-.012-.005-.008-.004-.016m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.023 5.434q-.01.004-.011.015-.001.006.004.012.001.007.007.008.006.004.012.008h.016q.017-.001.023-.008a.02.02 0 0 0 .012-.02q0-.007-.012-.015-.005-.01-.023-.008-.02.001-.028.008m-.011-.012q.016-.01.039-.008.023.001.035.008c.012.008.016.02.016.027q.001.017-.016.028a.04.04 0 0 1-.031.011h-.024l-.02-.008L10 5.465q-.005-.005-.004-.016-.001-.016.016-.027m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.152 5.469c0-.02.02-.032.043-.032h.02a.03.03 0 0 1 .015.008q.006 0 .012.012.002.006.004.012c0 .02-.023.031-.05.031a.04.04 0 0 1-.028-.012.02.02 0 0 1-.012-.02",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.21 5.445q-.005-.006-.01 0h-.005c-.02 0-.03.008-.035.016h.004v.008q.001.01.008.015.011.01.023.008.019.001.032-.004c.007-.008.011-.011.011-.02 0-.003-.004-.007-.004-.011l-.007-.008c-.004-.004-.012-.004-.016-.004m-.062.032h-.007v-.008c0-.024.027-.04.054-.04q.013-.001.02.005.012.002.02.003.01.008.015.016l.004.016q-.001.016-.02.027c-.007.008-.023.012-.039.012l-.035-.012c-.004-.008-.012-.016-.012-.02m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.285 5.504c0-.02.02-.031.05-.031.024 0 .04.011.04.03 0 .02-.016.032-.04.032-.007 0-.01 0-.019-.004q-.008.001-.015-.004l-.012-.011q-.002-.006-.004-.012m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.293 5.504c0 .004.004.008.004.008l.012.011q.006.002.011.004h.016c.008 0 .02 0 .023-.007q.007-.005.008-.016a.03.03 0 0 0-.008-.02.04.04 0 0 0-.023-.007.1.1 0 0 0-.031.007.02.02 0 0 0-.012.02m0-.027a.1.1 0 0 1 .043-.012c.012 0 .027.004.035.012a.04.04 0 0 1 .012.027q0 .017-.012.027a.1.1 0 0 1-.035.008c-.008.004-.016 0-.02 0a.03.03 0 0 1-.02-.008c-.003-.004-.01-.008-.01-.011a.03.03 0 0 1-.009-.016c0-.012.008-.024.016-.027m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.121 7.629h-.043v-.031h-.062v.12h.062v.083h-.14v.234h.078v.473h-.157v.246h1.188v-.246h-.152v-.473h.078v-.234h-.145v-.082h.067v-.117h-.067v.03h-.043v-.03h-.062v.03h-.047v-.03h-.067v.117h.067V7.8H9.53v-.262h.078v-.117h-.078v.031h-.043v-.031h-.062v.031h-.043v-.031h-.078v.117h.082v.262H9.23v-.082h.07v-.117h-.07v.03h-.039v-.03h-.074v.03ZM8.86 8.754h1.188Zm0-.059h1.188Zm0-.062h1.188Zm0-.059h1.188Zm0-.066h1.188Zm.157-.051h.879Zm0-.059h.879Zm0-.062h.879Zm0-.063h.879Zm0-.062h.879Zm0-.059h.879Zm0-.058h.879Zm-.079-.059H9.97Zm-.003-.058h1.035Zm0-.063h1.035Zm0-.055h1.035Zm.14-.062h.75Zm.301-.055h.148Zm.004-.062h.144Zm0-.059h.144Zm0-.059h.144ZM9.3 7.489h.3Zm-.227.25h.156Zm-.062-.074h.285Zm0 1.09v-.059Zm0-.121v-.059Zm-.082.004v.058Zm.144.058v-.062Zm.082.059v-.059Zm0-.121v-.059Zm0-.125v-.051Zm0-.11v-.062Zm-.082.176v-.066Zm-.14 0v-.066Zm.296-.066v.066Zm.07 0v-.051Zm-.226-.11v.063Zm.156 0v.063Zm.145 0v.063Zm-.074 0v-.062Zm.074-.125v.063Zm0-.12v.062Zm-.074-.06v.063Zm.074-.054v.055Zm-.145-.004v.063Zm-.156 0v.063Zm-.062-.058v.062Zm.14 0v.062Zm.149 0v.062Zm.078-.059v.059Zm-.149-.004v.063Zm-.156 0v.063Zm-.062-.055v.059Zm.285-.004v.063Zm-.145-.113v.059Zm.672-.004h-.152Zm.067-.074H9.6Zm-.004 1.09v-.059Zm0-.121v-.059Zm.082.004v.058Zm-.145.058v-.062Zm-.078.059v-.059Zm0-.121v-.059Zm0-.125v-.051Zm0-.11v-.062Zm.082.176v-.066Zm.14 0v-.066Zm-.296-.066v.066Zm-.07 0v-.051Zm.222-.11v.063Zm-.152 0v.063Zm-.149 0v.063Zm.079 0v-.062Zm-.079-.125v.063Zm0-.12v.062Zm.079-.06v.063Zm-.079-.054v.055Zm.149-.004v.063Zm.156 0v.063Zm.063-.058v.062Zm-.141 0v.062Zm-.148 0v.062Zm-.079-.059v.059Zm.149-.004v.063Zm.152 0v.063Zm.067-.055v.059Zm-.29-.004v.063Zm.149-.113v.059Zm-.305.656v-.062Zm0-.246v-.058Zm0 .121v-.062Zm0-.238v-.058Zm0-.12v-.056Zm0-.173V7.68Zm0-.12v-.06Zm-.37.097h.155Zm.304-.18h.144Zm.293.18h.152Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.297 7.414h.098v.031h.02v-.03H9.5v.03h.02v-.03h.101v.132h-.078v.242h.121v-.062h-.066v-.133h.086v.031h.03v-.031h.083v.031h.02v-.031h.09v.133h-.071v.066h.148v.25h-.078V8.5h.153v.262H8.848V8.5h.156v-.457h-.078v-.25h.144v-.066h-.066V7.59h.086v.031h.015v-.027H9.2v.031h.024v-.031h.09v.133h-.07v.062h.136V7.75h-.004v-.016h.004v-.187h-.082Zm.3.117v-.035h-.28v.035Zm-.28-.05h.28V7.43h-.054v.03H9.48v-.03h-.046v.03h-.059v-.03h-.059Zm.203.066h-.122v.008h.122Zm0 .023h-.063v.043h.063Zm0 .059h-.122v.043h.122Zm0 .059h-.063v.046h.063Zm0 .062h-.122v.04h.122Zm0 .055h-.122v.004h-.175v-.004H9.09v.004h-.145v.043h1.02v-.043h-.149v-.004h-.132v.004H9.52Zm.164-.016h.054v-.043h-.054Zm0-.059h.132v-.003h-.132Zm.203-.02v-.038H9.62v.039Zm-.266-.054h.266V7.61h-.051v.032h-.063v-.032h-.039v.032h-.07v-.032h-.043Zm.195.09h-.058v.043h.058Zm.149.121h-.063v.04h.063Zm0 .055h-.133v.047h.133Zm0 .062h-.063v.043h.063Zm-.082.043v-.043h-.125v.043Zm-.145 0v-.043H9.61v.043Zm-.148 0v-.043h-.133v.043Zm-.156 0v-.043h-.121v.043Zm-.141 0v-.043h-.129v.043Zm-.148 0v-.043H9.02v.043Zm-.122.016h.043v.043h-.043Zm0 .059v.043h.27v-.043Zm.29 0v.043h.12v-.043Zm.144 0v.043h.133v-.043Zm.152 0v.043h.278v-.043Zm.278-.016v-.043h-.051v.043Zm-.07 0v-.043H9.68v.043Zm-.157 0v-.043h-.125v.043Zm-.148 0v-.043h-.125v.043Zm-.149 0v-.043h-.12v.043Zm-.14 0v-.043h-.137v.043Zm.664.074h-.352v.043h.352Zm0 .059h-.43v.047h.43Zm0 .062h-.352v.047h.352Zm0 .063h-.133v.047h.133Zm0 .062h-.055v.043h.055Zm0 .059h-.133V8.5h.133Zm-.051.05v.051h.125v-.05Zm.144 0v.051h.06v-.05Zm.06.067h-.142v.043h.141Zm0 .059h-.06v.046h.06Zm0 .062h-.142v.043h.141Zm-.161.043v-.043h-.125v.043Zm-.145 0v-.043h-.566v.043Zm-.586 0v-.043H9.02v.043Zm-.148 0v-.043h-.133v.043Zm-.133-.059h.051v-.046h-.05Zm0-.062H9v-.043h-.133Zm0-.059h.055v-.05h-.055Zm.074-.05v.05h.125v-.05Zm.082-.016h.125v-.035h-.125Zm0-.05h.043v-.044h-.043Zm0-.06h.125v-.046h-.125Zm0-.062h.34v-.047h-.34Zm0-.062h.41v-.047h-.41Zm0-.063h.34V8.16h-.34Zm.364-.043v.043h.125V8.16Zm0 .121v.047h.125v-.047Zm-.219.063v.047h.125v-.047Zm.145 0v.047h.12v-.047Zm.144 0v.047h.133v-.047Zm.152 0v.047h.125v-.047Zm-.523.062v.043h.137v-.043Zm.156 0v.043h.121v-.043Zm.145 0v.043h.125v-.043Zm.148 0v.043h.125v-.043Zm.145 0v.043h.133v-.043Zm-.512.059V8.5h.125v-.035Zm.145 0V8.5h.277v-.035Zm.296 0V8.5h.125v-.035Zm-.523.05v.051h.137v-.05Zm.156 0v.051h.418v-.05Zm.438 0v.051h.136v-.05Zm-.66.067v.043h.128v-.043Zm.148 0v.043h.566v-.043Zm.586 0v.043h.125v-.043Zm-.816.059v.046h.128v-.046Zm.148 0v.046h.726v-.046Zm.746 0v.046h.129v-.046ZM9 8.027v-.043h-.055v.043Zm-.055-.058h.121v-.047h-.12Zm0-.063H9v-.039h-.055Zm.075-.039v.04h.27v-.04Zm.289 0v.04h.125v-.04Zm.148 0v.04h.133v-.04Zm.152 0v.04h.274v-.04Zm-.523.055v.047h.137v-.047Zm.156 0v.047h.13v-.047Zm.149 0v.047h.12v-.047Zm.144 0v.047h.125v-.047Zm.145 0v.047h.133v-.047Zm-.59-.133h.055v-.043H9.09Zm0-.059h.133v-.003H9.09Zm.203-.02v-.038h-.27v.039Zm-.27-.054h.27V7.61h-.05v.032H9.18v-.032h-.051v.012h.016l-.04.027v-.011H9.07v-.032h-.047Zm.2.09h-.059v.043h.059Zm.175-.012h.036v-.046h-.036Zm0-.12h.036V7.57h-.036Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.652 8.754v-.156c0-.032-.02-.121-.203-.121-.176 0-.191.093-.191.12v.157Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.277 8.523c.032-.03.082-.054.172-.054.094 0 .149.023.18.05a.1.1 0 0 1 .035.079v.164h-.418v-.164c0-.016.004-.047.031-.075m.016.008a.1.1 0 0 0-.027.067v.148h.379v-.148a.09.09 0 0 0-.032-.067c-.027-.023-.074-.047-.164-.047-.086 0-.129.024-.156.047m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.32 8.605-.093-.007c0-.032.007-.075.043-.09l.082.055c-.008.007-.032.027-.032.042m.266 0 .098-.007c0-.032-.012-.075-.043-.09l-.082.055c.004.007.027.027.027.042m-.102-.074.051-.066a1 1 0 0 0-.082-.016.3.3 0 0 0-.082.016l.05.066Zm-.18-.187v-.156c0-.043-.038-.083-.105-.083-.07 0-.105.04-.105.082v.165h.21Zm.301 0v-.156c0-.043.04-.083.106-.083s.105.04.105.082v.165h-.21Zm-.078-.399.02-.144h-.184l.008.144Zm.145 0-.02-.144h.196l-.02.144Zm-.438 0 .008-.144H9.06l.02.144Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.047 7.793h.207l-.008.16H9.07Zm.023.016.02.128h.137l.007-.128Zm.282-.016h.207l-.024.16h-.172Zm.023.016.008.128h.137l.015-.128Zm.27-.016h.214l-.023.16H9.66Zm.02.016.015.128h.136l.02-.128Zm-.552.316a.13.13 0 0 1 .086-.027c.07 0 .117.043.117.09v.171h-.234v-.171q.001-.037.031-.063m.016.012a.06.06 0 0 0-.027.05v.157h.195v-.156c0-.04-.04-.075-.098-.075q-.046 0-.07.024m.582-.024c-.059 0-.094.035-.094.075v.156h.192v-.156c0-.04-.04-.075-.098-.075m-.117.075c0-.047.047-.09.117-.09.074 0 .117.043.117.09v.171h-.234Zm-.184.257c.012 0 .031-.004.043-.004a1 1 0 0 1 .086.016l.012.004-.059.078h-.078l-.059-.078.012-.004zm-.023.024.039.054h.054l.04-.054a.2.2 0 0 0-.067-.012c-.012 0-.027.004-.039.004q-.017.004-.027.008m.254.031.007.004a.1.1 0 0 1 .036.039q.009.03.007.055v.007l-.117.008v-.008q-.001-.005-.008-.02-.007-.005-.007-.01h-.004c0-.005-.004-.009-.004-.009l-.004-.007Zm-.371 0 .097.063-.008.003-.015.02q-.012.013-.012.02v.007l-.113-.008v-.007c0-.016 0-.036.008-.051.007-.02.015-.035.035-.043Zm-.032.09.075.008q.005-.013.011-.02l.012-.015-.066-.043a.05.05 0 0 0-.024.03.1.1 0 0 0-.008.04m.403-.07-.067.043v.003q.004.006.008.012.006.007.012.02l.078-.008a.1.1 0 0 0-.008-.04c-.008-.015-.012-.023-.023-.03m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.586 8.754v-.137c0-.02-.02-.086-.137-.086q-.023-.001-.047.004c-.011.008-.027.012-.039.02a.1.1 0 0 0-.027.03l-.012.032v.137Zm-.3-.422v-.14c0-.04-.028-.075-.087-.075s-.09.035-.09.074v.141Zm.339 0v-.14c0-.04.027-.075.086-.075s.086.035.086.074v.141Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#0039f0",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.828 8.992c0-.324.305-.586.68-.586.37 0 .683.262.683.586s-.308.586-.683.586c-.38 0-.68-.262-.68-.586m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ad1519",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.508 8.414c-.367 0-.668.258-.668.578s.297.578.668.578c.367 0 .672-.258.672-.578s-.309-.578-.672-.578m-.695.578c0-.328.312-.594.695-.594.379 0 .695.266.695.594s-.308.594-.695.594-.695-.266-.695-.594m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.027 8.992c0-.238.22-.43.48-.43.266 0 .485.192.485.43 0 .235-.219.426-.48.426-.266 0-.485-.191-.485-.426m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#005bbf",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.508 8.57c-.254 0-.469.188-.469.422 0 .23.215.418.473.418.254 0 .468-.187.468-.418 0-.234-.214-.422-.472-.422m-.492.422c0-.242.222-.437.492-.437.273 0 .496.195.496.437 0 .238-.223.438-.492.438-.274 0-.496-.2-.496-.438m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.281 8.695s-.058.047-.058.094c0 .043.027.078.027.078a.04.04 0 0 0-.023-.02.06.06 0 0 0-.036-.011q-.01.002-.023.004c-.008.004-.016.004-.023.012-.004.003-.012.007-.012.015a.03.03 0 0 0-.008.016l.012.027.023.031q.011-.018.04-.02c.023 0 .042.017.042.032v.008h-.05v.031h.046l-.035.055.043-.012.04.031.034-.03.04.01-.028-.05h.04v-.035h-.048q-.006-.001 0-.008c0-.015.02-.031.04-.031.019 0 .042.008.042.02l.024-.032.008-.027c0-.024-.024-.047-.063-.047a.06.06 0 0 0-.055.031s.02-.035.02-.078c0-.047-.059-.094-.059-.094",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.285 8.691h.004q.001.004.008.008l.02.024a.1.1 0 0 1 .027.066.2.2 0 0 1-.008.055.07.07 0 0 1 .039-.012c.043 0 .07.023.07.05v.005l-.011.023-.024.031q-.001.005-.008.004l-.004-.004q0-.006-.007-.011c-.008 0-.016-.004-.028-.004q-.011.001-.023.008c-.008.007-.012.011-.012.02v.003h.043c.004 0 .008.004.008.004v.035q-.001.005-.008.004h-.031l.027.047-.004.004h-.008l-.035-.012-.03.031h-.009l-.039-.03-.035.01h-.008c0-.003-.004-.003 0-.007L10.227 9h-.036a.01.01 0 0 1-.007-.008v-.031s.004-.004.007-.004h.043v-.004c0-.012-.015-.027-.035-.027-.008 0-.015.004-.02.004l-.015.011q-.002.005-.004.004-.004.001-.008-.004l-.02-.03-.01-.024v-.004q0-.007.003-.02a.03.03 0 0 1 .016-.015l.023-.012c.008-.004.02-.004.027-.004q.023.001.04.008a.1.1 0 0 1-.012-.05c0-.024.015-.048.027-.067q.012-.013.024-.02.002-.004.003-.008h.004q-.001-.004.004-.008s.004 0 .004.004m0 .012c-.004 0-.004.004-.008.004l-.02.02c-.015.02-.027.039-.027.062 0 .02.008.04.012.055q.007.01.008.015.005.004.004.008c.004.004 0 .004-.004.008q-.001.001-.008-.004v-.004l-.004-.004q-.005-.006-.015-.011c-.008-.008-.02-.008-.032-.008-.007-.004-.015 0-.023 0l-.02.008q-.005.01-.011.015c-.004.004-.004.012-.004.016l.012.023.015.024q.006-.004.012-.008.01-.005.027-.004c.028 0 .047.016.047.035v.008q.001.007-.004.008H10.2v.02h.04q.002 0 .003.003v.004l-.027.043.027-.008h.008l.035.028.027-.028c.004 0 .008-.004.008 0l.028.008L10.324 9v-.004q.004-.005.008-.004h.035V8.97h-.043c-.004 0-.008-.004-.008-.004v-.012c0-.008.008-.02.016-.023a.04.04 0 0 1 .031-.012q.019-.001.032.004.005.004.011.008l.016-.024.008-.023c0-.02-.02-.04-.055-.04q-.035 0-.047.024h-.004v.004s-.004.004-.008.004q-.005-.004-.004-.008s0-.004.004-.004V8.86q.001-.005.008-.015a.2.2 0 0 0 .008-.055c0-.023-.012-.043-.027-.062q-.01-.013-.02-.02zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.191 8.996h.184v-.035h-.184Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.184 8.957h.199V9h-.2Zm.015.012v.023h.172V8.97Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.73 8.695s-.058.047-.058.094c0 .043.023.078.023.078-.008-.015-.03-.031-.058-.031-.035 0-.063.023-.063.047l.012.027.02.031q.006-.018.042-.02.014.002.028.009.012.011.011.023v.008h-.05v.031h.047l-.032.055.04-.012.038.031.036-.03.043.01-.036-.05h.047v-.035h-.05v-.008c0-.015.02-.031.043-.031.019 0 .035.008.039.02l.023-.032.008-.027c0-.024-.028-.047-.059-.047s-.054.016-.062.031c0 0 .023-.035.023-.078 0-.047-.055-.094-.055-.094",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.734 8.691.008.008q.01.006.02.024a.1.1 0 0 1 .031.066c0 .02-.008.04-.012.055a.1.1 0 0 1 .043-.012c.035 0 .067.023.067.05v.005l-.008.023-.028.031q-.002.005-.003.004-.005.001-.004-.004c-.004-.007-.016-.015-.036-.015q-.016.001-.027.008c-.004.007-.008.011-.008.02v.003h.043c.004 0 .004.004.004.004v.035q.001.005-.004.004h-.035l.027.043v.008h-.007l-.04-.012-.03.031h-.012l-.032-.03-.039.01h-.007v-.007l.03-.043h-.038s-.004-.004-.004-.008v-.031l.004-.004h.047v-.004a.02.02 0 0 0-.012-.02q-.012-.006-.024-.007c-.02 0-.035.008-.035.015q-.004.005-.008.004-.002.001-.003-.004l-.024-.03-.012-.024v-.004c0-.028.032-.051.07-.051q.023 0 .04.012c-.004-.016-.012-.035-.012-.055 0-.023.016-.047.031-.066l.02-.02.008-.008q-.001-.004.004-.008.003-.001.007.004m-.004.012-.003.004a.05.05 0 0 0-.02.02c-.016.02-.031.039-.031.062 0 .02.008.04.015.055 0 .008.004.011.004.015l.008.008q.001.004-.004.008c-.004 0-.008-.004-.008-.004l-.004-.004v-.004a.07.07 0 0 0-.05-.02c-.032 0-.059.02-.059.04l.012.023.015.024q.013-.012.043-.012.019.001.032.008c.008.008.015.02.015.027v.012s-.004.004-.008.004h-.042v.02h.039q.005 0 .004.003.005.002 0 .004l-.024.043.027-.008c0-.004.004 0 .004 0l.035.028.032-.028s.004-.004.008 0l.023.008L10.77 9c-.004-.004 0-.004 0-.004q.002-.005.003-.004h.04V8.97h-.043c-.004 0-.004-.004-.004-.004q-.006-.006 0-.012c0-.008.004-.02.011-.023q.012-.012.036-.012t.039.012l.02-.024.007-.023c0-.02-.027-.04-.055-.04-.023 0-.043.009-.05.02h-.004v.004q.001.005-.004.004s-.004.004-.008.004q-.002-.004-.004-.008l.008-.008q.001-.005.008-.015c.003-.016.011-.035.011-.055 0-.023-.015-.043-.027-.062l-.02-.02zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.637 8.996h.187v-.035h-.187Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.633 8.957h.195V9h-.195Zm.012.012v.023h.171V8.97Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.504 8.988s-.055.047-.055.094c0 .043.024.082.024.082a.04.04 0 0 0-.024-.023c-.008-.008-.023-.012-.035-.008a.1.1 0 0 0-.043.012c-.012.007-.02.02-.02.03l.008.024.02.031a.07.07 0 0 1 .043-.015c.023 0 .043.012.043.031q.006.006 0 .012h-.047v.031h.039l-.031.05.043-.015.039.031.031-.03.047.015-.035-.05h.047v-.032h-.051v-.012c0-.02.02-.031.043-.031.02 0 .035.008.039.015l.023-.03c.004-.005.012-.016.012-.024 0-.028-.031-.043-.066-.043q-.018-.002-.036.008a.04.04 0 0 0-.023.023s.027-.039.027-.086c0-.043-.058-.09-.058-.09",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.984h.012s.004 0 .004.004c0 0 .004 0 .004.004a.1.1 0 0 1 .023.024c.012.015.027.039.027.062a.13.13 0 0 1-.011.059.1.1 0 0 1 .039-.012c.039 0 .07.023.07.05q.001.009-.004.016-.002.004-.004.008c-.004 0-.004.004-.004.004l-.02.031h-.011q0-.006-.012-.011c-.008 0-.015-.004-.023-.004a.1.1 0 0 0-.027.008.03.03 0 0 0-.008.02v.003h.043q.007.001.007.008v.031s-.003.004-.007.004h-.036l.028.047c.004 0 0 .004 0 .004s-.004.004-.008 0l-.039-.012-.031.027h-.008l-.035-.027-.04.012c-.003.004-.007 0-.007 0-.004 0-.004-.004-.004-.004l.031-.047h-.031c-.004 0-.008-.004-.008-.004v-.031q.001-.007.008-.008h.043v-.004c0-.016-.02-.027-.04-.027-.015 0-.03.008-.034.015h-.012l-.02-.03v-.005l-.011-.023a.06.06 0 0 1 .023-.035.1.1 0 0 1 .047-.016q.02 0 .04.012a.2.2 0 0 1-.009-.055c0-.027.012-.05.028-.066q.008-.018.015-.024.007-.005.008-.004v-.004Zm.004.008q.001.004-.004.008l-.02.02a.1.1 0 0 0-.023.062q0 .031.012.055.004.01.008.015.001.007.003.008 0 .004-.003.008-.007.001-.008-.004c0-.004-.004-.004-.004-.008q-.007-.006-.02-.011-.013-.01-.03-.008a.07.07 0 0 0-.04.011q-.017.011-.016.028l.008.023.016.024q.013-.012.039-.012c.027 0 .05.016.05.035v.012s-.003.004-.007.004h-.043v.02h.035q.004.002.008.003v.004l-.027.043.03-.012h.009l.03.028.028-.028h.008l.031.012-.027-.043v-.004l.004-.004h.039v-.02h-.043l-.004-.003v-.012q0-.018.012-.023.012-.012.035-.012.017-.001.027.004.006.004.012.008l.016-.024q.002-.005.003-.004.002-.007.004-.008.005-.005.004-.011c0-.024-.023-.04-.058-.04a.1.1 0 0 0-.032.009q-.01.005-.015.011-.005.004-.004.008-.007.005-.008.004-.005-.004-.004-.008s0-.004.004-.008q.001-.005.008-.015c.004-.016.012-.035.012-.059a.1.1 0 0 0-.028-.058l-.02-.02zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.414 9.29h.184v-.032h-.184Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.406 9.25h.2v.043h-.2Zm.012.012v.02h.172v-.02Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.875 7.445h-.016c0 .008-.007.012-.011.016-.012.004-.028.008-.036 0q-.004-.004-.003-.008v-.008q-.006.005-.012.004-.006.001-.012-.004c-.012 0-.015-.015-.008-.023l.004-.008v-.008h-.011l-.004.008q-.019.014-.032.004c-.004 0-.004-.004-.004-.004h-.007c-.024.004-.032-.031-.036-.043l-.003.012v.039a.1.1 0 0 1-.012.039.4.4 0 0 1 .125.05q.06.034.101.079l.047-.02c.028-.004.059-.004.059-.004l.008-.007c-.012 0-.067.003-.067-.012l.004-.008q-.006.006-.011 0c-.008-.004-.008-.016 0-.023h.007v-.012h-.011l-.008.004c-.012.008-.028.008-.035 0-.004-.004-.004-.004-.004-.008q-.001-.004.004-.008-.006.005-.012.004-.011.001-.016-.004l-.004-.004q-.005-.007-.004-.008-.001-.006.004-.007c0-.004.004-.004.004-.008q.006-.004.012-.008Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.688 7.355.007.016v.008q.005-.001.004.004c0 .004.004.008.004.012l.008.011c.004 0 .004.004.004.004s.004 0 .004-.004h.015v.004c0 .004.004.004.004.004q.004.005.008.004l.016-.004.004-.012h.023v.016l-.004.008c-.008.008-.004.015.004.015q.004.005.008.004.004.001.008-.004l.011-.003-.004.011v.004l.004.004q.006.005.012.004l.016-.004.011-.012v-.004h.024v.02a.01.01 0 0 0-.008.008h-.004s0 .004-.004.004v.011l.004.004q.006.005.012.004.001.001.008-.004l.015-.004-.007.012v.008q.005.005.011.004c.004 0 .012 0 .016-.004l.012-.004h.02v.02h-.013q-.006.01 0 .015h.02l-.008.012q-.001.005.004.004.007.005.02.004h.05l-.02.015h-.023q-.017.001-.035.008l-.054.02v-.004a.3.3 0 0 0-.102-.078.3.3 0 0 0-.121-.051l-.008-.004.004-.004.012-.035v-.043Zm.28.207c-.003 0-.011 0-.015-.003q-.012 0-.012-.012h-.004v-.004h-.003c-.012-.008-.008-.02 0-.031h.007v-.004h-.004l-.007.004q-.012.007-.024.008-.012 0-.023-.012V7.5h-.004q-.011.001-.016-.004h-.004l-.007-.008V7.47q.003-.001.007-.008.004-.001.008-.008h-.004q-.006.007-.011.008v.004q-.012.002-.024.004t-.02-.008q-.003-.001-.007-.008h-.004q-.006.001-.012-.004c-.015-.004-.02-.02-.012-.031l.004-.004V7.41h-.004v.008h-.003q-.01.007-.02.008-.013.001-.02-.004c-.003 0-.003-.004-.003-.004h-.016s-.004-.004-.008-.004q-.006-.005-.012-.016v-.003.027l-.011.035a.4.4 0 0 1 .12.05.4.4 0 0 1 .098.079l.047-.02zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.773 7.469h.012s.008.008 0 .008h-.008v-.008",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.777 7.469h-.004.016v.004s.004 0 0 0v.004h-.012Zm.008 0h-.004v.004h.004zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.816 7.492-.011-.004V7.48h.008l.011.012.012.004s.004.004 0 .008h-.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8 7.48h.012l.024.016h.004V7.5q.001.005-.004.004h-.004l-.031-.016Zm.036.02h-.004l-.016-.008-.011-.004v-.004h.008Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.746 7.457-.012-.008s-.004 0 0-.004h.004l.012.004.012.012h-.008Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.734 7.445h.004l.012.004.012.008.004.004h-.012l-.008-.004-.012-.004q-.005.001-.004-.004v-.004Zm0 .004.012.004.008.004h.004l-.008-.004-.012-.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7 7.434h.01l.005.007h-.012Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7 7.434h.01l.005.007h-.012Zm.003.003h.008Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.86 7.52v-.012h-.012v.012Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.848 7.508h.015v.012h-.015Zm.004.004v.004h.007v-.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.887 7.54.008.003c0 .004.007.004.007 0l-.015-.016h-.008v.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.875 7.527h.012l.015.016v.004h-.007s-.004 0-.004-.004l-.008-.004-.008-.008Zm.004.004.008.004.008.008h.003l-.007-.008-.008-.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.926 7.563v-.008h-.012v.011h.012",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.91 7.555h.02v.011h-.02Zm.008.004v.003h.008V7.56Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.813 7.371h-.028l-.008.027.004.004h.012l.027-.015Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.781 7.367h.035l.012.024-.035.015h-.012l-.008-.004Zm.012.008-.008.023h.004l.024-.011-.004-.012Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.742 7.387v.015l.04.008v-.012l-.02-.02Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.766 7.371.023.027v.016l-.055-.008v-.02Zm-.016.02v.007l.027.004-.015-.02Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.824 7.422-.02.008-.027-.024v-.004h.047Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.773 7.398h.059v.028l-.031.011-.028-.03Zm.043.008h-.027l.016.02.011-.008Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.773 7.398h.008s.004-.003.004 0q.007-.001.008.004v.008h-.016l-.004-.004q-.004-.004-.003-.008",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.785 7.402h-.008c0 .004.004.004.004.004h.004zm-.008-.007q.006-.005.012-.004v.004q.007 0 .008.007.006.007 0 .008v.004h-.02q-.007-.002-.007-.004-.005-.006-.004-.012v-.003h.011m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.684 7.371-.012-.023-.016-.012s.016-.008.035 0c.02.012 0 .031 0 .031Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.656 7.328-.008-.004v.012h.004v.004a.03.03 0 0 1 .016.008l.016.03.015-.01h-.008.008v-.005q.005-.001.004-.008c.004-.003.004-.015-.008-.023q-.016-.005-.027-.004zm.031.035s0-.004.004-.004v-.004q.007-.01-.004-.015-.009-.005-.019-.004c.004.004.008.004.008.008Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.727 7.383-.016.012-.031-.02v-.008h.043Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.676 7.36h.05l.004.023-.02.015-.034-.02Zm.011.011.02.016.012-.008-.004-.008Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.676 7.367.011-.004c.004 0 .008.004.004.008 0 .008-.007.012-.011.012 0 0-.004-.008 0-.016",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.688 7.36h.007q.005.002.004.003c0 .004.004.008 0 .012q-.001.004-.008.008c-.004 0-.007.004-.011.004h-.004v-.004h.004-.004q-.005-.002-.004-.004v-.004h-.016Zm0 .007v.004q-.005.002-.004.004.005.001.004-.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.906 7.414h-.023l-.016.027v.004h.012l.035-.011Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.879 7.41h.031l.012.027-.043.016h-.016v-.012Zm.008.012-.012.02.031-.008-.004-.012Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.836 7.426-.004.02.035.003h.008v-.004l-.02-.027Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.86 7.414.019.027v.012h-.012l-.043-.004.008-.027Zm-.016.016-.004.011.027.004-.012-.02Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.91 7.469-.023.008-.02-.028v-.004h.008l.04.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.863 7.438h.012l.047.007-.008.028-.031.007-.02-.03Zm.012.011.012.02.02-.004v-.012Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.86 7.441c.003-.003.015-.003.019 0l.004.004v.008c-.004 0-.008.004-.008.004q-.006-.002-.012-.004v-.012",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.871 7.441v.004h-.004q-.001.005.004.004h.004v-.004h-.004zm-.016.004h-.007l.007-.008q.006-.004.012-.003.011 0 .016.003.005.001.004.008.006.006 0 .012c-.004 0-.008.004-.012.004-.008 0-.012-.004-.016-.004q-.005-.006-.004-.012m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.988 7.477.004.015-.035.012h-.008v-.008l.016-.023Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.96 7.465.032.008.008.023-.043.012h-.012v-.012Zm.009.012-.012.02.027-.005V7.48Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.98 7.523-.02.008-.015-.027V7.5h.012l.031.008-.004.015",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.941 7.496h.016l.04.012-.009.02-.008-.005v.008l-.023.008-.016-.035Zm.036.027.003-.011-.027-.008.012.02.012-.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.918 7.477-.008.015.035.012h.004V7.5l-.008-.027Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.95 7.465.007.035v.008h-.012l-.043-.012.012-.023Zm-.028.015-.004.012.027.004-.008-.02Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.96 7.508v-.012q-.003.001-.007-.004h-.012q.001.005-.004.004v.012h.02",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.941 7.488h.016q.004.005.008.004.005.006.004.012.001.007-.004.008l-.004.004-.008-.004h-.008q-.006.001-.011-.004s-.004-.004-.004-.008l.004-.004q.001-.004.007-.008m.012.012v-.004h-.008V7.5h-.004c0 .004.004.004.004.004h.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.016 7.566.035.004c.008 0 .011.004.02.008 0 0 .003-.016-.012-.023-.016-.012-.04.004-.04.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.031 7.547c.008 0 .02-.004.031.004a.02.02 0 0 1 .012.02q.005.001.004.003v.004h-.008.004v.008l-.008-.004a.03.03 0 0 0-.02-.008l-.038-.004.008-.015.004.004-.004-.004h.004q.005-.004.011-.008m-.004.016h.024q.006.003.011.007c0-.004-.003-.011-.007-.011q-.01-.006-.02 0-.004 0-.008.003m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.992 7.54-.012.015.032.015v-.004h.008l-.004-.03h-.024",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.992 7.531h.031l.004.04h-.007v.007l-.047-.023.015-.02.004.004Zm.004.008-.008.012.02.011h.008l-.004-.023Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.02 7.57s.007-.008.003-.011h-.015c-.004 0-.008.007-.004.011h.012",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c8b100",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.61 6.754h.042v.016h.024v.027h-.024v.035h.036v.004h.007v.023h-.12v-.027h.038v-.035h-.027V6.77h.023Zm.074.09h-.043v-.055h.023v-.008h-.023v-.015h-.02v.015h-.023v.008h.027v.055h-.04v.008h.099ZM12 7.559q.004-.005.008-.004h.023v.011l-.004.004h-.004v.004H12V7.57c-.004 0-.004-.008-.004-.008zM7.285 7.195v.04h-.004v-.04Zm.008 0v.04h-.004v-.04Zm.012 0v.043H7.3v-.043Zm-.082.004v.031h-.004V7.2Zm.015 0v.031H7.23V7.2Zm.008 0v.031h-.004V7.2Zm.008 0v.031H7.25V7.2Zm.012 0v.035h-.004V7.2Zm.007 0v.031H7.27V7.2Zm-.066.004v.024h-.004v-.024Zm.008 0v.024H7.21v-.024Zm-.04.004v.02h-.003v-.02Zm.009 0v.02H7.18v-.02Zm.011 0v.02h-.004v-.02Zm-.039.004v.008h-.008V7.21Zm.012 0v.012h-.004V7.21Zm-.027 0v.008h-.004V7.21ZM7.137 7.215v.004h-.008v-.004ZM13.543 7.195v.04h-.004v-.04Zm.027 0v.04h-.004v-.04Zm.012 0v.043h-.004v-.043ZM13.5 7.2v.031h-.004V7.2Zm.008 0v.031h-.004V7.2Zm.008 0v.031h-.004V7.2Zm.011 0v.031h-.004V7.2Zm.008 0v.035h-.004V7.2Zm.024 0v.035h-.004V7.2Zm-.079.004v.024h-.003v-.024Zm.008 0v.027h-.004v-.027Zm-.031.004v.02h-.004v-.02Zm.008 0v.02h-.004v-.02Zm-.04.004v.012h-.003V7.21Zm.012 0v.016h-.003V7.21Zm.008 0v.016h-.004V7.21Zm-.027 0v.008h-.004V7.21ZM13.406 7.215v.004h-.008v-.004Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSpain);
export default __webpack_public_path__ + "static/media/ic-spain.a77bafb62920e178f9a1357c0bb58e4e.svg";
export { ForwardRef as ReactComponent };